/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A special custom Scalar type for Dates that converts to a ISO formatted string  */
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  /** The `JSON` scalar type represents raw JSON as values. */
  SequelizeJSON: { input: any; output: any; }
};

export type Achievement = {
  __typename?: 'Achievement';
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AchievementLevel = {
  __typename?: 'AchievementLevel';
  CampaignId?: Maybe<Scalars['String']['output']>;
  achievement?: Maybe<Achievement>;
  achievementCode: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  fundraiserAchievements?: Maybe<Array<Maybe<FundraiserAchievement>>>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  value: Scalars['Int']['output'];
};


export type AchievementLevelFundraiserAchievementsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type AchievementLevelInput = {
  CampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  achievementCode?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fundraiserAchievements?: InputMaybe<Array<InputMaybe<FundraiserAchievementInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityMetric = {
  __typename?: 'ActivityMetric';
  AssignedActivityMetric?: Maybe<AssignedActivityMetric>;
  assignedCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']['output']>;
  category: ActivityMetriccategoryEnumType;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  plural: Scalars['String']['output'];
  singular: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type ActivityMetricAssignedCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type ActivityMetricInput = {
  AssignedActivityMetric?: InputMaybe<AssignedActivityMetricInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  assignedCampaigns?: InputMaybe<Array<InputMaybe<CampaignInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  plural?: InputMaybe<Scalars['String']['input']>;
  singular?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum ActivityMetriccategoryEnumType {
  Activity = 'activity',
  Custom = 'custom',
  Distance = 'distance',
  Fitness = 'fitness',
  Sports = 'sports'
}

export type AddFundraiserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  monetaryGoal: Scalars['Int']['input'];
  participantId: Scalars['String']['input'];
  performanceEstimate?: InputMaybe<Scalars['Int']['input']>;
  unlockedActivityMetricId?: InputMaybe<Scalars['String']['input']>;
};

export type AddOn = {
  __typename?: 'AddOn';
  amount: Scalars['String']['output'];
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  registrationType?: Maybe<RegistrationType>;
  registrationTypeId: Scalars['String']['output'];
  status: AddOnstatusEnumType;
  updatedAt: Scalars['Date']['output'];
};


export type AddOnAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type AddOnInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  answers?: InputMaybe<Array<InputMaybe<QuestionAnswerInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AddOnstatusEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum AddOnstatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  Pending = 'pending'
}

export type AdminInvite = {
  __typename?: 'AdminInvite';
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isExpired: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  resourceType: AdminInviteResourceTypeEnum;
  roleCode: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum AdminInviteResourceTypeEnum {
  Campaign = 'Campaign',
  Organization = 'Organization'
}

export enum AdminInviteStatusEnum {
  Accepted = 'accepted',
  Invalidated = 'invalidated',
  Pending = 'pending'
}

export type AssignedActivityMetric = {
  __typename?: 'AssignedActivityMetric';
  activityMetricId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AssignedActivityMetricInput = {
  activityMetricId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type Auction = {
  __typename?: 'Auction';
  bidderCount: Scalars['Int']['output'];
  bidders?: Maybe<Array<Maybe<AuctionBidder>>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  canBidderCoverPlatformFee: Scalars['Boolean']['output'];
  canBidderCoverProcessorFee: Scalars['Boolean']['output'];
  categories?: Maybe<Array<Maybe<AuctionCategory>>>;
  collectAddress: Scalars['Boolean']['output'];
  contactEmail: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  endDate: Scalars['Date']['output'];
  estimatedAmountRaised: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<AuctionItem>>>;
  myBidder?: Maybe<AuctionBidder>;
  startDate: Scalars['Date']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  welcomeMessage?: Maybe<Scalars['SequelizeJSON']['output']>;
};


export type AuctionBiddersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AuctionCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AuctionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type AuctionBid = {
  __typename?: 'AuctionBid';
  bid: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  highBid?: Maybe<Scalars['String']['output']>;
  highBidUpdated: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  itemBidder?: Maybe<AuctionItemBidder>;
  itemBidderId?: Maybe<Scalars['Int']['output']>;
  result: AuctionBidresultEnumType;
  type: AuctionBidtypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type AuctionBidder = {
  __typename?: 'AuctionBidder';
  AuctionItemBidder?: Maybe<AuctionItemBidder>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  auction?: Maybe<Auction>;
  auctionId: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  charge: PayableCharge;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  didCoverFee?: Maybe<Scalars['Boolean']['output']>;
  didCoverPlatformFee: Scalars['Boolean']['output'];
  didCoverProcessorFee: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isCoveringFees: Scalars['Boolean']['output'];
  isSmsEnabled: Scalars['Boolean']['output'];
  itemBidders?: Maybe<Array<Maybe<AuctionItemBidder>>>;
  items?: Maybe<Array<Maybe<AuctionItem>>>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodExpMonth?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpYear?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpiration?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  paymentProcessorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  paymentProcessorType?: Maybe<AuctionBidderpaymentProcessorTypeEnumType>;
  paymentSourceData?: Maybe<Scalars['SequelizeJSON']['output']>;
  paymentSourceKey?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  platformFeePercent: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  processorFeePercent: Scalars['String']['output'];
  stateProv?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};


export type AuctionBidderItemBiddersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AuctionBidderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type AuctionBidderInput = {
  AuctionItemBidder?: InputMaybe<AuctionItemBidderInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  auctionId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  didCoverFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCoveringFees?: InputMaybe<Scalars['Boolean']['input']>;
  isSmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemBidders?: InputMaybe<Array<InputMaybe<AuctionItemBidderInput>>>;
  items?: InputMaybe<Array<InputMaybe<AuctionItemInput>>>;
  paymentMethodBrand?: InputMaybe<Scalars['String']['input']>;
  paymentMethodExpMonth?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpYear?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  paymentProcessorData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  paymentProcessorType?: InputMaybe<AuctionBidderpaymentProcessorTypeEnumType>;
  paymentSourceData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  paymentSourceKey?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFeePercent?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorFeePercent?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type AuctionBidderResult = PayableResult & {
  __typename?: 'AuctionBidderResult';
  auctionBidderId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum AuctionBidderpaymentProcessorTypeEnumType {
  Stripe = 'stripe'
}

export enum AuctionBidresultEnumType {
  Outbid = 'outbid',
  Rejected = 'rejected',
  Winning = 'winning'
}

export enum AuctionBidtypeEnumType {
  Automatic = 'automatic',
  Maximum = 'maximum',
  Single = 'single'
}

export type AuctionCategory = {
  __typename?: 'AuctionCategory';
  auction?: Maybe<Auction>;
  auctionId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  items?: Maybe<Array<Maybe<AuctionItem>>>;
  name: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type AuctionCategoryItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type AuctionCategoryInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  auctionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<AuctionItemInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type AuctionInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  bidders?: InputMaybe<Array<InputMaybe<AuctionBidderInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  canBidderCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  canBidderCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<InputMaybe<AuctionCategoryInput>>>;
  collectAddress?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<AuctionItemInput>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  welcomeMessage?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type AuctionItem = {
  __typename?: 'AuctionItem';
  amount: Scalars['Int']['output'];
  auction?: Maybe<Auction>;
  auctionCategoryId?: Maybe<Scalars['String']['output']>;
  auctionId: Scalars['String']['output'];
  bidHistory: Array<Maybe<AuctionBid>>;
  bidIncrement: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  category?: Maybe<AuctionCategory>;
  categoryId?: Maybe<Scalars['String']['output']>;
  coveredFees: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['SequelizeJSON']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Date']['output'];
  estimatedValue?: Maybe<Scalars['Int']['output']>;
  hasCustomDates: Scalars['Boolean']['output'];
  highBid: Scalars['String']['output'];
  id: Scalars['String']['output'];
  images?: Maybe<Array<Maybe<AuctionItemImage>>>;
  isFeatured: Scalars['Boolean']['output'];
  isFulfilled: Scalars['Boolean']['output'];
  isProcessing: Scalars['Boolean']['output'];
  myBid?: Maybe<MyAuctionItemBid>;
  name: Scalars['String']['output'];
  numBids: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  startingBid: Scalars['String']['output'];
  status?: Maybe<AuctionItemStatusEnum>;
  updatedAt: Scalars['Date']['output'];
  winningAuctionItemBidderId?: Maybe<Scalars['Int']['output']>;
  winningItemBidder?: Maybe<AuctionItemBidder>;
};


export type AuctionItemImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type AuctionItemBidder = {
  __typename?: 'AuctionItemBidder';
  auctionBidderId: Scalars['String']['output'];
  auctionItemId: Scalars['String']['output'];
  bid?: Maybe<Scalars['String']['output']>;
  bidder?: Maybe<AuctionBidder>;
  createdAt: Scalars['Date']['output'];
  highBid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  item?: Maybe<AuctionItem>;
  type?: Maybe<AuctionItemBiddertypeEnumType>;
  updatedAt: Scalars['Date']['output'];
};

export type AuctionItemBidderInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  auctionBidderId?: InputMaybe<Scalars['String']['input']>;
  auctionItemId?: InputMaybe<Scalars['String']['input']>;
  bid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  highBid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<AuctionItemBiddertypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum AuctionItemBiddertypeEnumType {
  Maximum = 'maximum',
  Single = 'single'
}

export type AuctionItemImage = {
  __typename?: 'AuctionItemImage';
  auctionItem?: Maybe<AuctionItem>;
  auctionItemId?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  original: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AuctionItemImageInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  auctionItemId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  original?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type AuctionItemInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  auctionCategoryId?: InputMaybe<Scalars['String']['input']>;
  auctionId?: InputMaybe<Scalars['String']['input']>;
  bidIncrement?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  coveredFees?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  estimatedValue?: InputMaybe<Scalars['Int']['input']>;
  hasCustomDates?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<AuctionItemImageInput>>>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startingBid?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  winningAuctionItemBidderId?: InputMaybe<Scalars['Int']['input']>;
};

export enum AuctionItemStatusEnum {
  Active = 'active',
  Cancelled = 'cancelled',
  ChargeFailed = 'chargeFailed',
  Ended = 'ended',
  Fulfilled = 'fulfilled',
  Paid = 'paid',
  Scheduled = 'scheduled'
}

export type AuctionPreviewCampaignWidget = CampaignWidget & {
  __typename?: 'AuctionPreviewCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type AwardedAchievement = {
  __typename?: 'AwardedAchievement';
  achievedAt?: Maybe<Scalars['Date']['output']>;
  achievementCode: Scalars['String']['output'];
  fundraiserAchievementId?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type BidResult = {
  __typename?: 'BidResult';
  highBid: Scalars['String']['output'];
  result: AuctionBidresultEnumType;
};

export type BidderSearchResult = SearchResult & {
  __typename?: 'BidderSearchResult';
  avatarImage?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export type CalculateOrderAmountMiscItem = {
  __typename?: 'CalculateOrderAmountMiscItem';
  amount: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CalculateOrderAmountNeed = {
  __typename?: 'CalculateOrderAmountNeed';
  amount: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CalculateOrderAmountProduct = {
  __typename?: 'CalculateOrderAmountProduct';
  amount: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CalculateOrderAmountRaffle = {
  __typename?: 'CalculateOrderAmountRaffle';
  amount: Scalars['String']['output'];
  entries: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CalculateOrderAmountResult = {
  __typename?: 'CalculateOrderAmountResult';
  amount: Scalars['String']['output'];
  discount: Scalars['String']['output'];
  discountedSubtotal: Scalars['String']['output'];
  donation: Scalars['String']['output'];
  fees: Scalars['String']['output'];
  miscItems?: Maybe<Array<Maybe<CalculateOrderAmountMiscItem>>>;
  needs?: Maybe<Array<Maybe<CalculateOrderAmountNeed>>>;
  products?: Maybe<Array<Maybe<CalculateOrderAmountProduct>>>;
  raffle?: Maybe<Array<Maybe<CalculateOrderAmountRaffle>>>;
  subtotal: Scalars['String']['output'];
  ticketBundles?: Maybe<Array<Maybe<CalculateOrderAmountTicketBundle>>>;
  tickets?: Maybe<Array<Maybe<CalculateOrderAmountTicket>>>;
  wonLiveAuctionItems?: Maybe<Array<Maybe<CalculateOrderAmountWonLiveAuctionItem>>>;
};

export type CalculateOrderAmountTicket = {
  __typename?: 'CalculateOrderAmountTicket';
  amount: Scalars['String']['output'];
  discountText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalAmount: Scalars['String']['output'];
  registrationTypeId: Scalars['String']['output'];
};

export type CalculateOrderAmountTicketBundle = {
  __typename?: 'CalculateOrderAmountTicketBundle';
  amount: Scalars['String']['output'];
  bundleOptionId: Scalars['String']['output'];
  discountText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalAmount: Scalars['String']['output'];
  tickets?: Maybe<Array<Maybe<CalculateOrderAmountTicket>>>;
};

export type CalculateOrderAmountWonLiveAuctionItem = {
  __typename?: 'CalculateOrderAmountWonLiveAuctionItem';
  amount: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CalculateOrderInput = {
  campaignId: Scalars['String']['input'];
  coverFee: Scalars['Boolean']['input'];
  discountCode?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<CreateOrderDonationInput>;
  miscItems?: InputMaybe<Array<CalculateOrderMiscItemInput>>;
  needs?: InputMaybe<Array<InputMaybe<CreateOrderNeedInput>>>;
  products?: InputMaybe<Array<CalculateOrderProductInput>>;
  raffle?: InputMaybe<Array<CalculateOrderRaffleItemInput>>;
  ticketBundles?: InputMaybe<Array<CalculateOrderTicketBundleInput>>;
  tickets: Array<CalculateOrderTicketInput>;
  wonLiveAuctionItems?: InputMaybe<Array<CalculateOrderWonLiveAuctionItemInput>>;
};

export type CalculateOrderMiscItemInput = {
  amount: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CalculateOrderProductInput = {
  productId: Scalars['String']['input'];
};

export type CalculateOrderRaffleItemInput = {
  entries: Scalars['Int']['input'];
  raffleId: Scalars['String']['input'];
};

export type CalculateOrderTicketBundleInput = {
  bundleOptionId: Scalars['String']['input'];
  includedTicketQuantity: Scalars['Int']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  tickets?: InputMaybe<Array<InputMaybe<CalculateOrderTicketInput>>>;
};

export type CalculateOrderTicketInput = {
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CalculateOrderWonLiveAuctionItemInput = {
  amount: Scalars['String']['input'];
  liveAuctionItemId: Scalars['String']['input'];
};

export type CalculateRaffleOrderInput = {
  campaignId: Scalars['String']['input'];
  coverFee: Scalars['Boolean']['input'];
  items: Array<CalculateRaffleOrderItemInput>;
};

export type CalculateRaffleOrderItem = {
  __typename?: 'CalculateRaffleOrderItem';
  amount: Scalars['String']['output'];
  entries: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CalculateRaffleOrderItemInput = {
  entries: Scalars['Int']['input'];
  raffleId: Scalars['String']['input'];
};

export type CalculateRaffleOrderResult = {
  __typename?: 'CalculateRaffleOrderResult';
  coveredFeeAmount: Scalars['String']['output'];
  items: Array<CalculateRaffleOrderItem>;
  raffleAmount: Scalars['String']['output'];
  totalAmount: Scalars['String']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  AssignedActivityMetric?: Maybe<AssignedActivityMetric>;
  accentColor: Scalars['String']['output'];
  achievementLevels?: Maybe<Array<Maybe<AchievementLevel>>>;
  activeFeatures: CampaignFeatures;
  addOns?: Maybe<Array<Maybe<AddOn>>>;
  amountRaised: Scalars['String']['output'];
  assignedActivityMetrics?: Maybe<Array<Maybe<ActivityMetric>>>;
  auction?: Maybe<Auction>;
  availableActivityMetrics: Array<Maybe<ActivityMetric>>;
  /** Custom label for donate button on Campaign Landing Page - defaults to Donate */
  campaignDonateButtonLabel: Scalars['String']['output'];
  /** Header hero image for Campaign Landing Page */
  campaignHeaderBackgroundImage?: Maybe<Scalars['String']['output']>;
  /** Headline to be displayed instead of campaign name on Campaign Landing Page */
  campaignHeadline?: Maybe<Scalars['String']['output']>;
  /** Custom label for join button on Campaign Landing Page - defaults to Join */
  campaignJoinButtonLabel: Scalars['String']['output'];
  campaignLogo?: Maybe<Scalars['String']['output']>;
  campaignShowGoalDial: Scalars['Boolean']['output'];
  campaignStory: Scalars['SequelizeJSON']['output'];
  /** Optional title on Campaign Landing Page story widget - defaults to Our Mission */
  campaignStoryTitle?: Maybe<Scalars['String']['output']>;
  /** Subtext to be displayed under campaign headline on Campaign Landing Page */
  campaignSubHeadline?: Maybe<Scalars['String']['output']>;
  campaignType?: Maybe<CampaignType>;
  campaignTypeCode?: Maybe<Scalars['String']['output']>;
  canDonorCoverPlatformFee: Scalars['Boolean']['output'];
  canDonorCoverProcessorFee: Scalars['Boolean']['output'];
  canParticipantCoverPlatformFee: Scalars['Boolean']['output'];
  canParticipantCoverProcessorFee: Scalars['Boolean']['output'];
  canRaffleCoverPlatformFee: Scalars['Boolean']['output'];
  canRaffleCoverProcessorFee: Scalars['Boolean']['output'];
  canSponsorCoverPlatformFee: Scalars['Boolean']['output'];
  canSponsorCoverProcessorFee: Scalars['Boolean']['output'];
  children?: Maybe<Array<Maybe<Campaign>>>;
  /** Controls whether donors will be asked to provide address. Choices are off (default), optional and required. */
  collectDonorAddress: CampaigncollectDonorAddressEnumType;
  /** Controls whether fundraisers will be asked to provide phone. Choices are off (default), optional and required. */
  collectDonorPhone: CampaigncollectDonorPhoneEnumType;
  collectRaffleAddress: CampaigncollectRaffleAddressEnumType;
  collectRafflePhone: CampaigncollectRafflePhoneEnumType;
  collectShopAddress: CampaigncollectShopAddressEnumType;
  collectShopPhone: CampaigncollectShopPhoneEnumType;
  collectSponsorAddress: CampaigncollectSponsorAddressEnumType;
  collectSponsorPhone: CampaigncollectSponsorPhoneEnumType;
  contactEmail: Scalars['String']['output'];
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  customActivityMetrics?: Maybe<Array<Maybe<ActivityMetric>>>;
  dailyStats: Array<Maybe<CampaignDailyStats>>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  discountCodeCount: Scalars['Int']['output'];
  discountCodes?: Maybe<Array<Maybe<DiscountCode>>>;
  displayId?: Maybe<Scalars['String']['output']>;
  donationCount: Scalars['Int']['output'];
  donationFeeMode: CampaigndonationFeeModeEnumType;
  /** Array of four values */
  donationPresets: Scalars['SequelizeJSON']['output'];
  donationQuestions?: Maybe<Array<Maybe<Question>>>;
  donationTable: DonationTable;
  donations?: Maybe<Array<Maybe<Donation>>>;
  duplicatedFrom?: Maybe<Campaign>;
  duplicatedFromId?: Maybe<Scalars['String']['output']>;
  embedWidgets?: Maybe<Array<Maybe<EmbedWidget>>>;
  enabledFeatures: Scalars['SequelizeJSON']['output'];
  event?: Maybe<CampaignEvent>;
  eventNumberMode: CampaigneventNumberModeEnumType;
  eventNumberStart?: Maybe<Scalars['Int']['output']>;
  eventSeating?: Maybe<Array<Maybe<EventAttendeeSeating>>>;
  eventTables?: Maybe<Array<Maybe<EventTable>>>;
  formEnableRedirect: Scalars['Boolean']['output'];
  formHeading?: Maybe<Scalars['String']['output']>;
  formRedirectButtonLabel?: Maybe<Scalars['String']['output']>;
  formRedirectUrl?: Maybe<Scalars['String']['output']>;
  formSubHeading?: Maybe<Scalars['String']['output']>;
  formThankYouMessage?: Maybe<Scalars['SequelizeJSON']['output']>;
  fundraiserCount: Scalars['Int']['output'];
  fundraiserCustomTextBlocks?: Maybe<Array<Maybe<CustomTextBlock>>>;
  /** Profile Avatar for the Fundraiser */
  fundraiserDefaultHeaderAvatarImage?: Maybe<Scalars['String']['output']>;
  /** Header hero image for Fundraiser Landing Page */
  fundraiserDefaultHeaderBackgroundImage?: Maybe<Scalars['String']['output']>;
  fundraiserDefaultMonetaryGoal: Scalars['Int']['output'];
  fundraiserDefaultStory: Scalars['SequelizeJSON']['output'];
  /** Optional title on Fundraiser Landing Page story widget - defaults to My Mission */
  fundraiserDefaultStoryTitle?: Maybe<Scalars['String']['output']>;
  fundraiserWidgets?: Maybe<Array<Maybe<CampaignWidget>>>;
  fundraisers?: Maybe<Array<Maybe<Fundraiser>>>;
  /** Date on which join button will be disabled */
  fundraisingDisabledDate?: Maybe<Scalars['String']['output']>;
  /** Type of fundraising - team or individual. Defaults to create_team_create_individual */
  fundraisingType: CampaignfundraisingTypeEnumType;
  getEmailCustomization: CampaignEmailCustomization;
  /** Date on which donate button will be disabled */
  givingDisabledDate?: Maybe<Scalars['String']['output']>;
  givingVoucher: Scalars['String']['output'];
  heroShowDonate?: Maybe<Scalars['Boolean']['output']>;
  heroShowJoin?: Maybe<Scalars['Boolean']['output']>;
  heroShowRaised?: Maybe<Scalars['Boolean']['output']>;
  heroStyle?: Maybe<CampaignheroStyleEnumType>;
  id: Scalars['String']['output'];
  includeShopInAmountRaised: Scalars['Boolean']['output'];
  intervalEndDate?: Maybe<Scalars['String']['output']>;
  intervalStartDate?: Maybe<Scalars['String']['output']>;
  isAuctionEnabled: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isDoubleTheDonationDisabled: Scalars['Boolean']['output'];
  isFundANeedEnabled: Scalars['Boolean']['output'];
  /** Is Join button disabled. Does not take into account the fundraisingDisabledDate - use isFundraisingEnabled for that. */
  isFundraisingDisabled: Scalars['Boolean']['output'];
  /** Determines if all criteria is met to allow fundraising (isFundraisingDisabled and fundraisingDisabledDate settings) */
  isFundraisingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFundraisingOptOutEnabled: Scalars['Boolean']['output'];
  /** Is Donate button disabled. Does not take into account the givingDisabledDate - use isGivingEnabled for that. */
  isGivingDisabled: Scalars['Boolean']['output'];
  /** Determines if all criteria is met to allow giving (isGivingDisabled and givingDisabledDate settings) */
  isGivingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLaunched: Scalars['Boolean']['output'];
  isLiveAuctionEnabled: Scalars['Boolean']['output'];
  isMetricLabelLocked?: Maybe<Scalars['Boolean']['output']>;
  isOfflineDonationMatchEnabled: Scalars['Boolean']['output'];
  isPerformanceEnabled: Scalars['Boolean']['output'];
  isRaffleEnabled: Scalars['Boolean']['output'];
  isRecurringGivingEnabled: Scalars['Boolean']['output'];
  isShopEnabled: Scalars['Boolean']['output'];
  isSponsorshipEnabled: Scalars['Boolean']['output'];
  liveAuctionItemCount: Scalars['Int']['output'];
  liveAuctionItems?: Maybe<Array<Maybe<LiveAuctionItem>>>;
  liveDisplays?: Maybe<Array<Maybe<LiveDisplay>>>;
  lockedFeatures: CampaignFeatures;
  matches?: Maybe<Array<Maybe<Match>>>;
  messages?: Maybe<Array<Maybe<CampaignMessage>>>;
  metadata?: Maybe<Array<Maybe<CampaignMetadata>>>;
  metricLabel?: Maybe<Scalars['String']['output']>;
  metricLabelPlural?: Maybe<Scalars['String']['output']>;
  monetaryGoal?: Maybe<Scalars['Int']['output']>;
  myPermissions?: Maybe<Array<Scalars['String']['output']>>;
  myTeam?: Maybe<Team>;
  name: Scalars['String']['output'];
  needs?: Maybe<Array<Maybe<Need>>>;
  orderTable: OrderTable;
  orders?: Maybe<Array<Maybe<Order>>>;
  outstandingPledgeAmount?: Maybe<Scalars['String']['output']>;
  ownerOrganization?: Maybe<Organization>;
  ownerOrganizationId: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<CampaignPage>>>;
  parent?: Maybe<Campaign>;
  parentId?: Maybe<Scalars['String']['output']>;
  participantCount: Scalars['Int']['output'];
  participantQuestions?: Maybe<Array<Maybe<Question>>>;
  participantTable: ParticipantTable;
  participants?: Maybe<Array<Maybe<Fundraiser>>>;
  performanceEndDate?: Maybe<Scalars['String']['output']>;
  performanceMode?: Maybe<CampaignperformanceModeEnumType>;
  performanceStartDate?: Maybe<Scalars['String']['output']>;
  performanceStatus?: Maybe<CampaignPerformanceStatusEnum>;
  performanceTrackingLevel?: Maybe<CampaignperformanceTrackingLevelEnumType>;
  platformFee: Scalars['String']['output'];
  previousCampaign?: Maybe<Campaign>;
  previousCampaignId?: Maybe<Scalars['String']['output']>;
  previousFundraiserTable: PreviousParticipantTable;
  primaryColor: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<Product>>>;
  programSort?: Maybe<Scalars['Int']['output']>;
  raffleEntryCount: Scalars['Int']['output'];
  raffleOrderItems?: Maybe<Array<Maybe<RaffleOrderItem>>>;
  raffleOrders?: Maybe<Array<Maybe<RaffleOrder>>>;
  raffles?: Maybe<Array<Maybe<Raffle>>>;
  recurringDonationPresets: Scalars['SequelizeJSON']['output'];
  registrationDescription?: Maybe<Scalars['SequelizeJSON']['output']>;
  registrationTypes?: Maybe<Array<Maybe<RegistrationType>>>;
  registrationsIncludedInTotal?: Maybe<Scalars['Boolean']['output']>;
  reportTemplates?: Maybe<Array<Maybe<ReportTemplate>>>;
  searchDonations?: Maybe<Array<Maybe<DonationSearchResult>>>;
  searchFundraisers?: Maybe<Array<Maybe<FundraiserSearchResult>>>;
  searchTeams?: Maybe<Array<Maybe<TeamSearchResult>>>;
  searchText?: Maybe<Scalars['String']['output']>;
  shopOrdersTable: ShopOrdersTable;
  slug?: Maybe<Scalars['String']['output']>;
  soldProducts?: Maybe<Array<Maybe<SoldProduct>>>;
  soldProductsCount: Scalars['Int']['output'];
  soldTicketBundles?: Maybe<Array<Maybe<SoldTicketBundle>>>;
  sponsorCount: Scalars['Int']['output'];
  sponsorPurchaseInstructions?: Maybe<Scalars['SequelizeJSON']['output']>;
  sponsorQuestions?: Maybe<Array<Maybe<Question>>>;
  sponsors?: Maybe<Array<Maybe<Sponsor>>>;
  stats?: Maybe<FundraisingStats>;
  subsequentCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  supportedFeatures: CampaignFeatures;
  supportedWidgetTypes: CampaignWidgetTypes;
  supportsDailyRecurringDonations: Scalars['Boolean']['output'];
  supportsHourlyRecurringDonations: Scalars['Boolean']['output'];
  supportsMonthlyRecurringDonations: Scalars['Boolean']['output'];
  supportsQuarterlyRecurringDonations: Scalars['Boolean']['output'];
  supportsWeeklyRecurringDonations: Scalars['Boolean']['output'];
  supportsYearlyRecurringDonations: Scalars['Boolean']['output'];
  teamCustomTextBlocks?: Maybe<Array<Maybe<CustomTextBlock>>>;
  /** Profile Avatar for the Team */
  teamDefaultHeaderAvatarImage?: Maybe<Scalars['String']['output']>;
  /** Header hero image for Team Landing Page */
  teamDefaultHeaderBackgroundImage?: Maybe<Scalars['String']['output']>;
  teamDefaultMonetaryGoal: Scalars['Int']['output'];
  teamDefaultStory: Scalars['SequelizeJSON']['output'];
  /** Optional title on Team Landing Page story widget - defaults to Our Mission */
  teamDefaultStoryTitle?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  ticketCount: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  totalAddOnAmount: Scalars['String']['output'];
  totalAuctionAmount: Scalars['String']['output'];
  totalFlatAmount: Scalars['String']['output'];
  totalLiveAuctionAmount: Scalars['String']['output'];
  totalMatchAmount: Scalars['String']['output'];
  totalOfflineFlatAmount: Scalars['String']['output'];
  totalOrderMiscItemAmount: Scalars['String']['output'];
  totalPledgeAmount: Scalars['String']['output'];
  totalRaffleAmount: Scalars['String']['output'];
  totalRegistrationAmount: Scalars['String']['output'];
  totalShopAmount: Scalars['String']['output'];
  totalSponsorAmount: Scalars['String']['output'];
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  type: CampaigntypeEnumType;
  unclaimedParticipantCount: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  updates?: Maybe<Array<Maybe<FundraisingUpdate>>>;
  updatesCount: Scalars['Int']['output'];
  userPermissions?: Maybe<Array<UserPermissions>>;
  widgets?: Maybe<Array<Maybe<CampaignWidget>>>;
  wonLiveAuctionItems?: Maybe<Array<Maybe<WonLiveAuctionItem>>>;
};


export type CampaignAchievementLevelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignAddOnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignAssignedActivityMetricsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignAvailableActivityMetricsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignCustomActivityMetricsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignDailyStatsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CampaignDiscountCodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignDonationQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignDonationTableArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignEmbedWidgetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignEventSeatingArgs = {
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CampaignEventTablesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignFundraiserCustomTextBlocksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignFundraiserWidgetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignFundraisersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignGetEmailCustomizationArgs = {
  messageType: Scalars['String']['input'];
};


export type CampaignGivingVoucherArgs = {
  type: GivingVoucherEnum;
  validationToken?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignLiveAuctionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignLiveDisplaysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignMatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignMetadataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignNeedsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignOrderTableArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignParticipantQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignParticipantTableArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignPreviousFundraiserTableArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignRaffleOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignRaffleOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignRafflesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignRegistrationTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignReportTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignSearchDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignSearchFundraisersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignSearchTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignShopOrdersTableArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignSoldProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignSoldTicketBundlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignSponsorQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignSponsorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignSubsequentCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignSupportedWidgetTypesArgs = {
  scope: Scalars['String']['input'];
};


export type CampaignTeamCustomTextBlocksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignUpdatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignUpdatesCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignWidgetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignWonLiveAuctionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignDailyStats = {
  __typename?: 'CampaignDailyStats';
  amountRaised: Scalars['Float']['output'];
  attendeeCount: Scalars['Int']['output'];
  auctionAmount: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  donationAmount: Scalars['Float']['output'];
  donationCount: Scalars['Int']['output'];
  liveAuctionAmount: Scalars['Float']['output'];
  orderAmount: Scalars['Float']['output'];
  orderCount: Scalars['Int']['output'];
  orderMiscItemAmount: Scalars['Float']['output'];
  orderMiscItemCount: Scalars['Int']['output'];
  participantAmount: Scalars['Float']['output'];
  participantCount: Scalars['Int']['output'];
  performanceResult: Scalars['Float']['output'];
  raffleAmount: Scalars['Float']['output'];
  shopAmount: Scalars['Float']['output'];
  sponsorAmount: Scalars['Float']['output'];
  sponsorCount: Scalars['Int']['output'];
  ticketBundleAmount: Scalars['Float']['output'];
};

export type CampaignEmailCustomization = {
  __typename?: 'CampaignEmailCustomization';
  customData?: Maybe<Scalars['SequelizeJSON']['output']>;
  messageType: Scalars['String']['output'];
};

export type CampaignEvent = {
  __typename?: 'CampaignEvent';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  stateProv?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type CampaignEventInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CampaignFeatures = {
  __typename?: 'CampaignFeatures';
  activityTracking: Scalars['Boolean']['output'];
  auction: Scalars['Boolean']['output'];
  donationForm: Scalars['Boolean']['output'];
  doubleTheDonation: Scalars['Boolean']['output'];
  event: Scalars['Boolean']['output'];
  fundANeed: Scalars['Boolean']['output'];
  giving: Scalars['Boolean']['output'];
  join: Scalars['Boolean']['output'];
  liveAuction: Scalars['Boolean']['output'];
  matching: Scalars['Boolean']['output'];
  monetaryGoal: Scalars['Boolean']['output'];
  participantQuestions: Scalars['Boolean']['output'];
  raffle: Scalars['Boolean']['output'];
  shop: Scalars['Boolean']['output'];
  sponsorship: Scalars['Boolean']['output'];
  strava: Scalars['Boolean']['output'];
  teams: Scalars['Boolean']['output'];
  tickets: Scalars['Boolean']['output'];
};

export type CampaignInput = {
  AssignedActivityMetric?: InputMaybe<AssignedActivityMetricInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  accentColor?: InputMaybe<Scalars['String']['input']>;
  achievementLevels?: InputMaybe<Array<InputMaybe<AchievementLevelInput>>>;
  addOns?: InputMaybe<Array<InputMaybe<AddOnInput>>>;
  assignedActivityMetrics?: InputMaybe<Array<InputMaybe<ActivityMetricInput>>>;
  auction?: InputMaybe<AuctionInput>;
  /** Custom label for donate button on Campaign Landing Page - defaults to Donate */
  campaignDonateButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** Header hero image for Campaign Landing Page */
  campaignHeaderBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  /** Headline to be displayed instead of campaign name on Campaign Landing Page */
  campaignHeadline?: InputMaybe<Scalars['String']['input']>;
  /** Custom label for join button on Campaign Landing Page - defaults to Join */
  campaignJoinButtonLabel?: InputMaybe<Scalars['String']['input']>;
  campaignLogo?: InputMaybe<Scalars['String']['input']>;
  campaignShowGoalDial?: InputMaybe<Scalars['Boolean']['input']>;
  campaignStory?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  /** Optional title on Campaign Landing Page story widget - defaults to Our Mission */
  campaignStoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** Subtext to be displayed under campaign headline on Campaign Landing Page */
  campaignSubHeadline?: InputMaybe<Scalars['String']['input']>;
  campaignTypeCode?: InputMaybe<Scalars['String']['input']>;
  canDonorCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  canDonorCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  canParticipantCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  canParticipantCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  canRaffleCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  canRaffleCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  canSponsorCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  canSponsorCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<InputMaybe<CampaignInput>>>;
  /** Controls whether donors will be asked to provide address. Choices are off (default), optional and required. */
  collectDonorAddress?: InputMaybe<CampaigncollectDonorAddressEnumType>;
  /** Controls whether fundraisers will be asked to provide phone. Choices are off (default), optional and required. */
  collectDonorPhone?: InputMaybe<CampaigncollectDonorPhoneEnumType>;
  collectRaffleAddress?: InputMaybe<CampaigncollectRaffleAddressEnumType>;
  collectRafflePhone?: InputMaybe<CampaigncollectRafflePhoneEnumType>;
  collectShopAddress?: InputMaybe<CampaigncollectShopAddressEnumType>;
  collectShopPhone?: InputMaybe<CampaigncollectShopPhoneEnumType>;
  collectSponsorAddress?: InputMaybe<CampaigncollectSponsorAddressEnumType>;
  collectSponsorPhone?: InputMaybe<CampaigncollectSponsorPhoneEnumType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customActivityMetrics?: InputMaybe<Array<InputMaybe<ActivityMetricInput>>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  discountCodes?: InputMaybe<Array<InputMaybe<DiscountCodeInput>>>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  donationFeeMode?: InputMaybe<CampaigndonationFeeModeEnumType>;
  /** Array of four values */
  donationPresets?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  donationQuestions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  donations?: InputMaybe<Array<InputMaybe<DonationInput>>>;
  duplicatedFromId?: InputMaybe<Scalars['String']['input']>;
  embedWidgets?: InputMaybe<Array<InputMaybe<EmbedWidgetInput>>>;
  enabledFeatures?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  event?: InputMaybe<CampaignEventInput>;
  eventNumberMode?: InputMaybe<CampaigneventNumberModeEnumType>;
  eventNumberStart?: InputMaybe<Scalars['Int']['input']>;
  eventTables?: InputMaybe<Array<InputMaybe<EventTableInput>>>;
  formEnableRedirect?: InputMaybe<Scalars['Boolean']['input']>;
  formHeading?: InputMaybe<Scalars['String']['input']>;
  formRedirectButtonLabel?: InputMaybe<Scalars['String']['input']>;
  formRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  formSubHeading?: InputMaybe<Scalars['String']['input']>;
  formThankYouMessage?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  fundraiserCustomTextBlocks?: InputMaybe<Array<InputMaybe<CustomTextBlockInput>>>;
  /** Profile Avatar for the Fundraiser */
  fundraiserDefaultHeaderAvatarImage?: InputMaybe<Scalars['String']['input']>;
  /** Header hero image for Fundraiser Landing Page */
  fundraiserDefaultHeaderBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  fundraiserDefaultMonetaryGoal?: InputMaybe<Scalars['Int']['input']>;
  fundraiserDefaultStory?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  /** Optional title on Fundraiser Landing Page story widget - defaults to My Mission */
  fundraiserDefaultStoryTitle?: InputMaybe<Scalars['String']['input']>;
  fundraiserWidgets?: InputMaybe<Array<InputMaybe<CampaignWidgetInput>>>;
  fundraisers?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  /** Date on which join button will be disabled */
  fundraisingDisabledDate?: InputMaybe<Scalars['String']['input']>;
  /** Type of fundraising - team or individual. Defaults to create_team_create_individual */
  fundraisingType?: InputMaybe<CampaignfundraisingTypeEnumType>;
  /** Date on which donate button will be disabled */
  givingDisabledDate?: InputMaybe<Scalars['String']['input']>;
  heroShowDonate?: InputMaybe<Scalars['Boolean']['input']>;
  heroShowJoin?: InputMaybe<Scalars['Boolean']['input']>;
  heroShowRaised?: InputMaybe<Scalars['Boolean']['input']>;
  heroStyle?: InputMaybe<CampaignheroStyleEnumType>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeShopInAmountRaised?: InputMaybe<Scalars['Boolean']['input']>;
  intervalEndDate?: InputMaybe<Scalars['String']['input']>;
  intervalStartDate?: InputMaybe<Scalars['String']['input']>;
  isAuctionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleTheDonationDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFundANeedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Join button disabled. Does not take into account the fundraisingDisabledDate - use isFundraisingEnabled for that. */
  isFundraisingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if all criteria is met to allow fundraising (isFundraisingDisabled and fundraisingDisabledDate settings) */
  isFundraisingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFundraisingOptOutEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Donate button disabled. Does not take into account the givingDisabledDate - use isGivingEnabled for that. */
  isGivingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if all criteria is met to allow giving (isGivingDisabled and givingDisabledDate settings) */
  isGivingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLaunched?: InputMaybe<Scalars['Boolean']['input']>;
  isLiveAuctionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMetricLabelLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isOfflineDonationMatchEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPerformanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRaffleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurringGivingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSponsorshipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  liveAuctionItems?: InputMaybe<Array<InputMaybe<LiveAuctionItemInput>>>;
  liveDisplays?: InputMaybe<Array<InputMaybe<LiveDisplayInput>>>;
  matches?: InputMaybe<Array<InputMaybe<MatchInput>>>;
  messages?: InputMaybe<Array<InputMaybe<CampaignMessageInput>>>;
  metadata?: InputMaybe<Array<InputMaybe<CampaignMetadataInput>>>;
  monetaryGoal?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needs?: InputMaybe<Array<InputMaybe<NeedInput>>>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  ownerOrganizationId?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Array<InputMaybe<CampaignPageInput>>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  participantQuestions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  participants?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  performanceMode?: InputMaybe<CampaignperformanceModeEnumType>;
  performanceTrackingLevel?: InputMaybe<CampaignperformanceTrackingLevelEnumType>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  previousCampaignId?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<ProductInput>>>;
  programSort?: InputMaybe<Scalars['Int']['input']>;
  raffleEntryCount?: InputMaybe<Scalars['Int']['input']>;
  raffleOrderItems?: InputMaybe<Array<InputMaybe<RaffleOrderItemInput>>>;
  raffleOrders?: InputMaybe<Array<InputMaybe<RaffleOrderInput>>>;
  raffles?: InputMaybe<Array<InputMaybe<RaffleInput>>>;
  recurringDonationPresets?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  registrationDescription?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  registrationTypes?: InputMaybe<Array<InputMaybe<RegistrationTypeInput>>>;
  registrationsIncludedInTotal?: InputMaybe<Scalars['Boolean']['input']>;
  reportTemplates?: InputMaybe<Array<InputMaybe<ReportTemplateInput>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  soldProducts?: InputMaybe<Array<InputMaybe<SoldProductInput>>>;
  soldProductsCount?: InputMaybe<Scalars['Int']['input']>;
  soldTicketBundles?: InputMaybe<Array<InputMaybe<SoldTicketBundleInput>>>;
  sponsorPurchaseInstructions?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  sponsorQuestions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  sponsors?: InputMaybe<Array<InputMaybe<SponsorInput>>>;
  subsequentCampaigns?: InputMaybe<Array<InputMaybe<CampaignInput>>>;
  supportsDailyRecurringDonations?: InputMaybe<Scalars['Boolean']['input']>;
  supportsHourlyRecurringDonations?: InputMaybe<Scalars['Boolean']['input']>;
  supportsMonthlyRecurringDonations?: InputMaybe<Scalars['Boolean']['input']>;
  supportsQuarterlyRecurringDonations?: InputMaybe<Scalars['Boolean']['input']>;
  supportsWeeklyRecurringDonations?: InputMaybe<Scalars['Boolean']['input']>;
  supportsYearlyRecurringDonations?: InputMaybe<Scalars['Boolean']['input']>;
  teamCustomTextBlocks?: InputMaybe<Array<InputMaybe<CustomTextBlockInput>>>;
  /** Profile Avatar for the Team */
  teamDefaultHeaderAvatarImage?: InputMaybe<Scalars['String']['input']>;
  /** Header hero image for Team Landing Page */
  teamDefaultHeaderBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  teamDefaultMonetaryGoal?: InputMaybe<Scalars['Int']['input']>;
  teamDefaultStory?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  /** Optional title on Team Landing Page story widget - defaults to Our Mission */
  teamDefaultStoryTitle?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<InputMaybe<TeamInput>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  totalAddOnAmount?: InputMaybe<Scalars['String']['input']>;
  totalAuctionAmount?: InputMaybe<Scalars['String']['input']>;
  totalLiveAuctionAmount?: InputMaybe<Scalars['String']['input']>;
  totalOrderMiscItemAmount?: InputMaybe<Scalars['String']['input']>;
  totalRaffleAmount?: InputMaybe<Scalars['String']['input']>;
  totalShopAmount?: InputMaybe<Scalars['String']['input']>;
  totalSponsorAmount?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CampaigntypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<CampaignWidgetInput>>>;
  wonLiveAuctionItems?: InputMaybe<Array<InputMaybe<WonLiveAuctionItemInput>>>;
};

export type CampaignMessage = {
  __typename?: 'CampaignMessage';
  CampaignId?: Maybe<Scalars['String']['output']>;
  audiences?: Maybe<Array<Maybe<CampaignMessageAudience>>>;
  body: Scalars['SequelizeJSON']['output'];
  bodyColor: Scalars['String']['output'];
  buttonColor: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  ccSender: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deliveryInfo?: Maybe<MessageDeliveryInfo>;
  headerImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isProcessing?: Maybe<Scalars['Boolean']['output']>;
  messageServiceId?: Maybe<Scalars['String']['output']>;
  previewText?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CampaignMessagestatusEnumType>;
  subject: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type CampaignMessageAudiencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignMessageAudience = {
  __typename?: 'CampaignMessageAudience';
  CampaignMessageId?: Maybe<Scalars['String']['output']>;
  audience: CampaignMessageAudienceaudienceEnumType;
  campaignMessage?: Maybe<CampaignMessage>;
  campaignMessageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  question?: Maybe<Question>;
  questionAnswerValue?: Maybe<Scalars['SequelizeJSON']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<RegistrationType>;
  registrationTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type CampaignMessageAudienceInput = {
  CampaignMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  audience?: InputMaybe<CampaignMessageAudienceaudienceEnumType>;
  campaignMessageId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  questionAnswerValue?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum CampaignMessageAudienceaudienceEnumType {
  AllAuctionBidders = 'all_auction_bidders',
  AllDonors = 'all_donors',
  AllFundraisers = 'all_fundraisers',
  AllTeamCaptains = 'all_team_captains',
  CampaignAdmins = 'campaign_admins',
  FundraisersNothingRaised = 'fundraisers_nothing_raised',
  FundraisersWithoutPerformance = 'fundraisers_without_performance',
  ParticipantsNotFundraising = 'participants_not_fundraising',
  PreviousParticipants = 'previous_participants',
  PreviousTeamCaptains = 'previous_team_captains',
  QuestionRespondents = 'question_respondents',
  Sponsors = 'sponsors',
  TicketHolders = 'ticket_holders'
}

export type CampaignMessageInput = {
  CampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  audiences?: InputMaybe<Array<InputMaybe<CampaignMessageAudienceInput>>>;
  body?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  bodyColor?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  ccSender?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  previewText?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<CampaignMessagestatusEnumType>;
  subject?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CampaignMessageTestInput = {
  body: Scalars['SequelizeJSON']['input'];
  bodyColor: Scalars['String']['input'];
  buttonColor: Scalars['String']['input'];
  ccSender?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  previewText?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  textColor: Scalars['String']['input'];
};

export enum CampaignMessagestatusEnumType {
  Draft = 'draft',
  Scheduled = 'scheduled',
  Sent = 'sent'
}

export type CampaignMetadata = {
  __typename?: 'CampaignMetadata';
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CampaignMetadataInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignPage = {
  __typename?: 'CampaignPage';
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  widgets?: Maybe<Array<Maybe<CampaignWidget>>>;
};


export type CampaignPageWidgetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignPageInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<CampaignWidgetInput>>>;
};

export enum CampaignPerformanceStatusEnum {
  CloseOut = 'closeOut',
  NotStarted = 'notStarted',
  Performing = 'performing'
}

export type CampaignSearchResult = SearchResult & {
  __typename?: 'CampaignSearchResult';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export type CampaignType = {
  __typename?: 'CampaignType';
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CampaignWidget = {
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type CampaignWidgetInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignPageId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<CampaignWidgetscopeEnumType>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CampaignWidgettypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CampaignWidgetTypes = {
  __typename?: 'CampaignWidgetTypes';
  auctionPreview: Scalars['Boolean']['output'];
  childCampaignListing: Scalars['Boolean']['output'];
  communityActivity: Scalars['Boolean']['output'];
  customBlock: Scalars['Boolean']['output'];
  donations: Scalars['Boolean']['output'];
  eventDetails: Scalars['Boolean']['output'];
  groupLeaderboard: Scalars['Boolean']['output'];
  imageGallery: Scalars['Boolean']['output'];
  impactStories: Scalars['Boolean']['output'];
  leaderboard: Scalars['Boolean']['output'];
  logoGrid: Scalars['Boolean']['output'];
  raffle: Scalars['Boolean']['output'];
  shop: Scalars['Boolean']['output'];
  sponsorPackages: Scalars['Boolean']['output'];
  sponsors: Scalars['Boolean']['output'];
};

export enum CampaignWidgetscopeEnumType {
  Campaign = 'campaign',
  Fundraiser = 'fundraiser'
}

export enum CampaignWidgettypeEnumType {
  AuctionPreview = 'auctionPreview',
  ChildCampaignListing = 'childCampaignListing',
  CommunityActivity = 'communityActivity',
  CustomBlock = 'customBlock',
  Donations = 'donations',
  EventDetails = 'eventDetails',
  GroupLeaderboard = 'groupLeaderboard',
  ImageGallery = 'imageGallery',
  ImpactStories = 'impactStories',
  Leaderboard = 'leaderboard',
  LogoGrid = 'logoGrid',
  Raffle = 'raffle',
  Shop = 'shop',
  SponsorPackages = 'sponsorPackages',
  Sponsors = 'sponsors'
}

export enum CampaigncollectDonorAddressEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigncollectDonorPhoneEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigncollectRaffleAddressEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigncollectRafflePhoneEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigncollectShopAddressEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigncollectShopPhoneEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigncollectSponsorAddressEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigncollectSponsorPhoneEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum CampaigndonationFeeModeEnumType {
  Fee = 'fee',
  Tip = 'tip'
}

export enum CampaigneventNumberModeEnumType {
  Automatic = 'automatic',
  Manual = 'manual',
  Off = 'off'
}

export enum CampaignfundraisingTypeEnumType {
  CreateJoinTeam = 'create_join_team',
  CreateTeamCreateIndividual = 'create_team_create_individual',
  Individual = 'individual',
  JoinTeam = 'join_team',
  JoinTeamCreateIndividual = 'join_team_create_individual'
}

export enum CampaignheroStyleEnumType {
  Basic = 'basic',
  Cover = 'cover',
  Fade = 'fade'
}

export enum CampaignperformanceModeEnumType {
  Event = 'event',
  Interval = 'interval'
}

export enum CampaignperformanceTrackingLevelEnumType {
  Fundraiser = 'fundraiser',
  Team = 'team'
}

export enum CampaigntypeEnumType {
  ClassicEvent = 'classic_event',
  Donation = 'donation',
  DonationForm = 'donation_form',
  Event = 'event',
  EventPeerToPeer = 'event_peer_to_peer',
  EventPeerToPeerVariableActivity = 'event_peer_to_peer_variable_activity',
  Program = 'program',
  VirtualPeerToPeer = 'virtual_peer_to_peer',
  VirtualPeerToPeerVariableActivity = 'virtual_peer_to_peer_variable_activity'
}

export type ChargeCommitmentResult = {
  __typename?: 'ChargeCommitmentResult';
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChargeSponsorResult = PayableResult & {
  __typename?: 'ChargeSponsorResult';
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ChargeStatus {
  Cancelled = 'cancelled',
  Charged = 'charged',
  Error = 'error',
  Failed = 'failed',
  Failing = 'failing',
  Invoiced = 'invoiced',
  Pending = 'pending'
}

export type ChargeType = {
  __typename?: 'ChargeType';
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ChildCampaignListingCampaignWidget = CampaignWidget & {
  __typename?: 'ChildCampaignListingCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export enum CommitmentNudgeStatusEnum {
  Overdue = 'overdue',
  Unfulfilled = 'unfulfilled'
}

export type CommunityActivityCampaignWidget = CampaignWidget & {
  __typename?: 'CommunityActivityCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type CompleteOrderInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inviteMessage?: Maybe<Scalars['String']['output']>;
  inviteStatus?: Maybe<ContactInviteStatus>;
  maxReminders?: Maybe<Scalars['Int']['output']>;
  nextReminderDate?: Maybe<Scalars['Date']['output']>;
  prevReminderDate?: Maybe<Scalars['Date']['output']>;
  relatedDonations?: Maybe<Array<Maybe<ContactDonation>>>;
  remindersCancelledAt?: Maybe<Scalars['Date']['output']>;
  remindersRemaining: Scalars['Int']['output'];
  remindersUnsubbedAt?: Maybe<Scalars['Date']['output']>;
  sendingReminder: Scalars['Boolean']['output'];
  source?: Maybe<ContactsourceEnumType>;
  updatedAt: Scalars['Date']['output'];
};


export type ContactRelatedDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type ContactDonation = {
  __typename?: 'ContactDonation';
  contact?: Maybe<Contact>;
  contactId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  donation?: Maybe<Donation>;
  donationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  matchType?: Maybe<ContactDonationmatchTypeEnumType>;
  updatedAt: Scalars['Date']['output'];
};

export type ContactDonationInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<ContactDonationmatchTypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum ContactDonationmatchTypeEnumType {
  Email = 'email',
  Tracking = 'tracking'
}

export type ContactInfo = {
  email: Scalars['String']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ContactInfoSourceEnum>;
};

export enum ContactInfoSourceEnum {
  Contact = 'contact',
  Donation = 'donation',
  Entered = 'entered'
}

export type ContactInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inviteMessage?: InputMaybe<Scalars['String']['input']>;
  maxReminders?: InputMaybe<Scalars['Int']['input']>;
  nextReminderDate?: InputMaybe<Scalars['Date']['input']>;
  prevReminderDate?: InputMaybe<Scalars['Date']['input']>;
  relatedDonations?: InputMaybe<Array<InputMaybe<ContactDonationInput>>>;
  remindersCancelledAt?: InputMaybe<Scalars['Date']['input']>;
  remindersRemaining?: InputMaybe<Scalars['Int']['input']>;
  remindersUnsubbedAt?: InputMaybe<Scalars['Date']['input']>;
  sendingReminder?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ContactsourceEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum ContactInviteStatus {
  Cancelled = 'cancelled',
  Donated = 'donated',
  Expired = 'expired',
  Invited = 'invited',
  Reminded = 'reminded',
  Unsubscribed = 'unsubscribed'
}

export enum ContactsourceEnumType {
  Contact = 'contact',
  Donation = 'donation',
  Entered = 'entered'
}

export type CreateAdminInviteInput = {
  email: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  roleCode: Scalars['String']['input'];
};

export type CreateAuctionBidderInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  auctionId: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  confirmationTokenId: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  isCoveringFees?: InputMaybe<Scalars['Boolean']['input']>;
  isSmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDonationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationTokenId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  estimatedAmount: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  givingVoucher?: InputMaybe<Scalars['String']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<GivingPlanfrequencyEnumType>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  tip: Scalars['String']['input'];
  type: DonationTypeEnum;
};

export type CreateOfflineDonationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  givingVoucher?: InputMaybe<Scalars['String']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  offlinePaymentType?: InputMaybe<Scalars['String']['input']>;
  offlineReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<GivingPlanfrequencyEnumType>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  type: OfflineDonationTypeEnum;
};

export type CreateOrderDonationInput = {
  amount: Scalars['String']['input'];
};

export type CreateOrderFundraiserInput = {
  avatarImage?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  intervalReminderOffset?: InputMaybe<Scalars['Int']['input']>;
  makeTeamCaptain?: InputMaybe<Scalars['Boolean']['input']>;
  monetaryGoal: Scalars['Int']['input'];
  performanceEstimate?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  unlockedActivityMetricId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderInput = {
  amount: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<CreateOrderDonationInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  givingVoucher?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  miscItems?: InputMaybe<Array<InputMaybe<CreateOrderMiscItemInput>>>;
  needs?: InputMaybe<Array<InputMaybe<CreateOrderNeedInput>>>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  previousTeamId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<CreateOrderProductInput>>>;
  raffle?: InputMaybe<Array<InputMaybe<CreateOrderRaffleItemInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<CreateOrderTeamInput>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  ticketBundles?: InputMaybe<Array<InputMaybe<CreateOrderTicketBundleInput>>>;
  tickets?: InputMaybe<Array<InputMaybe<CreateOrderTicketInput>>>;
  wonLiveAuctionItems?: InputMaybe<Array<InputMaybe<CreateOrderWonLiveAuctionItemInput>>>;
};

export type CreateOrderMiscItemInput = {
  amount: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOrderNeedInput = {
  needId: Scalars['String']['input'];
};

export type CreateOrderProductInput = {
  noteResponse?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  selectedVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderQuestionInput = {
  answer: Scalars['SequelizeJSON']['input'];
  id: Scalars['String']['input'];
};

export type CreateOrderRaffleItemInput = {
  entries: Scalars['Int']['input'];
  raffleId: Scalars['String']['input'];
};

export type CreateOrderTeamInput = {
  avatarImage?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  monetaryGoal: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  story?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CreateOrderTicketBundleInput = {
  bundleOptionId: Scalars['String']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  tickets?: InputMaybe<Array<InputMaybe<CreateOrderTicketInput>>>;
};

export type CreateOrderTicketInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundraiser?: InputMaybe<CreateOrderFundraiserInput>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  isForBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<CreateOrderQuestionInput>>>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderWonLiveAuctionItemInput = {
  amount: Scalars['Float']['input'];
  fundraiserId: Scalars['String']['input'];
  liveAuctionItemId: Scalars['String']['input'];
};

export type CreateParticipantInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventTableId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<CreateParticipantQuestionInput>>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  ticketGroupId: Scalars['String']['input'];
  ticketStatus?: InputMaybe<TicketstatusEnumType>;
};

export type CreateParticipantQuestionInput = {
  answer: Scalars['SequelizeJSON']['input'];
  id: Scalars['String']['input'];
};

export type CreateRaffleOrderInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverFee: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  items: Array<CreateRaffleOrderItemInput>;
  lastName: Scalars['String']['input'];
  paymentToken: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  totalAmount: Scalars['String']['input'];
};

export type CreateRaffleOrderItemInput = {
  entries: Scalars['Int']['input'];
  raffleId: Scalars['String']['input'];
};

export type CreateRaffleOrderResult = PayableResult & {
  __typename?: 'CreateRaffleOrderResult';
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  raffleOrderId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateSponsorInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  confirmationTokenId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
  paymentType: SponsorpaymentTypeEnumType;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<CreateSponsorQuestionInput>>>;
  registrationTypeId: Scalars['String']['input'];
  sendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorBuyerId?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  totalAmount: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSponsorQuestionInput = {
  answer: Scalars['SequelizeJSON']['input'];
  id: Scalars['String']['input'];
};

export type CreateSponsorResult = PayableResult & {
  __typename?: 'CreateSponsorResult';
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomBlockCampaignWidget = CampaignWidget & {
  __typename?: 'CustomBlockCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type CustomTextBlock = {
  __typename?: 'CustomTextBlock';
  /** Block alignment. Choices are left and center */
  alignment: CustomTextBlockalignmentEnumType;
  backgroundColor: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']['output']>;
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isBottomPaddingEnabled: Scalars['Boolean']['output'];
  isTopPaddingEnabled: Scalars['Boolean']['output'];
  /** Block template/layout: choices are text_top and text_bottom */
  layout: CustomTextBlocklayoutEnumType;
  /** JSON object with properties about the media  */
  mediaProperties?: Maybe<Scalars['SequelizeJSON']['output']>;
  /** Type of media: choices are image and video */
  mediaType?: Maybe<CustomTextBlockmediaTypeEnumType>;
  /** Text body */
  text?: Maybe<Scalars['SequelizeJSON']['output']>;
  textColor: Scalars['String']['output'];
  /** Title for the text block widget */
  title?: Maybe<Scalars['String']['output']>;
  titleColor: Scalars['String']['output'];
  type: CustomTextBlocktypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type CustomTextBlockInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  /** Block alignment. Choices are left and center */
  alignment?: InputMaybe<CustomTextBlockalignmentEnumType>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  campaignPageId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isBottomPaddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isTopPaddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Block template/layout: choices are text_top and text_bottom */
  layout?: InputMaybe<CustomTextBlocklayoutEnumType>;
  /** JSON object with properties about the media  */
  mediaProperties?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  /** Type of media: choices are image and video */
  mediaType?: InputMaybe<CustomTextBlockmediaTypeEnumType>;
  /** Text body */
  text?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  /** Title for the text block widget */
  title?: InputMaybe<Scalars['String']['input']>;
  titleColor?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomTextBlocktypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum CustomTextBlockalignmentEnumType {
  Center = 'center',
  Left = 'left'
}

export enum CustomTextBlocklayoutEnumType {
  TextBottom = 'text_bottom',
  TextTop = 'text_top'
}

export enum CustomTextBlockmediaTypeEnumType {
  Image = 'image',
  Video = 'video'
}

export enum CustomTextBlocktypeEnumType {
  Campaign = 'campaign',
  Fundraiser = 'fundraiser',
  Team = 'team'
}

export enum CustomizableMessageTypeEnum {
  AuctionBidderWelcome = 'auctionBidderWelcome',
  FlatReceipt = 'flatReceipt',
  FundraiserLaunch = 'fundraiserLaunch',
  OrderReceipt = 'orderReceipt',
  RaffleReceipt = 'raffleReceipt',
  SponsorReceipt = 'sponsorReceipt'
}

export type DiscountCode = {
  __typename?: 'DiscountCode';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  discountType: DiscountCodediscountTypeEnumType;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  qtyTotal?: Maybe<Scalars['Int']['output']>;
  qtyUsed: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  value: Scalars['String']['output'];
};

export type DiscountCodeInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  discountType?: InputMaybe<DiscountCodediscountTypeEnumType>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  qtyTotal?: InputMaybe<Scalars['Int']['input']>;
  qtyUsed?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum DiscountCodediscountTypeEnumType {
  Flat = 'flat',
  Percent = 'percent'
}

export type Donation = {
  __typename?: 'Donation';
  activationData?: Maybe<Scalars['SequelizeJSON']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  charge: PayableCharge;
  chargeAmount?: Maybe<Scalars['String']['output']>;
  chargeDate?: Maybe<Scalars['Date']['output']>;
  chargeNet?: Maybe<Scalars['String']['output']>;
  chargeStatus?: Maybe<ChargeStatus>;
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coveredFees: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  didCoverFee?: Maybe<Scalars['Boolean']['output']>;
  didCoverPlatformFee: Scalars['Boolean']['output'];
  didCoverProcessorFee: Scalars['Boolean']['output'];
  discountCode?: Maybe<DiscountCode>;
  discountCodeId?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  donationMatches?: Maybe<Array<Maybe<DonationMatch>>>;
  donationScope?: Maybe<DonationdonationScopeEnumType>;
  donationType?: Maybe<DonationType>;
  donationTypeCode: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  estimatedAmount: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId?: Maybe<Scalars['String']['output']>;
  givingPlan?: Maybe<GivingPlan>;
  givingPlanId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  need?: Maybe<Need>;
  needId?: Maybe<Scalars['String']['output']>;
  offlinePaymentDate?: Maybe<Scalars['String']['output']>;
  offlinePaymentType?: Maybe<DonationofflinePaymentTypeEnumType>;
  offlineReferenceNumber?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodExpMonth?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpYear?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpiration?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platformFee: Scalars['String']['output'];
  platformFeePercent: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  processorFeePercent: Scalars['String']['output'];
  registrationType?: Maybe<RegistrationType>;
  registrationTypeId?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<Maybe<DonationReply>>>;
  searchText?: Maybe<Scalars['String']['output']>;
  stateProv?: Maybe<Scalars['String']['output']>;
  status: DonationstatusEnumType;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  thankedAt?: Maybe<Scalars['Date']['output']>;
  thankedBy?: Maybe<User>;
  thankedById?: Maybe<Scalars['String']['output']>;
  tip: Scalars['String']['output'];
  tipBasis: Scalars['String']['output'];
  totalPledgeAmount?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type DonationAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type DonationDonationMatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type DonationRepliesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type DonationButtonEmbedWidget = EmbedWidget & {
  __typename?: 'DonationButtonEmbedWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: EmbedWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type DonationCreatedActivity = ItemActivity & {
  __typename?: 'DonationCreatedActivity';
  donation: Donation;
  timestamp: Scalars['Date']['output'];
};

export type DonationFormEmbedWidget = EmbedWidget & {
  __typename?: 'DonationFormEmbedWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: EmbedWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type DonationInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  activationData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<InputMaybe<QuestionAnswerInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coveredFees?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  didCoverFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  discountCodeId?: InputMaybe<Scalars['String']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  donationMatches?: InputMaybe<Array<InputMaybe<DonationMatchInput>>>;
  donationScope?: InputMaybe<DonationdonationScopeEnumType>;
  donationTypeCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedAmount?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  givingPlanId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needId?: InputMaybe<Scalars['String']['input']>;
  offlinePaymentDate?: InputMaybe<Scalars['String']['input']>;
  offlinePaymentType?: InputMaybe<DonationofflinePaymentTypeEnumType>;
  offlineReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodBrand?: InputMaybe<Scalars['String']['input']>;
  paymentMethodExpMonth?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpYear?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  platformFeePercent?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorFeePercent?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  replies?: InputMaybe<Array<InputMaybe<DonationReplyInput>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DonationstatusEnumType>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  thankedAt?: InputMaybe<Scalars['Date']['input']>;
  thankedById?: InputMaybe<Scalars['String']['input']>;
  tip?: InputMaybe<Scalars['String']['input']>;
  tipBasis?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationMatch = {
  __typename?: 'DonationMatch';
  amount: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  donation?: Maybe<Donation>;
  donationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  match?: Maybe<Match>;
  matchId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type DonationMatchInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  matchId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type DonationReply = {
  __typename?: 'DonationReply';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  donation?: Maybe<Donation>;
  donationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reply: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type DonationReplyInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reply?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type DonationResult = PayableResult & {
  __typename?: 'DonationResult';
  donationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DonationSearchResult = SearchResult & {
  __typename?: 'DonationSearchResult';
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export type DonationTable = {
  __typename?: 'DonationTable';
  count: Scalars['Int']['output'];
  rows: Array<Donation>;
};

export type DonationType = {
  __typename?: 'DonationType';
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum DonationTypeEnum {
  CommitmentFlat = 'commitment_flat',
  Flat = 'flat',
  NeedFlat = 'need_flat',
  Pledge = 'pledge',
  RecurringFlat = 'recurring_flat',
  Registration = 'registration'
}

export enum DonationdonationScopeEnumType {
  Campaign = 'campaign',
  Fundraiser = 'fundraiser',
  Team = 'team'
}

export enum DonationofflinePaymentTypeEnumType {
  Cash = 'cash',
  Check = 'check',
  Other = 'other'
}

export type DonationsCampaignWidget = CampaignWidget & {
  __typename?: 'DonationsCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export enum DonationstatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  Pending = 'pending'
}

export type EmailCustomization = {
  __typename?: 'EmailCustomization';
  campaignId: Scalars['String']['output'];
  customData: Scalars['SequelizeJSON']['output'];
  messageType: CustomizableMessageTypeEnum;
};

export type EmbedWidget = {
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: EmbedWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type EmbedWidgetInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EmbedWidgettypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum EmbedWidgettypeEnumType {
  DonationButton = 'donationButton',
  DonationForm = 'donationForm'
}

export type EventAttendee = Fundraiser | TicketGroupGuest;

export type EventAttendeeSeating = {
  __typename?: 'EventAttendeeSeating';
  attendee?: Maybe<EventAttendee>;
  eventTable?: Maybe<EventTable>;
  isSeated: Scalars['Boolean']['output'];
};

export type EventDetailsCampaignWidget = CampaignWidget & {
  __typename?: 'EventDetailsCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type EventTable = {
  __typename?: 'EventTable';
  EventTableSponsor?: Maybe<EventTableSponsor>;
  EventTableTicketGroup?: Maybe<EventTableTicketGroup>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Maybe<Fundraiser>>>;
  seatsUsed: Scalars['Int']['output'];
  sponsorReservations?: Maybe<Array<Maybe<Sponsor>>>;
  tableNumber: Scalars['Int']['output'];
  ticketGroupReservations?: Maybe<Array<Maybe<TicketGroup>>>;
  totalSeats: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type EventTableParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type EventTableSponsorReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type EventTableTicketGroupReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type EventTableInput = {
  EventTableSponsor?: InputMaybe<EventTableSponsorInput>;
  EventTableTicketGroup?: InputMaybe<EventTableTicketGroupInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  sponsorReservations?: InputMaybe<Array<InputMaybe<SponsorInput>>>;
  ticketGroupReservations?: InputMaybe<Array<InputMaybe<TicketGroupInput>>>;
  totalSeats?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type EventTableSponsor = {
  __typename?: 'EventTableSponsor';
  createdAt: Scalars['Date']['output'];
  eventTable?: Maybe<EventTable>;
  eventTableId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  seatsReserved: Scalars['Int']['output'];
  sponsor?: Maybe<Sponsor>;
  sponsorId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type EventTableSponsorInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  eventTableId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  seatsReserved?: InputMaybe<Scalars['Int']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type EventTableTicketGroup = {
  __typename?: 'EventTableTicketGroup';
  createdAt: Scalars['Date']['output'];
  eventTable?: Maybe<EventTable>;
  eventTableId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  seatsReserved: Scalars['Int']['output'];
  ticketGroup?: Maybe<TicketGroup>;
  ticketGroupId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type EventTableTicketGroupInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  eventTableId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  seatsReserved?: InputMaybe<Scalars['Int']['input']>;
  ticketGroupId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type Fundraiser = {
  __typename?: 'Fundraiser';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  aggregatedPerformanceResult: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  amountRaised: Scalars['String']['output'];
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  avatarImage?: Maybe<Scalars['String']['output']>;
  awardedAchievements?: Maybe<Array<Maybe<AwardedAchievement>>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  charge: PayableCharge;
  city?: Maybe<Scalars['String']['output']>;
  commitmentAmount?: Maybe<Scalars['Int']['output']>;
  commitmentAmountRemaining?: Maybe<Scalars['String']['output']>;
  commitmentAmountWaived?: Maybe<Scalars['String']['output']>;
  commitmentDonation?: Maybe<Donation>;
  commitmentDonationId?: Maybe<Scalars['String']['output']>;
  commitmentNote?: Maybe<Scalars['SequelizeJSON']['output']>;
  commitmentStatus?: Maybe<FundraiserCommitmentStatusEnum>;
  contactCount: Scalars['Int']['output'];
  contacts?: Maybe<Array<Maybe<Contact>>>;
  convertToFundraiserUnits: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  coveredFees: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  dailyStats: Array<Maybe<FundraiserDailyStats>>;
  deductibleAmount?: Maybe<Scalars['String']['output']>;
  didCoverFee?: Maybe<Scalars['Boolean']['output']>;
  didCoverPlatformFee: Scalars['Boolean']['output'];
  didCoverProcessorFee: Scalars['Boolean']['output'];
  discountAmount: Scalars['String']['output'];
  displayId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  donatedToSelf: Scalars['Boolean']['output'];
  donationCount: Scalars['Int']['output'];
  donations?: Maybe<Array<Maybe<Donation>>>;
  email?: Maybe<Scalars['String']['output']>;
  enabledFeatures: Scalars['SequelizeJSON']['output'];
  estimatedAmountRaised?: Maybe<Scalars['String']['output']>;
  eventNumber?: Maybe<Scalars['Int']['output']>;
  eventOrder?: Maybe<Order>;
  eventOrderId?: Maybe<Scalars['String']['output']>;
  eventTable?: Maybe<EventTable>;
  eventTableId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fundraisingUpdateCount: Scalars['Int']['output'];
  hasRejoined?: Maybe<Scalars['Boolean']['output']>;
  headerImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  intervalReminderOffset?: Maybe<Scalars['Int']['output']>;
  intervalReminders?: Maybe<Array<Maybe<IntervalReminder>>>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoicingStatus: FundraiserinvoicingStatusEnumType;
  isCoveringFees: Scalars['Boolean']['output'];
  isForBuyer: Scalars['Boolean']['output'];
  isPerformanceClosing: Scalars['Boolean']['output'];
  isTeamCaptain?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Required monetary goal for the Fundraiser (in whole dollars). Defaults to 1000 */
  monetaryGoal: Scalars['Int']['output'];
  myPermissions?: Maybe<Array<Scalars['String']['output']>>;
  nonDeductibleAmount?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  originalAmount: Scalars['String']['output'];
  outstandingPledgeAmount: Scalars['String']['output'];
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodExpMonth?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpYear?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpiration?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  paymentProcessorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  paymentProcessorType?: Maybe<FundraiserpaymentProcessorTypeEnumType>;
  paymentSourceData?: Maybe<Scalars['SequelizeJSON']['output']>;
  paymentSourceKey?: Maybe<Scalars['String']['output']>;
  performanceEstimate?: Maybe<Scalars['Int']['output']>;
  performanceSettings?: Maybe<PerformanceSettings>;
  performanceWorth?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platformFee: Scalars['String']['output'];
  platformFeePercent: Scalars['String']['output'];
  pledgePresets?: Maybe<Array<Scalars['String']['output']>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  potentialContacts?: Maybe<Array<Maybe<PotentialContact>>>;
  processorFeePercent: Scalars['String']['output'];
  registrationType?: Maybe<RegistrationType>;
  registrationTypeId?: Maybe<Scalars['String']['output']>;
  resolvedEmail?: Maybe<Scalars['String']['output']>;
  resolvedName?: Maybe<Scalars['String']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  sendingReminder: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  stateProv?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<FundraisingStats>;
  status: FundraiserstatusEnumType;
  /** Stored in AST */
  story?: Maybe<Scalars['SequelizeJSON']['output']>;
  storyTitle?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  teamJoinedAt?: Maybe<Scalars['Date']['output']>;
  ticketGroup?: Maybe<TicketGroup>;
  ticketGroupId?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['String']['output']>;
  ticketStatus: FundraiserticketStatusEnumType;
  totalFlatAmount: Scalars['String']['output'];
  totalMatchAmount: Scalars['String']['output'];
  totalOfflineFlatAmount: Scalars['String']['output'];
  totalPledgeAmount: Scalars['String']['output'];
  totalPledgeValue: Scalars['String']['output'];
  totalRegistrationAmount: Scalars['String']['output'];
  totalSponsorAmount: Scalars['String']['output'];
  type: FundraisertypeEnumType;
  unlockedActivityMetric?: Maybe<ActivityMetric>;
  unlockedActivityMetricId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  updates?: Maybe<Array<Maybe<FundraisingUpdate>>>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type FundraiserAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type FundraiserAwardedAchievementsArgs = {
  achievementCode?: InputMaybe<Scalars['String']['input']>;
};


export type FundraiserContactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type FundraiserConvertToFundraiserUnitsArgs = {
  value: Scalars['Float']['input'];
};


export type FundraiserDailyStatsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type FundraiserDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type FundraiserFundraisingUpdateCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type FundraiserIntervalRemindersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type FundraiserUpdatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type FundraiserAchievement = {
  __typename?: 'FundraiserAchievement';
  AchievementLevelId?: Maybe<Scalars['String']['output']>;
  achievedLevel?: Maybe<AchievementLevel>;
  achievedLevelId?: Maybe<Scalars['String']['output']>;
  achievement?: Maybe<Achievement>;
  achievementCode: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  seenAt?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  value: Scalars['Int']['output'];
};

export type FundraiserAchievementInput = {
  AchievementLevelId?: InputMaybe<Scalars['String']['input']>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  achievedLevelId?: InputMaybe<Scalars['String']['input']>;
  achievementCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  seenAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type FundraiserDailyStats = {
  __typename?: 'FundraiserDailyStats';
  amountRaised: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  donationCount: Scalars['Int']['output'];
  invitedDonors: Scalars['Int']['output'];
  participantAmount: Scalars['Float']['output'];
  participantCount: Scalars['Int']['output'];
  performanceResult: Scalars['Float']['output'];
};

export type FundraiserInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<InputMaybe<QuestionAnswerInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  commitmentAmountRemaining?: InputMaybe<Scalars['String']['input']>;
  commitmentAmountWaived?: InputMaybe<Scalars['String']['input']>;
  commitmentDonationId?: InputMaybe<Scalars['String']['input']>;
  commitmentNote?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  commitmentStatus?: InputMaybe<FundraiserCommitmentStatusInputEnum>;
  contacts?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  coveredFees?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deductibleAmount?: InputMaybe<Scalars['String']['input']>;
  didCoverFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  donations?: InputMaybe<Array<InputMaybe<DonationInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabledFeatures?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  eventNumber?: InputMaybe<Scalars['Int']['input']>;
  eventOrderId?: InputMaybe<Scalars['String']['input']>;
  eventTableId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intervalReminderOffset?: InputMaybe<Scalars['Int']['input']>;
  intervalReminders?: InputMaybe<Array<InputMaybe<IntervalReminderInput>>>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  invoicingStatus?: InputMaybe<FundraiserinvoicingStatusEnumType>;
  isCoveringFees?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamCaptain?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Required monetary goal for the Fundraiser (in whole dollars). Defaults to 1000 */
  monetaryGoal?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodBrand?: InputMaybe<Scalars['String']['input']>;
  paymentMethodExpMonth?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpYear?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  paymentProcessorData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  paymentProcessorType?: InputMaybe<FundraiserpaymentProcessorTypeEnumType>;
  paymentSourceData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  paymentSourceKey?: InputMaybe<Scalars['String']['input']>;
  performanceEstimate?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  platformFeePercent?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorFeePercent?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  sendingReminder?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FundraiserstatusEnumType>;
  /** Stored in AST */
  story?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  storyTitle?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  ticketGroupId?: InputMaybe<Scalars['String']['input']>;
  ticketStatus?: InputMaybe<FundraiserticketStatusEnumType>;
  unlockedActivityMetricId?: InputMaybe<Scalars['String']['input']>;
  updates?: InputMaybe<Array<InputMaybe<FundraisingUpdateInput>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FundraiserSearchResult = SearchResult & {
  __typename?: 'FundraiserSearchResult';
  avatarImage?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  resolvedName: Scalars['String']['output'];
  searchText: Scalars['String']['output'];
  teamId?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  type: SearchResultTypeEnum;
};

export enum FundraiserinvoicingStatusEnumType {
  Complete = 'complete',
  InProgress = 'in_progress',
  Partial = 'partial',
  Pending = 'pending'
}

export enum FundraiserpaymentProcessorTypeEnumType {
  Stripe = 'stripe'
}

export enum FundraiserstatusEnumType {
  Active = 'active',
  Confirmed = 'confirmed',
  Deleted = 'deleted',
  Invoiced = 'invoiced',
  Pending = 'pending'
}

export enum FundraiserticketStatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  CheckedIn = 'checked_in'
}

export enum FundraisertypeEnumType {
  Fundraiser = 'fundraiser',
  TicketOnly = 'ticket_only'
}

export type FundraisingStats = {
  __typename?: 'FundraisingStats';
  actualAmountRaised?: Maybe<Scalars['String']['output']>;
  aggregatedPerformanceResult?: Maybe<Scalars['Float']['output']>;
  deprecatedAggregatedPerformanceResult?: Maybe<Scalars['Float']['output']>;
  estimatedAmountRaised?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  percentOfMonetaryGoal?: Maybe<Scalars['String']['output']>;
  pledgeValue?: Maybe<Scalars['String']['output']>;
};

export type FundraisingUpdate = {
  __typename?: 'FundraisingUpdate';
  clapCounter: Scalars['Int']['output'];
  commentCounter: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  cryCounter: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  embeddedMedia?: Maybe<Scalars['SequelizeJSON']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId: Scalars['String']['output'];
  hahaCounter: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  likeCounter: Scalars['Int']['output'];
  loveCounter: Scalars['Int']['output'];
  /** Stored in AST */
  message?: Maybe<Scalars['SequelizeJSON']['output']>;
  myReaction?: Maybe<ReactionreactionTypeEnumType>;
  performanceUnits?: Maybe<Scalars['String']['output']>;
  reactions?: Maybe<Array<Maybe<Reaction>>>;
  shouldSendToDonors?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stravaActivity?: Maybe<Scalars['JSONObject']['output']>;
  type?: Maybe<FundraisingUpdatetypeEnumType>;
  updatedAt: Scalars['Date']['output'];
  wowCounter: Scalars['Int']['output'];
  yayCounter: Scalars['Int']['output'];
};


export type FundraisingUpdateReactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type FundraisingUpdateActivity = ItemActivity & {
  __typename?: 'FundraisingUpdateActivity';
  fundraisingUpdate: FundraisingUpdate;
  timestamp: Scalars['Date']['output'];
};

export type FundraisingUpdateInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  commentCounter?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  embeddedMedia?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stored in AST */
  message?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  performanceUnits?: InputMaybe<Scalars['String']['input']>;
  reactions?: InputMaybe<Array<InputMaybe<ReactionInput>>>;
  shouldSendToDonors?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FundraisingUpdatetypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum FundraisingUpdatetypeEnumType {
  Fundraising = 'fundraising',
  Performance = 'performance'
}

export type GatewayServiceRoot = {
  __typename?: 'GatewayServiceRoot';
  timeout: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};


export type GatewayServiceRootTimeoutArgs = {
  duration: Scalars['Int']['input'];
};

export type GivingPlan = {
  __typename?: 'GivingPlan';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  charge: PayableCharge;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coveredFees: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  didCoverFee?: Maybe<Scalars['Boolean']['output']>;
  didCoverPlatformFee: Scalars['Boolean']['output'];
  didCoverProcessorFee: Scalars['Boolean']['output'];
  donations?: Maybe<Array<Maybe<Donation>>>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  frequency: GivingPlanfrequencyEnumType;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isProcessing: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  lifetimeAmount: Scalars['String']['output'];
  nextChargeDate?: Maybe<Scalars['Date']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodExpMonth?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpYear?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpiration?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platformFee: Scalars['String']['output'];
  platformFeePercent: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  processorFeePercent: Scalars['String']['output'];
  searchText?: Maybe<Scalars['String']['output']>;
  stateProv?: Maybe<Scalars['String']['output']>;
  status: GivingPlanstatusEnumType;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type GivingPlanDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type GivingPlanInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coveredFees?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  didCoverFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  donations?: InputMaybe<Array<InputMaybe<DonationInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<GivingPlanfrequencyEnumType>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nextChargeDate?: InputMaybe<Scalars['Date']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodBrand?: InputMaybe<Scalars['String']['input']>;
  paymentMethodExpMonth?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpYear?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  platformFeePercent?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorFeePercent?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GivingPlanstatusEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum GivingPlanfrequencyEnumType {
  Daily = 'daily',
  Hourly = 'hourly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export enum GivingPlanstatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  Failed = 'failed',
  Failing = 'failing',
  Pending = 'pending'
}

export enum GivingVoucherEnum {
  Donation = 'Donation',
  Order = 'Order'
}

export type GlobalQuestion = {
  __typename?: 'GlobalQuestion';
  assignableAudiences: Scalars['SequelizeJSON']['output'];
  config: Scalars['SequelizeJSON']['output'];
  createdAt: Scalars['Date']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  localQuestions?: Maybe<Array<Maybe<Question>>>;
  options?: Maybe<Array<Maybe<GlobalQuestionOption>>>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  shouldAddToNewCampaigns: Scalars['Boolean']['output'];
  type: GlobalQuestiontypeEnumType;
  updatedAt: Scalars['Date']['output'];
};


export type GlobalQuestionLocalQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type GlobalQuestionOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type GlobalQuestionInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  assignableAudiences?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  config?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  localQuestions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  options?: InputMaybe<Array<InputMaybe<GlobalQuestionOptionInput>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  shouldAddToNewCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<GlobalQuestiontypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type GlobalQuestionOption = {
  __typename?: 'GlobalQuestionOption';
  createdAt: Scalars['Date']['output'];
  globalQuestion?: Maybe<GlobalQuestion>;
  globalQuestionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  localQuestionOptions?: Maybe<Array<Maybe<QuestionOption>>>;
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type GlobalQuestionOptionLocalQuestionOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type GlobalQuestionOptionInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  globalQuestionId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  localQuestionOptions?: InputMaybe<Array<InputMaybe<QuestionOptionInput>>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum GlobalQuestiontypeEnumType {
  Address = 'address',
  Choice = 'choice',
  Currency = 'currency',
  Date = 'date',
  Number = 'number',
  Phone = 'phone',
  TextMultipleLine = 'text_multiple_line',
  TextSingleLine = 'text_single_line',
  WaiverSimple = 'waiver_simple',
  YesNo = 'yes_no'
}

export type GroupLeaderboardCampaignWidget = CampaignWidget & {
  __typename?: 'GroupLeaderboardCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  groups: Array<Maybe<GroupLeaderboardGroup>>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  question?: Maybe<Question>;
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};


export type GroupLeaderboardCampaignWidgetGroupsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type GroupLeaderboardGroup = {
  __typename?: 'GroupLeaderboardGroup';
  estimatedAmountRaised?: Maybe<Scalars['String']['output']>;
  fundraisers?: Maybe<Array<Maybe<Fundraiser>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  performanceUnits?: Maybe<Scalars['Float']['output']>;
};


export type GroupLeaderboardGroupFundraisersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export enum HeroStyleEnum {
  Basic = 'basic',
  Cover = 'cover'
}

export type ImageGalleryCampaignWidget = CampaignWidget & {
  __typename?: 'ImageGalleryCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type ImpactStoriesCampaignWidget = CampaignWidget & {
  __typename?: 'ImpactStoriesCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type IntervalReminder = {
  __typename?: 'IntervalReminder';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  type?: Maybe<IntervalRemindertypeEnumType>;
  updatedAt: Scalars['Date']['output'];
};

export type IntervalReminderInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<IntervalRemindertypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum IntervalRemindertypeEnumType {
  Closeout = 'closeout',
  Final = 'final',
  FinishedEarly = 'finishedEarly',
  FirstDay = 'firstDay',
  LastDay = 'lastDay',
  Rejoin = 'rejoin',
  Reminder = 'reminder',
  Update = 'update'
}

export type ItemActivity = {
  timestamp: Scalars['Date']['output'];
};

export type LeaderboardCampaignWidget = CampaignWidget & {
  __typename?: 'LeaderboardCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type LikeFundraisingUpdateSuccess = {
  __typename?: 'LikeFundraisingUpdateSuccess';
  newCount?: Maybe<Scalars['Int']['output']>;
};

export type LiveAuctionItem = {
  __typename?: 'LiveAuctionItem';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  wonLiveAuctionItems?: Maybe<Array<Maybe<WonLiveAuctionItem>>>;
};


export type LiveAuctionItemWonLiveAuctionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type LiveAuctionItemInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  wonLiveAuctionItems?: InputMaybe<Array<InputMaybe<WonLiveAuctionItemInput>>>;
};

export type LiveDisplay = {
  __typename?: 'LiveDisplay';
  auctionShowBidQRCode: Scalars['Boolean']['output'];
  auctionShowEstimatedRaised: Scalars['Boolean']['output'];
  auctionShowItems: Scalars['Boolean']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  fundraisingDisplayGoal?: Maybe<Scalars['Int']['output']>;
  fundraisingShowAmountRaised: Scalars['Boolean']['output'];
  fundraisingShowDonateQRCode: Scalars['Boolean']['output'];
  fundraisingShowDonationFeed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  leaderboardShowIndividuals: Scalars['Boolean']['output'];
  leaderboardShowTeams: Scalars['Boolean']['output'];
  leaderboardType: LiveDisplayleaderboardTypeEnumType;
  name: Scalars['String']['output'];
  theme: LiveDisplaythemeEnumType;
  type: LiveDisplaytypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type LiveDisplayInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  auctionShowBidQRCode?: InputMaybe<Scalars['Boolean']['input']>;
  auctionShowEstimatedRaised?: InputMaybe<Scalars['Boolean']['input']>;
  auctionShowItems?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fundraisingDisplayGoal?: InputMaybe<Scalars['Int']['input']>;
  fundraisingShowAmountRaised?: InputMaybe<Scalars['Boolean']['input']>;
  fundraisingShowDonateQRCode?: InputMaybe<Scalars['Boolean']['input']>;
  fundraisingShowDonationFeed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  leaderboardShowIndividuals?: InputMaybe<Scalars['Boolean']['input']>;
  leaderboardShowTeams?: InputMaybe<Scalars['Boolean']['input']>;
  leaderboardType?: InputMaybe<LiveDisplayleaderboardTypeEnumType>;
  name?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<LiveDisplaythemeEnumType>;
  type?: InputMaybe<LiveDisplaytypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum LiveDisplayleaderboardTypeEnumType {
  Performance = 'performance',
  Raised = 'raised'
}

export enum LiveDisplaythemeEnumType {
  Dark = 'dark',
  Light = 'light'
}

export enum LiveDisplaytypeEnumType {
  Auction = 'auction',
  Fundraising = 'fundraising',
  Leaderboard = 'leaderboard'
}

export enum LoginService {
  Facebook = 'facebook'
}

export type LoginSuccess = {
  __typename?: 'LoginSuccess';
  token?: Maybe<Scalars['String']['output']>;
};

export type LogoGridCampaignWidget = CampaignWidget & {
  __typename?: 'LogoGridCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type Match = {
  __typename?: 'Match';
  CampaignId?: Maybe<Scalars['String']['output']>;
  amountRemaining?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  donationMatches?: Maybe<Array<Maybe<DonationMatch>>>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  maxAmount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  status: MatchStatusEnum;
  updatedAt: Scalars['Date']['output'];
};


export type MatchDonationMatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type MatchInput = {
  CampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amountRemaining?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  donationMatches?: InputMaybe<Array<InputMaybe<DonationMatchInput>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum MatchStatusEnum {
  Active = 'active',
  Depleted = 'depleted',
  Ended = 'ended',
  NotStarted = 'notStarted'
}

export type MessageDeliveryInfo = {
  __typename?: 'MessageDeliveryInfo';
  deliveryRate?: Maybe<Scalars['Float']['output']>;
  openRate?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
};

export type MessagePreview = {
  __typename?: 'MessagePreview';
  html?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MessageServiceRootQuery = {
  __typename?: 'MessageServiceRootQuery';
  messagePreview?: Maybe<MessagePreview>;
  version: Scalars['String']['output'];
};


export type MessageServiceRootQueryMessagePreviewArgs = {
  data: Scalars['JSONObject']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export enum ModelValidationSchema {
  CampaignMetadata = 'CampaignMetadata'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptAdminInvite: ValidateAdminInviteResponseEnum;
  acceptSponsorCashPayment: Scalars['Boolean']['output'];
  addFundraiser?: Maybe<Fundraiser>;
  addLiveAuctionWinner: Order;
  addNeedCommitments: AddNeedCommitmentsResult;
  addUserRole?: Maybe<Scalars['Boolean']['output']>;
  answerQuestion: Scalars['Boolean']['output'];
  assignGlobalQuestions?: Maybe<Scalars['Boolean']['output']>;
  calculateDonationFees: Scalars['String']['output'];
  calculateRaffleOrderAmount: CalculateRaffleOrderResult;
  calculateRegistrationAmount: RegistrationAmount;
  calculateSponsorAmount: SponsorAmount;
  cancelAuctionItem?: Maybe<Scalars['Int']['output']>;
  cancelContactReminders: Contact;
  cancelPledge: Donation;
  changePassword?: Maybe<Scalars['Boolean']['output']>;
  chargeCommitment: ChargeCommitmentResult;
  chargeSponsor: ChargeSponsorResult;
  claimFundraiser?: Maybe<Fundraiser>;
  completeOrder: OrderResult;
  connectDoubleTheDonation: Scalars['Boolean']['output'];
  /** Create ActivityMetric */
  createActivityMetric?: Maybe<ActivityMetric>;
  createAdminInvite?: Maybe<AdminInvite>;
  /** Create Auction */
  createAuction?: Maybe<Auction>;
  createAuctionBid: BidResult;
  createAuctionBidder: AuctionBidderResult;
  /** Create AuctionCategory */
  createAuctionCategory?: Maybe<AuctionCategory>;
  /** Create AuctionItem */
  createAuctionItem?: Maybe<AuctionItem>;
  /** Create AuctionItemImage */
  createAuctionItemImage?: Maybe<AuctionItemImage>;
  /** Create Campaign */
  createCampaign?: Maybe<Campaign>;
  /** Create CampaignMessage */
  createCampaignMessage?: Maybe<CampaignMessage>;
  /** Create CampaignMessageAudience */
  createCampaignMessageAudience?: Maybe<CampaignMessageAudience>;
  /** Create CampaignMetadata */
  createCampaignMetadata?: Maybe<CampaignMetadata>;
  /** Create CampaignPage */
  createCampaignPage?: Maybe<CampaignPage>;
  /** Create CampaignWidget */
  createCampaignWidget?: Maybe<CampaignWidget>;
  /** Create Contact */
  createContact?: Maybe<Contact>;
  createContactsAndSend?: Maybe<Fundraiser>;
  createCustomTextBlock?: Maybe<CustomTextBlock>;
  /** Create DiscountCode */
  createDiscountCode?: Maybe<DiscountCode>;
  createDonation: DonationResult;
  /** Create DonationReply */
  createDonationReply?: Maybe<DonationReply>;
  /** Create EmbedWidget */
  createEmbedWidget?: Maybe<EmbedWidget>;
  /** Create EventTable */
  createEventTable?: Maybe<EventTable>;
  /** Create EventTableSponsor */
  createEventTableSponsor?: Maybe<EventTableSponsor>;
  /** Create EventTableTicketGroup */
  createEventTableTicketGroup?: Maybe<EventTableTicketGroup>;
  /** Create Fundraiser */
  createFundraiser?: Maybe<Fundraiser>;
  /** Create FundraisingUpdate */
  createFundraisingUpdate?: Maybe<FundraisingUpdate>;
  /** Create GlobalQuestion */
  createGlobalQuestion?: Maybe<GlobalQuestion>;
  /** Create IntervalReminder */
  createIntervalReminder?: Maybe<IntervalReminder>;
  /** Create LiveAuctionItem */
  createLiveAuctionItem?: Maybe<LiveAuctionItem>;
  /** Create LiveDisplay */
  createLiveDisplay?: Maybe<LiveDisplay>;
  createManyEventTables: Array<EventTable>;
  /** Create Match */
  createMatch?: Maybe<Match>;
  /** Create Need */
  createNeed?: Maybe<Need>;
  createOfflineDonation: Donation;
  createOrUpdateEmailCustomization?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use the 'slug' property on the input of update mutations */
  createOrUpdateSlug?: Maybe<Scalars['Boolean']['output']>;
  createOrder: OrderResult;
  /** Create Organization */
  createOrganization?: Maybe<Organization>;
  createOrganizationSubscriptionCheckoutSession: OrganizationSubscriptionSessionResult;
  createOrganizationSubscriptionManageSession: OrganizationSubscriptionSessionResult;
  createParticipant?: Maybe<Fundraiser>;
  /** Create Product */
  createProduct?: Maybe<Product>;
  /** Create ProductVariant */
  createProductVariant?: Maybe<ProductVariant>;
  createProgram?: Maybe<Program>;
  /** Create Question */
  createQuestion?: Maybe<Question>;
  /** Create QuestionOption */
  createQuestionOption?: Maybe<QuestionOption>;
  /** Create QuestionRegistrationType */
  createQuestionRegistrationType?: Maybe<QuestionRegistrationType>;
  /** Create Raffle */
  createRaffle?: Maybe<Raffle>;
  createRaffleOrder: CreateRaffleOrderResult;
  /** Create RaffleWinningDraw */
  createRaffleWinningDraw?: Maybe<RaffleWinningDraw>;
  /** Create RegistrationType */
  createRegistrationType?: Maybe<RegistrationType>;
  /** Create ReportTemplate */
  createReportTemplate?: Maybe<ReportTemplate>;
  /** Create SoldTicketBundle */
  createSoldTicketBundle?: Maybe<SoldTicketBundle>;
  createSponsor: CreateSponsorResult;
  /** Create Team */
  createTeam?: Maybe<Team>;
  /** Create TeamMessageBoardPost */
  createTeamMessageBoardPost?: Maybe<TeamMessageBoardPost>;
  /** Create TipTapMigration */
  createTipTapMigration?: Maybe<TipTapMigration>;
  /** Create User */
  createUser?: Maybe<User>;
  deleteAdminInvite?: Maybe<Scalars['Int']['output']>;
  /** Delete AuctionCategory */
  deleteAuctionCategory?: Maybe<Scalars['Int']['output']>;
  /** Delete AuctionItem */
  deleteAuctionItem?: Maybe<Scalars['Int']['output']>;
  /** Delete AuctionItemImage */
  deleteAuctionItemImage?: Maybe<Scalars['Int']['output']>;
  /** Delete Campaign */
  deleteCampaign?: Maybe<Scalars['Int']['output']>;
  /** Delete CampaignMessage */
  deleteCampaignMessage?: Maybe<Scalars['Int']['output']>;
  /** Delete CampaignMessageAudience */
  deleteCampaignMessageAudience?: Maybe<Scalars['Int']['output']>;
  /** Delete CampaignMetadata */
  deleteCampaignMetadata?: Maybe<Scalars['Int']['output']>;
  /** Delete CampaignPage */
  deleteCampaignPage?: Maybe<Scalars['Int']['output']>;
  /** Delete CampaignWidget */
  deleteCampaignWidget?: Maybe<Scalars['Int']['output']>;
  /** Delete Contact */
  deleteContact?: Maybe<Scalars['Int']['output']>;
  deleteCustomTextBlock?: Maybe<Scalars['Int']['output']>;
  /** Delete DiscountCode */
  deleteDiscountCode?: Maybe<Scalars['Int']['output']>;
  deleteDonation?: Maybe<Scalars['Int']['output']>;
  /** Delete DonationReply */
  deleteDonationReply?: Maybe<Scalars['Int']['output']>;
  /** Delete EmbedWidget */
  deleteEmbedWidget?: Maybe<Scalars['Int']['output']>;
  /** Delete EventTable */
  deleteEventTable?: Maybe<Scalars['Int']['output']>;
  /** Delete EventTableSponsor */
  deleteEventTableSponsor?: Maybe<Scalars['Int']['output']>;
  /** Delete EventTableTicketGroup */
  deleteEventTableTicketGroup?: Maybe<Scalars['Int']['output']>;
  /** Delete Fundraiser */
  deleteFundraiser?: Maybe<Scalars['Int']['output']>;
  /** Delete FundraisingUpdate */
  deleteFundraisingUpdate?: Maybe<Scalars['Int']['output']>;
  /** Delete GlobalQuestion */
  deleteGlobalQuestion?: Maybe<Scalars['Int']['output']>;
  /** Delete IntervalReminder */
  deleteIntervalReminder?: Maybe<Scalars['Int']['output']>;
  /** Delete LiveAuctionItem */
  deleteLiveAuctionItem?: Maybe<Scalars['Int']['output']>;
  /** Delete LiveDisplay */
  deleteLiveDisplay?: Maybe<Scalars['Int']['output']>;
  /** Delete Need */
  deleteNeed?: Maybe<Scalars['Int']['output']>;
  deleteOrder?: Maybe<Scalars['Int']['output']>;
  /** Delete Product */
  deleteProduct?: Maybe<Scalars['Int']['output']>;
  /** Delete ProductVariant */
  deleteProductVariant?: Maybe<Scalars['Int']['output']>;
  deleteProgram: Scalars['Int']['output'];
  /** Delete Question */
  deleteQuestion?: Maybe<Scalars['Int']['output']>;
  /** Delete QuestionOption */
  deleteQuestionOption?: Maybe<Scalars['Int']['output']>;
  /** Delete QuestionRegistrationType */
  deleteQuestionRegistrationType?: Maybe<Scalars['Int']['output']>;
  /** Delete Raffle */
  deleteRaffle?: Maybe<Scalars['Int']['output']>;
  /** Delete RaffleWinningDraw */
  deleteRaffleWinningDraw?: Maybe<Scalars['Int']['output']>;
  /** Delete RegistrationType */
  deleteRegistrationType?: Maybe<Scalars['Int']['output']>;
  /** Delete ReportTemplate */
  deleteReportTemplate?: Maybe<Scalars['Int']['output']>;
  /** Delete SoldTicketBundle */
  deleteSoldTicketBundle?: Maybe<Scalars['Int']['output']>;
  /** Delete Sponsor */
  deleteSponsor?: Maybe<Scalars['Int']['output']>;
  deleteTeam?: Maybe<Scalars['Int']['output']>;
  /** Delete TeamMessageBoardPost */
  deleteTeamMessageBoardPost?: Maybe<Scalars['Int']['output']>;
  /** Delete TipTapMigration */
  deleteTipTapMigration?: Maybe<Scalars['Int']['output']>;
  disconnectDoubleTheDonation: Scalars['Boolean']['output'];
  drawRaffleWinner?: Maybe<RaffleOrder>;
  duplicateCampaign: Campaign;
  duplicateCampaignWidget: CampaignWidget;
  inviteTeamMember?: Maybe<Scalars['Boolean']['output']>;
  invoiceSponsor: Scalars['Boolean']['output'];
  /** @deprecated the setReaction mutation instead */
  likeFundraisingUpdate?: Maybe<LikeFundraisingUpdateSuccess>;
  login?: Maybe<LoginSuccess>;
  loginWithService?: Maybe<LoginSuccess>;
  logout?: Maybe<Scalars['Boolean']['output']>;
  reactivateGivingPlan: UpdatePaymentMethodResult;
  recreateTeam?: Maybe<Scalars['Boolean']['output']>;
  removeParticipantPayment?: Maybe<Scalars['Boolean']['output']>;
  removeUserRole?: Maybe<Scalars['Boolean']['output']>;
  resendAuctionItemReceipt?: Maybe<Scalars['Boolean']['output']>;
  resendCommitmentChargeFailedEmail?: Maybe<Scalars['Boolean']['output']>;
  resendFundraiserLaunchEmail?: Maybe<Scalars['Boolean']['output']>;
  resendGivingPlanManageLink?: Maybe<Scalars['Boolean']['output']>;
  resendOrderReceipt?: Maybe<Scalars['Boolean']['output']>;
  resendPledgeConfirmation?: Maybe<Scalars['Boolean']['output']>;
  resendReceipt?: Maybe<Scalars['Boolean']['output']>;
  resendSponsorInvoice: Scalars['Boolean']['output'];
  resendSponsorReceipt: Scalars['Boolean']['output'];
  retryChargeGivingPlan: RetryChargeGivingPlanResult;
  retryChargeWinnerForAuctionItem: RetryChargeAuctionWinnerResult;
  seatGuests?: Maybe<EventTableTicketGroup>;
  seatSponsorGuests?: Maybe<EventTableSponsor>;
  seeFundraiserAchievement: Scalars['Boolean']['output'];
  sendCampaignMessage: CampaignMessage;
  sendCampaignMessageTest: Scalars['Boolean']['output'];
  sendForgotPasswordToken?: Maybe<Scalars['Boolean']['output']>;
  sendFundraiserCommitmentNudge: Scalars['Boolean']['output'];
  sendOutstandingPledgeNudge: Array<Maybe<Scalars['String']['output']>>;
  sendTeamCaptainNudge: Scalars['Boolean']['output'];
  setAssignedActivityMetrics?: Maybe<Scalars['Int']['output']>;
  setForgottenPassword?: Maybe<LoginSuccess>;
  setReaction?: Maybe<ReactionWithToken>;
  thankDonor?: Maybe<Scalars['Boolean']['output']>;
  toggleMetaPixelIntegration: Scalars['Boolean']['output'];
  undeleteCampaign: Scalars['Int']['output'];
  undeleteProgram: Scalars['Int']['output'];
  unseatGuests?: Maybe<EventTableTicketGroup>;
  unseatSponsorGuests?: Maybe<EventTableSponsor>;
  /** Update AchievementLevel */
  updateAchievementLevel?: Maybe<AchievementLevel>;
  /** Update ActivityMetric */
  updateActivityMetric?: Maybe<ActivityMetric>;
  /** Update AddOn */
  updateAddOn?: Maybe<AddOn>;
  updateAdminInvite?: Maybe<AdminInvite>;
  updateAuction?: Maybe<Auction>;
  /** Update AuctionBidder */
  updateAuctionBidder?: Maybe<AuctionBidder>;
  updateAuctionBidderPaymentMethod: UpdatePaymentMethodResult;
  /** Update AuctionCategory */
  updateAuctionCategory?: Maybe<AuctionCategory>;
  updateAuctionCategoryOrder: Scalars['Boolean']['output'];
  updateAuctionItem?: Maybe<AuctionItem>;
  updateAuctionItemImageOrder: Scalars['Boolean']['output'];
  updateAuctionItemMaxBid?: Maybe<Scalars['Boolean']['output']>;
  updateAuctionItemOrder: Scalars['Boolean']['output'];
  /** Update Campaign */
  updateCampaign?: Maybe<Campaign>;
  /** Update CampaignEvent */
  updateCampaignEvent?: Maybe<CampaignEvent>;
  /** Update CampaignMessage */
  updateCampaignMessage?: Maybe<CampaignMessage>;
  /** Update CampaignMessageAudience */
  updateCampaignMessageAudience?: Maybe<CampaignMessageAudience>;
  /** Update CampaignMetadata */
  updateCampaignMetadata?: Maybe<CampaignMetadata>;
  /** Update CampaignPage */
  updateCampaignPage?: Maybe<CampaignPage>;
  updateCampaignPageOrder: Scalars['Boolean']['output'];
  /** Update CampaignWidget */
  updateCampaignWidget?: Maybe<CampaignWidget>;
  updateCampaignWidgetOrder: Scalars['Boolean']['output'];
  updateCommitmentAmount?: Maybe<Scalars['Boolean']['output']>;
  updateCommitmentPaymentSource: UpdatePaymentMethodResult;
  /** Update Contact */
  updateContact?: Maybe<Contact>;
  updateCustomTextBlock?: Maybe<CustomTextBlock>;
  /** Update DiscountCode */
  updateDiscountCode?: Maybe<DiscountCode>;
  updateDonation?: Maybe<Donation>;
  /** Update DonationReply */
  updateDonationReply?: Maybe<DonationReply>;
  /** Update EmbedWidget */
  updateEmbedWidget?: Maybe<EmbedWidget>;
  /** Update EventTable */
  updateEventTable?: Maybe<EventTable>;
  /** Update EventTableSponsor */
  updateEventTableSponsor?: Maybe<EventTableSponsor>;
  /** Update EventTableTicketGroup */
  updateEventTableTicketGroup?: Maybe<EventTableTicketGroup>;
  /** Update Fundraiser */
  updateFundraiser?: Maybe<Fundraiser>;
  /** Update FundraisingUpdate */
  updateFundraisingUpdate?: Maybe<FundraisingUpdate>;
  updateGivingPlan: GivingPlan;
  updateGivingPlanPaymentSource: UpdatePaymentMethodResult;
  /** Update GlobalQuestion */
  updateGlobalQuestion?: Maybe<GlobalQuestion>;
  updateGlobalQuestionOptionOrder: Scalars['Boolean']['output'];
  /** Update IntervalReminder */
  updateIntervalReminder?: Maybe<IntervalReminder>;
  /** Update LiveAuctionItem */
  updateLiveAuctionItem?: Maybe<LiveAuctionItem>;
  /** Update LiveDisplay */
  updateLiveDisplay?: Maybe<LiveDisplay>;
  /** Update Match */
  updateMatch?: Maybe<Match>;
  /** Update Need */
  updateNeed?: Maybe<Need>;
  updateOrder: Order;
  /** Update Organization */
  updateOrganization?: Maybe<Organization>;
  updateParticipant?: Maybe<Fundraiser>;
  updateParticipantPayment: UpdateParticipantPaymentResult;
  updatePledge: Donation;
  updatePledgePaymentSource: UpdatePaymentMethodResult;
  /** Update Product */
  updateProduct?: Maybe<Product>;
  updateProductOrder: Scalars['Boolean']['output'];
  /** Update ProductVariant */
  updateProductVariant?: Maybe<ProductVariant>;
  updateProgram?: Maybe<Program>;
  updateProgramChildOrder: Scalars['Boolean']['output'];
  /** Update Question */
  updateQuestion?: Maybe<Question>;
  /** Update QuestionOption */
  updateQuestionOption?: Maybe<QuestionOption>;
  updateQuestionOptionOrder: Scalars['Boolean']['output'];
  updateQuestionOrder: Scalars['Boolean']['output'];
  /** Update QuestionRegistrationType */
  updateQuestionRegistrationType?: Maybe<QuestionRegistrationType>;
  /** Update Raffle */
  updateRaffle?: Maybe<Raffle>;
  /** Update RaffleOrder */
  updateRaffleOrder?: Maybe<RaffleOrder>;
  /** Update RaffleWinningDraw */
  updateRaffleWinningDraw?: Maybe<RaffleWinningDraw>;
  updateRegistrationType: RegistrationType;
  updateRegistrationTypeOrder: Scalars['Boolean']['output'];
  /** Update ReportTemplate */
  updateReportTemplate?: Maybe<ReportTemplate>;
  /** Update SoldProduct */
  updateSoldProduct?: Maybe<SoldProduct>;
  /** Update SoldTicketBundle */
  updateSoldTicketBundle?: Maybe<SoldTicketBundle>;
  /** Update Sponsor */
  updateSponsor?: Maybe<Sponsor>;
  /** Update Team */
  updateTeam?: Maybe<Team>;
  /** Update TeamMessageBoardPost */
  updateTeamMessageBoardPost?: Maybe<TeamMessageBoardPost>;
  /** Update TipTapMigration */
  updateTipTapMigration?: Maybe<TipTapMigration>;
  /** Update User */
  updateUser?: Maybe<User>;
  updateUserApiKey?: Maybe<Scalars['String']['output']>;
  validateDiscountCode: Scalars['Boolean']['output'];
};


export type MutationAcceptAdminInviteArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptSponsorCashPaymentArgs = {
  id: Scalars['String']['input'];
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
  sendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddFundraiserArgs = {
  fundraiser: AddFundraiserInput;
};


export type MutationAddLiveAuctionWinnerArgs = {
  amount: Scalars['Float']['input'];
  liveAuctionItemId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};


export type MutationAddNeedCommitmentsArgs = {
  needId: Scalars['String']['input'];
  participantIds: Array<Scalars['String']['input']>;
};


export type MutationAddUserRoleArgs = {
  resourceId: Scalars['String']['input'];
  roleCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAnswerQuestionArgs = {
  answer: Scalars['SequelizeJSON']['input'];
  audienceId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};


export type MutationAssignGlobalQuestionsArgs = {
  audienceType: AudienceTypeEnum;
  campaignId: Scalars['String']['input'];
  globalQuestionIds: Array<Scalars['String']['input']>;
};


export type MutationCalculateDonationFeesArgs = {
  amount: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  coverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  coverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  processorFee?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCalculateRaffleOrderAmountArgs = {
  raffleOrder: CalculateRaffleOrderInput;
};


export type MutationCalculateRegistrationAmountArgs = {
  discountCode?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCalculateSponsorAmountArgs = {
  campaignId: Scalars['String']['input'];
  coverFee: Scalars['Boolean']['input'];
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelAuctionItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelContactRemindersArgs = {
  contactId: Scalars['ID']['input'];
};


export type MutationCancelPledgeArgs = {
  donationId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChargeCommitmentArgs = {
  amount: Scalars['String']['input'];
  fundraiserId: Scalars['String']['input'];
};


export type MutationChargeSponsorArgs = {
  confirmationTokenId: Scalars['String']['input'];
  coverFee: Scalars['Boolean']['input'];
  sendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimFundraiserArgs = {
  commitmentDonationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationCompleteOrderArgs = {
  order: CompleteOrderInput;
};


export type MutationConnectDoubleTheDonationArgs = {
  organizationId: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
};


export type MutationCreateActivityMetricArgs = {
  ActivityMetric?: InputMaybe<ActivityMetricInput>;
};


export type MutationCreateAdminInviteArgs = {
  AdminInvite: CreateAdminInviteInput;
};


export type MutationCreateAuctionArgs = {
  Auction?: InputMaybe<AuctionInput>;
};


export type MutationCreateAuctionBidArgs = {
  bid: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  type: AuctionBidtypeEnumType;
};


export type MutationCreateAuctionBidderArgs = {
  auctionBidder: CreateAuctionBidderInput;
};


export type MutationCreateAuctionCategoryArgs = {
  AuctionCategory?: InputMaybe<AuctionCategoryInput>;
};


export type MutationCreateAuctionItemArgs = {
  AuctionItem?: InputMaybe<AuctionItemInput>;
};


export type MutationCreateAuctionItemImageArgs = {
  AuctionItemImage?: InputMaybe<AuctionItemImageInput>;
};


export type MutationCreateCampaignArgs = {
  Campaign?: InputMaybe<CampaignInput>;
};


export type MutationCreateCampaignMessageArgs = {
  CampaignMessage?: InputMaybe<CampaignMessageInput>;
};


export type MutationCreateCampaignMessageAudienceArgs = {
  CampaignMessageAudience?: InputMaybe<CampaignMessageAudienceInput>;
};


export type MutationCreateCampaignMetadataArgs = {
  CampaignMetadata?: InputMaybe<CampaignMetadataInput>;
};


export type MutationCreateCampaignPageArgs = {
  CampaignPage?: InputMaybe<CampaignPageInput>;
};


export type MutationCreateCampaignWidgetArgs = {
  CampaignWidget?: InputMaybe<CampaignWidgetInput>;
};


export type MutationCreateContactArgs = {
  Contact?: InputMaybe<ContactInput>;
};


export type MutationCreateContactsAndSendArgs = {
  contacts?: InputMaybe<Array<InputMaybe<ContactInfo>>>;
  fundraiserId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomTextBlockArgs = {
  CustomTextBlock: CustomTextBlockInput;
};


export type MutationCreateDiscountCodeArgs = {
  DiscountCode?: InputMaybe<DiscountCodeInput>;
};


export type MutationCreateDonationArgs = {
  donation: CreateDonationInput;
};


export type MutationCreateDonationReplyArgs = {
  DonationReply?: InputMaybe<DonationReplyInput>;
};


export type MutationCreateEmbedWidgetArgs = {
  EmbedWidget?: InputMaybe<EmbedWidgetInput>;
};


export type MutationCreateEventTableArgs = {
  EventTable?: InputMaybe<EventTableInput>;
};


export type MutationCreateEventTableSponsorArgs = {
  EventTableSponsor?: InputMaybe<EventTableSponsorInput>;
};


export type MutationCreateEventTableTicketGroupArgs = {
  EventTableTicketGroup?: InputMaybe<EventTableTicketGroupInput>;
};


export type MutationCreateFundraiserArgs = {
  Fundraiser?: InputMaybe<FundraiserInput>;
};


export type MutationCreateFundraisingUpdateArgs = {
  FundraisingUpdate?: InputMaybe<FundraisingUpdateInput>;
};


export type MutationCreateGlobalQuestionArgs = {
  GlobalQuestion?: InputMaybe<GlobalQuestionInput>;
};


export type MutationCreateIntervalReminderArgs = {
  IntervalReminder?: InputMaybe<IntervalReminderInput>;
};


export type MutationCreateLiveAuctionItemArgs = {
  LiveAuctionItem?: InputMaybe<LiveAuctionItemInput>;
};


export type MutationCreateLiveDisplayArgs = {
  LiveDisplay?: InputMaybe<LiveDisplayInput>;
};


export type MutationCreateManyEventTablesArgs = {
  campaignId: Scalars['String']['input'];
  numberOfTables: Scalars['Int']['input'];
  totalSeats: Scalars['Int']['input'];
};


export type MutationCreateMatchArgs = {
  Match?: InputMaybe<MatchInput>;
};


export type MutationCreateNeedArgs = {
  Need?: InputMaybe<NeedInput>;
};


export type MutationCreateOfflineDonationArgs = {
  donation: CreateOfflineDonationInput;
};


export type MutationCreateOrUpdateEmailCustomizationArgs = {
  campaignId: Scalars['String']['input'];
  customData: Scalars['SequelizeJSON']['input'];
  messageType: CustomizableMessageTypeEnum;
};


export type MutationCreateOrUpdateSlugArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  objectId: Scalars['String']['input'];
  type: SlugTypeEnum;
};


export type MutationCreateOrderArgs = {
  givingVoucher?: InputMaybe<Scalars['String']['input']>;
  order: CreateOrderInput;
};


export type MutationCreateOrganizationArgs = {
  Organization?: InputMaybe<OrganizationInput>;
};


export type MutationCreateOrganizationSubscriptionCheckoutSessionArgs = {
  organizationId: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  term: OrganizationSubscriptionTermEnum;
};


export type MutationCreateOrganizationSubscriptionManageSessionArgs = {
  organizationId: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationCreateParticipantArgs = {
  participant: CreateParticipantInput;
};


export type MutationCreateProductArgs = {
  Product?: InputMaybe<ProductInput>;
};


export type MutationCreateProductVariantArgs = {
  ProductVariant?: InputMaybe<ProductVariantInput>;
};


export type MutationCreateProgramArgs = {
  Program: ProgramInput;
};


export type MutationCreateQuestionArgs = {
  Question?: InputMaybe<QuestionInput>;
};


export type MutationCreateQuestionOptionArgs = {
  QuestionOption?: InputMaybe<QuestionOptionInput>;
};


export type MutationCreateQuestionRegistrationTypeArgs = {
  QuestionRegistrationType?: InputMaybe<QuestionRegistrationTypeInput>;
};


export type MutationCreateRaffleArgs = {
  Raffle?: InputMaybe<RaffleInput>;
};


export type MutationCreateRaffleOrderArgs = {
  raffleOrder: CreateRaffleOrderInput;
};


export type MutationCreateRaffleWinningDrawArgs = {
  RaffleWinningDraw?: InputMaybe<RaffleWinningDrawInput>;
};


export type MutationCreateRegistrationTypeArgs = {
  RegistrationType?: InputMaybe<RegistrationTypeInput>;
};


export type MutationCreateReportTemplateArgs = {
  ReportTemplate?: InputMaybe<ReportTemplateInput>;
};


export type MutationCreateSoldTicketBundleArgs = {
  SoldTicketBundle?: InputMaybe<SoldTicketBundleInput>;
};


export type MutationCreateSponsorArgs = {
  sponsor: CreateSponsorInput;
};


export type MutationCreateTeamArgs = {
  Team?: InputMaybe<TeamInput>;
};


export type MutationCreateTeamMessageBoardPostArgs = {
  TeamMessageBoardPost?: InputMaybe<TeamMessageBoardPostInput>;
};


export type MutationCreateTipTapMigrationArgs = {
  TipTapMigration?: InputMaybe<TipTapMigrationInput>;
};


export type MutationCreateUserArgs = {
  User?: InputMaybe<UserInput>;
};


export type MutationDeleteAdminInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAuctionCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAuctionItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAuctionItemImageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignMessageAudienceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignMetadataArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignPageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignWidgetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCustomTextBlockArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDiscountCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDonationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDonationReplyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmbedWidgetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEventTableArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEventTableSponsorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteEventTableTicketGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFundraiserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFundraisingUpdateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteGlobalQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteIntervalReminderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLiveAuctionItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLiveDisplayArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteNeedArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProductVariantArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteQuestionOptionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteQuestionRegistrationTypeArgs = {
  questionId: Scalars['String']['input'];
};


export type MutationDeleteRaffleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRaffleWinningDrawArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRegistrationTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteReportTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSoldTicketBundleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSponsorArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTeamArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTeamMessageBoardPostArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTipTapMigrationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDisconnectDoubleTheDonationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDrawRaffleWinnerArgs = {
  raffleId: Scalars['String']['input'];
};


export type MutationDuplicateCampaignArgs = {
  campaignId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  includeParent?: InputMaybe<Scalars['Boolean']['input']>;
  markSourceCampaignAsCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  monetaryGoal?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previousCampaignId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDuplicateCampaignWidgetArgs = {
  id: Scalars['String']['input'];
};


export type MutationInviteTeamMemberArgs = {
  emails: Array<Scalars['String']['input']>;
  message: Scalars['SequelizeJSON']['input'];
  teamId: Scalars['String']['input'];
};


export type MutationInvoiceSponsorArgs = {
  id: Scalars['String']['input'];
};


export type MutationLikeFundraisingUpdateArgs = {
  fundraisingUpdateId: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginWithServiceArgs = {
  accessToken: Scalars['String']['input'];
  type: LoginService;
};


export type MutationReactivateGivingPlanArgs = {
  amount: Scalars['String']['input'];
  confirmationTokenId: Scalars['String']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  frequency: GivingPlanfrequencyEnumType;
  nextChargeDate: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRecreateTeamArgs = {
  id: Scalars['String']['input'];
  targetCampaignId: Scalars['String']['input'];
};


export type MutationRemoveParticipantPaymentArgs = {
  participantId: Scalars['String']['input'];
};


export type MutationRemoveUserRoleArgs = {
  resourceId: Scalars['String']['input'];
  roleCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationResendAuctionItemReceiptArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendCommitmentChargeFailedEmailArgs = {
  fundraiserId: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendFundraiserLaunchEmailArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendGivingPlanManageLinkArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendOrderReceiptArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendPledgeConfirmationArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendReceiptArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendSponsorInvoiceArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendSponsorReceiptArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRetryChargeGivingPlanArgs = {
  donationId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRetryChargeWinnerForAuctionItemArgs = {
  id: Scalars['String']['input'];
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSeatGuestsArgs = {
  eventTableId: Scalars['ID']['input'];
  numSeats: Scalars['Int']['input'];
  ticketGroupId: Scalars['ID']['input'];
};


export type MutationSeatSponsorGuestsArgs = {
  eventTableId: Scalars['ID']['input'];
  numSeats: Scalars['Int']['input'];
  sponsorId: Scalars['ID']['input'];
};


export type MutationSeeFundraiserAchievementArgs = {
  fundraiserAchievementId: Scalars['String']['input'];
};


export type MutationSendCampaignMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendCampaignMessageTestArgs = {
  campaignId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message: CampaignMessageTestInput;
};


export type MutationSendForgotPasswordTokenArgs = {
  email: Scalars['String']['input'];
  redirectAs?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  resetUrl: Scalars['String']['input'];
};


export type MutationSendFundraiserCommitmentNudgeArgs = {
  body: Scalars['SequelizeJSON']['input'];
  campaignId: Scalars['String']['input'];
  commitmentStatus: CommitmentNudgeStatusEnum;
};


export type MutationSendOutstandingPledgeNudgeArgs = {
  campaignId: Scalars['String']['input'];
  fundraisers: Array<Scalars['String']['input']>;
};


export type MutationSendTeamCaptainNudgeArgs = {
  audience: TeamCaptainNudgeAudienceEnum;
  body: Scalars['SequelizeJSON']['input'];
  campaignId: Scalars['String']['input'];
};


export type MutationSetAssignedActivityMetricsArgs = {
  activityMetricIds: Array<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
};


export type MutationSetForgottenPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSetReactionArgs = {
  reactionType?: InputMaybe<ReactionreactionTypeEnumType>;
  subjectId: Scalars['String']['input'];
  subjectType: ReactionsubjectTypeEnumType;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationThankDonorArgs = {
  id: Scalars['String']['input'];
  message: Scalars['SequelizeJSON']['input'];
};


export type MutationToggleMetaPixelIntegrationArgs = {
  metaPixelId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationUndeleteCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationUndeleteProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnseatGuestsArgs = {
  eventTableId: Scalars['ID']['input'];
  numSeats: Scalars['Int']['input'];
  ticketGroupId: Scalars['ID']['input'];
};


export type MutationUnseatSponsorGuestsArgs = {
  eventTableId: Scalars['ID']['input'];
  numSeats: Scalars['Int']['input'];
  sponsorId: Scalars['ID']['input'];
};


export type MutationUpdateAchievementLevelArgs = {
  AchievementLevel?: InputMaybe<AchievementLevelInput>;
};


export type MutationUpdateActivityMetricArgs = {
  ActivityMetric?: InputMaybe<ActivityMetricInput>;
};


export type MutationUpdateAddOnArgs = {
  AddOn?: InputMaybe<AddOnInput>;
};


export type MutationUpdateAdminInviteArgs = {
  AdminInvite: UpdateAdminInviteInput;
};


export type MutationUpdateAuctionArgs = {
  Auction: AuctionInput;
};


export type MutationUpdateAuctionBidderArgs = {
  AuctionBidder?: InputMaybe<AuctionBidderInput>;
};


export type MutationUpdateAuctionBidderPaymentMethodArgs = {
  confirmationTokenId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateAuctionCategoryArgs = {
  AuctionCategory?: InputMaybe<AuctionCategoryInput>;
};


export type MutationUpdateAuctionCategoryOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateAuctionItemArgs = {
  AuctionItem: AuctionItemInput;
};


export type MutationUpdateAuctionItemImageOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateAuctionItemMaxBidArgs = {
  amount: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};


export type MutationUpdateAuctionItemOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateCampaignArgs = {
  Campaign?: InputMaybe<CampaignInput>;
};


export type MutationUpdateCampaignEventArgs = {
  CampaignEvent?: InputMaybe<CampaignEventInput>;
};


export type MutationUpdateCampaignMessageArgs = {
  CampaignMessage?: InputMaybe<CampaignMessageInput>;
};


export type MutationUpdateCampaignMessageAudienceArgs = {
  CampaignMessageAudience?: InputMaybe<CampaignMessageAudienceInput>;
};


export type MutationUpdateCampaignMetadataArgs = {
  CampaignMetadata?: InputMaybe<CampaignMetadataInput>;
};


export type MutationUpdateCampaignPageArgs = {
  CampaignPage?: InputMaybe<CampaignPageInput>;
};


export type MutationUpdateCampaignPageOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateCampaignWidgetArgs = {
  CampaignWidget?: InputMaybe<CampaignWidgetInput>;
};


export type MutationUpdateCampaignWidgetOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateCommitmentAmountArgs = {
  amount: Scalars['Int']['input'];
  fundraiserId: Scalars['String']['input'];
};


export type MutationUpdateCommitmentPaymentSourceArgs = {
  confirmationTokenId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateContactArgs = {
  Contact?: InputMaybe<ContactInput>;
};


export type MutationUpdateCustomTextBlockArgs = {
  CustomTextBlock: CustomTextBlockInput;
};


export type MutationUpdateDiscountCodeArgs = {
  DiscountCode?: InputMaybe<DiscountCodeInput>;
};


export type MutationUpdateDonationArgs = {
  Donation: DonationInput;
};


export type MutationUpdateDonationReplyArgs = {
  DonationReply?: InputMaybe<DonationReplyInput>;
};


export type MutationUpdateEmbedWidgetArgs = {
  EmbedWidget?: InputMaybe<EmbedWidgetInput>;
};


export type MutationUpdateEventTableArgs = {
  EventTable?: InputMaybe<EventTableInput>;
};


export type MutationUpdateEventTableSponsorArgs = {
  EventTableSponsor?: InputMaybe<EventTableSponsorInput>;
};


export type MutationUpdateEventTableTicketGroupArgs = {
  EventTableTicketGroup?: InputMaybe<EventTableTicketGroupInput>;
};


export type MutationUpdateFundraiserArgs = {
  Fundraiser?: InputMaybe<FundraiserInput>;
};


export type MutationUpdateFundraisingUpdateArgs = {
  FundraisingUpdate?: InputMaybe<FundraisingUpdateInput>;
};


export type MutationUpdateGivingPlanArgs = {
  GivingPlan: UpdateGivingPlanInput;
};


export type MutationUpdateGivingPlanPaymentSourceArgs = {
  confirmationTokenId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateGlobalQuestionArgs = {
  GlobalQuestion?: InputMaybe<GlobalQuestionInput>;
};


export type MutationUpdateGlobalQuestionOptionOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateIntervalReminderArgs = {
  IntervalReminder?: InputMaybe<IntervalReminderInput>;
};


export type MutationUpdateLiveAuctionItemArgs = {
  LiveAuctionItem?: InputMaybe<LiveAuctionItemInput>;
};


export type MutationUpdateLiveDisplayArgs = {
  LiveDisplay?: InputMaybe<LiveDisplayInput>;
};


export type MutationUpdateMatchArgs = {
  Match?: InputMaybe<MatchInput>;
};


export type MutationUpdateNeedArgs = {
  Need?: InputMaybe<NeedInput>;
};


export type MutationUpdateOrderArgs = {
  order: UpdateOrderInput;
};


export type MutationUpdateOrganizationArgs = {
  Organization?: InputMaybe<OrganizationInput>;
};


export type MutationUpdateParticipantArgs = {
  Fundraiser: FundraiserInput;
};


export type MutationUpdateParticipantPaymentArgs = {
  confirmationTokenId: Scalars['String']['input'];
  participant: UpdateParticipantPaymentInput;
};


export type MutationUpdatePledgeArgs = {
  amount: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdatePledgePaymentSourceArgs = {
  confirmationTokenId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateProductArgs = {
  Product?: InputMaybe<ProductInput>;
};


export type MutationUpdateProductOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateProductVariantArgs = {
  ProductVariant?: InputMaybe<ProductVariantInput>;
};


export type MutationUpdateProgramArgs = {
  Program: ProgramInput;
};


export type MutationUpdateProgramChildOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateQuestionArgs = {
  Question?: InputMaybe<QuestionInput>;
};


export type MutationUpdateQuestionOptionArgs = {
  QuestionOption?: InputMaybe<QuestionOptionInput>;
};


export type MutationUpdateQuestionOptionOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateQuestionOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateQuestionRegistrationTypeArgs = {
  QuestionRegistrationType?: InputMaybe<QuestionRegistrationTypeInput>;
};


export type MutationUpdateRaffleArgs = {
  Raffle?: InputMaybe<RaffleInput>;
};


export type MutationUpdateRaffleOrderArgs = {
  RaffleOrder?: InputMaybe<RaffleOrderInput>;
};


export type MutationUpdateRaffleWinningDrawArgs = {
  RaffleWinningDraw?: InputMaybe<RaffleWinningDrawInput>;
};


export type MutationUpdateRegistrationTypeArgs = {
  RegistrationType: RegistrationTypeInput;
};


export type MutationUpdateRegistrationTypeOrderArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateReportTemplateArgs = {
  ReportTemplate?: InputMaybe<ReportTemplateInput>;
};


export type MutationUpdateSoldProductArgs = {
  SoldProduct?: InputMaybe<SoldProductInput>;
};


export type MutationUpdateSoldTicketBundleArgs = {
  SoldTicketBundle?: InputMaybe<SoldTicketBundleInput>;
};


export type MutationUpdateSponsorArgs = {
  Sponsor?: InputMaybe<SponsorInput>;
};


export type MutationUpdateTeamArgs = {
  Team?: InputMaybe<TeamInput>;
};


export type MutationUpdateTeamMessageBoardPostArgs = {
  TeamMessageBoardPost?: InputMaybe<TeamMessageBoardPostInput>;
};


export type MutationUpdateTipTapMigrationArgs = {
  TipTapMigration?: InputMaybe<TipTapMigrationInput>;
};


export type MutationUpdateUserArgs = {
  User?: InputMaybe<UserInput>;
};


export type MutationUpdateUserApiKeyArgs = {
  userId: Scalars['String']['input'];
};


export type MutationValidateDiscountCodeArgs = {
  campaignId: Scalars['String']['input'];
  discountCode: Scalars['String']['input'];
};

export type MyAuctionItemBid = {
  __typename?: 'MyAuctionItemBid';
  bid: Scalars['String']['output'];
  isWinning: Scalars['Boolean']['output'];
  type: AuctionBidtypeEnumType;
};

export type Need = {
  __typename?: 'Need';
  amount: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  donations?: Maybe<Array<Maybe<Donation>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  qtyUsed: Scalars['Int']['output'];
  totalCommitmentAmount: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type NeedDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type NeedInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  donations?: InputMaybe<Array<InputMaybe<DonationInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum OfflineDonationTypeEnum {
  OfflineFlat = 'offline_flat',
  OfflinePledge = 'offline_pledge'
}

/** Operation on object. Defaults to KEEP. */
export enum OpsEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Keep = 'KEEP',
  Update = 'UPDATE'
}

export type Order = {
  __typename?: 'Order';
  activationData?: Maybe<Scalars['SequelizeJSON']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  buyerTicket?: Maybe<Fundraiser>;
  buyerTicketId?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']['output']>;
  cancelledDonationAmount: Scalars['String']['output'];
  cancelledProductAmount: Scalars['String']['output'];
  cancelledRaffleAmount: Scalars['String']['output'];
  cancelledTicketAmount: Scalars['String']['output'];
  cancelledTotalAmount: Scalars['String']['output'];
  charge: PayableCharge;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coveredFees: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  deductibleAmount: Scalars['String']['output'];
  didCoverFee?: Maybe<Scalars['Boolean']['output']>;
  didCoverPlatformFee: Scalars['Boolean']['output'];
  didCoverProcessorFee: Scalars['Boolean']['output'];
  discountAmount: Scalars['String']['output'];
  discountCode?: Maybe<DiscountCode>;
  discountCodeId?: Maybe<Scalars['String']['output']>;
  discountConfig?: Maybe<Scalars['SequelizeJSON']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<Donation>;
  donationTotalAmount: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  liveAuctionTotalAmount: Scalars['String']['output'];
  miscItems?: Maybe<Array<Maybe<OrderMiscItem>>>;
  miscTotalAmount: Scalars['String']['output'];
  needDonations?: Maybe<Array<Maybe<Donation>>>;
  openTabParticipant?: Maybe<Fundraiser>;
  orderData: OrderData;
  paidAt?: Maybe<Scalars['Date']['output']>;
  paymentInfo?: Maybe<Scalars['String']['output']>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodExpMonth?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpYear?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpiration?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<OrderpaymentTypeEnumType>;
  phone?: Maybe<Scalars['String']['output']>;
  platformFee: Scalars['String']['output'];
  platformFeePercent: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  processorFeePercent: Scalars['String']['output'];
  productActiveAmount: Scalars['String']['output'];
  productAmount: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  productTotalAmount: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<SoldProduct>>>;
  raffleOrder?: Maybe<RaffleOrder>;
  raffleTotalAmount: Scalars['String']['output'];
  searchText?: Maybe<Scalars['String']['output']>;
  soldTicketBundles?: Maybe<Array<Maybe<SoldTicketBundle>>>;
  stateProv?: Maybe<Scalars['String']['output']>;
  status: OrderstatusEnumType;
  ticketCount: Scalars['Int']['output'];
  ticketTotalAmount: Scalars['String']['output'];
  tickets?: Maybe<Array<Maybe<Fundraiser>>>;
  tip: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  wonLiveAuctionItems?: Maybe<Array<Maybe<WonLiveAuctionItem>>>;
};


export type OrderMiscItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrderNeedDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrderProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrderSoldTicketBundlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrderTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrderWonLiveAuctionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type OrderData = {
  __typename?: 'OrderData';
  amount: Scalars['String']['output'];
  coverFee?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discountCode?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<OrderDonationData>;
  id: Scalars['String']['output'];
  miscItems?: Maybe<Array<OrderMiscItemData>>;
  needs?: Maybe<Array<OrderNeedData>>;
  products?: Maybe<Array<OrderProductData>>;
  raffle?: Maybe<Array<OrderRaffleItemData>>;
  wonLiveAuctionItems?: Maybe<Array<OrderWonLiveAuctionItemData>>;
};

export type OrderDonationData = {
  __typename?: 'OrderDonationData';
  amount: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type OrderInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  activationData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  buyerTicketId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coveredFees?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  didCoverFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  discountAmount?: InputMaybe<Scalars['String']['input']>;
  discountCodeId?: InputMaybe<Scalars['String']['input']>;
  discountConfig?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<DonationInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  miscItems?: InputMaybe<Array<InputMaybe<OrderMiscItemInput>>>;
  needDonations?: InputMaybe<Array<InputMaybe<DonationInput>>>;
  openTabParticipant?: InputMaybe<FundraiserInput>;
  paidAt?: InputMaybe<Scalars['Date']['input']>;
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
  paymentMethodBrand?: InputMaybe<Scalars['String']['input']>;
  paymentMethodExpMonth?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpYear?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<OrderpaymentTypeEnumType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  platformFeePercent?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorFeePercent?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<SoldProductInput>>>;
  raffleOrder?: InputMaybe<RaffleOrderInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  soldTicketBundles?: InputMaybe<Array<InputMaybe<SoldTicketBundleInput>>>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  tickets?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  tip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  wonLiveAuctionItems?: InputMaybe<Array<InputMaybe<WonLiveAuctionItemInput>>>;
};

export type OrderMiscItem = {
  __typename?: 'OrderMiscItem';
  amount: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type OrderMiscItemData = {
  __typename?: 'OrderMiscItemData';
  amount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrderMiscItemInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type OrderNeedData = {
  __typename?: 'OrderNeedData';
  amount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  needId: Scalars['String']['output'];
};

export type OrderProductData = {
  __typename?: 'OrderProductData';
  amount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  noteResponse?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  selectedVariantId?: Maybe<Scalars['String']['output']>;
};

export type OrderRaffleItemData = {
  __typename?: 'OrderRaffleItemData';
  amount: Scalars['String']['output'];
  entries: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  raffleId: Scalars['String']['output'];
};

export type OrderResult = PayableResult & {
  __typename?: 'OrderResult';
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OrderSearchResult = SearchResult & {
  __typename?: 'OrderSearchResult';
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export type OrderTable = {
  __typename?: 'OrderTable';
  count: Scalars['Int']['output'];
  rows: Array<Order>;
};

export type OrderWonLiveAuctionItemData = {
  __typename?: 'OrderWonLiveAuctionItemData';
  amount: Scalars['Float']['output'];
  fundraiserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  liveAuctionItemId: Scalars['String']['output'];
};

export enum OrderpaymentTypeEnumType {
  Card = 'card',
  CardOnFile = 'card_on_file',
  CashCheck = 'cash_check'
}

export enum OrderstatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  Failed = 'failed',
  Partial = 'partial',
  Pending = 'pending'
}

export type Organization = {
  __typename?: 'Organization';
  activeCampaignCount: Scalars['Int']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  ae?: Maybe<User>;
  aeId?: Maybe<Scalars['String']['output']>;
  campaignDefaultAccentColor: Scalars['String']['output'];
  campaignDefaultCanDonorCoverPlatformFee: Scalars['Boolean']['output'];
  campaignDefaultCanDonorCoverProcessorFee: Scalars['Boolean']['output'];
  campaignDefaultCanParticipantCoverPlatformFee: Scalars['Boolean']['output'];
  campaignDefaultCanParticipantCoverProcessorFee: Scalars['Boolean']['output'];
  campaignDefaultDonationFeeMode: OrganizationcampaignDefaultDonationFeeModeEnumType;
  campaignDefaultPrimaryColor: Scalars['String']['output'];
  campaignMetadata: Array<Maybe<CampaignMetadata>>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  captchaThreshold?: Maybe<Scalars['Float']['output']>;
  chargeDescription?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  csr?: Maybe<User>;
  csrId?: Maybe<Scalars['String']['output']>;
  deletedCampaignCount: Scalars['Int']['output'];
  doneCampaignCount: Scalars['Int']['output'];
  doubleTheDonationPublicKey?: Maybe<Scalars['String']['output']>;
  firstChargeDate?: Maybe<Scalars['String']['output']>;
  givingPlans?: Maybe<Array<Maybe<GivingPlan>>>;
  globalQuestions?: Maybe<Array<Maybe<GlobalQuestion>>>;
  id: Scalars['String']['output'];
  isForProfit: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  metaPixelId?: Maybe<Scalars['String']['output']>;
  myPermissions?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  paymentProcessorConfig?: Maybe<Scalars['SequelizeJSON']['output']>;
  platformFee: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  processorFee: Scalars['String']['output'];
  reportTemplates?: Maybe<Array<Maybe<ReportTemplate>>>;
  stateProv?: Maybe<Scalars['String']['output']>;
  subscriptionStatus: OrganizationsubscriptionStatusEnumType;
  transitionState?: Maybe<OrganizationtransitionStateEnumType>;
  updatedAt: Scalars['Date']['output'];
  userPermissions?: Maybe<Array<UserPermissions>>;
  website?: Maybe<Scalars['String']['output']>;
};


export type OrganizationCampaignMetadataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrganizationCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrganizationGivingPlansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrganizationGlobalQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type OrganizationReportTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type OrganizationInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  aeId?: InputMaybe<Scalars['String']['input']>;
  campaignDefaultAccentColor?: InputMaybe<Scalars['String']['input']>;
  campaignDefaultCanDonorCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  campaignDefaultCanDonorCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  campaignDefaultCanParticipantCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  campaignDefaultCanParticipantCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  campaignDefaultDonationFeeMode?: InputMaybe<OrganizationcampaignDefaultDonationFeeModeEnumType>;
  campaignDefaultPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<CampaignInput>>>;
  captchaThreshold?: InputMaybe<Scalars['Float']['input']>;
  chargeDescription?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  csrId?: InputMaybe<Scalars['String']['input']>;
  doubleTheDonationPublicKey?: InputMaybe<Scalars['String']['input']>;
  firstChargeDate?: InputMaybe<Scalars['String']['input']>;
  givingPlans?: InputMaybe<Array<InputMaybe<GivingPlanInput>>>;
  globalQuestions?: InputMaybe<Array<InputMaybe<GlobalQuestionInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isForProfit?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metaPixelId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorFee?: InputMaybe<Scalars['String']['input']>;
  reportTemplates?: InputMaybe<Array<InputMaybe<ReportTemplateInput>>>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  subscriptionStatus?: InputMaybe<OrganizationsubscriptionStatusEnumType>;
  transitionState?: InputMaybe<OrganizationtransitionStateEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSubscriptionCheckoutInput = {
  organizationId: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  term: OrganizationSubscriptionTermEnum;
};

export type OrganizationSubscriptionManageInput = {
  organizationId: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type OrganizationSubscriptionSessionResult = {
  __typename?: 'OrganizationSubscriptionSessionResult';
  url: Scalars['String']['output'];
};

export enum OrganizationSubscriptionTermEnum {
  Month = 'month',
  Year = 'year'
}

export enum OrganizationcampaignDefaultDonationFeeModeEnumType {
  Fee = 'fee',
  Tip = 'tip'
}

export enum OrganizationsubscriptionStatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  Exempt = 'exempt',
  Incomplete = 'incomplete'
}

export enum OrganizationtransitionStateEnumType {
  Active = 'active',
  Inactive = 'inactive',
  Onboarding = 'onboarding'
}

export type Participant = {
  __typename?: 'Participant';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  campaign?: Maybe<Campaign>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<ParticipantRegistration>;
  resolvedName?: Maybe<Scalars['String']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  stateProv?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Ticket>;
  type: ParticipantTypeEnum;
  updatedAt: Scalars['Date']['output'];
};

export type ParticipantRegistration = {
  __typename?: 'ParticipantRegistration';
  amount: Scalars['String']['output'];
  deductibleAmount?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['String']['output'];
  discountCode?: Maybe<DiscountCode>;
  nonDeductibleAmount?: Maybe<Scalars['String']['output']>;
  originalAmount: Scalars['String']['output'];
  registrationType?: Maybe<RegistrationType>;
};

export type ParticipantSearchResult = SearchResult & {
  __typename?: 'ParticipantSearchResult';
  avatarImage?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  participantType: SearchResultParticipantTypeEnum;
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export type ParticipantTable = {
  __typename?: 'ParticipantTable';
  count: Scalars['Int']['output'];
  rows: Array<Fundraiser>;
};

export enum ParticipantTypeEnum {
  Fundraiser = 'fundraiser',
  Ticket = 'ticket'
}

export type PayableCharge = {
  __typename?: 'PayableCharge';
  gross?: Maybe<Scalars['String']['output']>;
  net?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['Date']['output']>;
  processedAt?: Maybe<Scalars['Date']['output']>;
  status: PayableChargeStatus;
  triesRemaining?: Maybe<Scalars['Int']['output']>;
};

export enum PayableChargeStatus {
  Cancelled = 'cancelled',
  Error = 'error',
  Failed = 'failed',
  Failing = 'failing',
  Paid = 'paid',
  Pending = 'pending'
}

export type PayableResult = {
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PerformanceSettings = {
  __typename?: 'PerformanceSettings';
  id?: Maybe<Scalars['String']['output']>;
  metricLabel?: Maybe<Scalars['String']['output']>;
  metricLabelPlural?: Maybe<Scalars['String']['output']>;
};

export type PerformanceUpdateActivity = ItemActivity & {
  __typename?: 'PerformanceUpdateActivity';
  performanceUpdate: FundraisingUpdate;
  timestamp: Scalars['Date']['output'];
};

export type PotentialContact = {
  __typename?: 'PotentialContact';
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  source: ContactInfoSourceEnum;
};

export type PreviousParticipantTable = {
  __typename?: 'PreviousParticipantTable';
  rejoinedCount: Scalars['Int']['output'];
  rows: Array<Fundraiser>;
  totalCount: Scalars['Int']['output'];
};

export type Product = {
  __typename?: 'Product';
  amount: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['SequelizeJSON']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  isNoteRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  noteLabel?: Maybe<Scalars['String']['output']>;
  publicDisplay: ProductpublicDisplayEnumType;
  qtyLimitScope: ProductqtyLimitScopeEnumType;
  qtyRemaining?: Maybe<Scalars['Int']['output']>;
  qtyTotal?: Maybe<Scalars['Int']['output']>;
  qtyUsed: Scalars['Int']['output'];
  soldProducts?: Maybe<Array<Maybe<SoldProduct>>>;
  sort: Scalars['Int']['output'];
  totalSalesAmount: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  variants?: Maybe<Array<Maybe<ProductVariant>>>;
};


export type ProductSoldProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type ProductVariantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type ProductInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isNoteRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteLabel?: InputMaybe<Scalars['String']['input']>;
  publicDisplay?: InputMaybe<ProductpublicDisplayEnumType>;
  qtyLimitScope?: InputMaybe<ProductqtyLimitScopeEnumType>;
  qtyTotal?: InputMaybe<Scalars['Int']['input']>;
  qtyUsed?: InputMaybe<Scalars['Int']['input']>;
  soldProducts?: InputMaybe<Array<InputMaybe<SoldProductInput>>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantInput>>>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<Product>;
  productId: Scalars['String']['output'];
  qtyRemaining?: Maybe<Scalars['Int']['output']>;
  qtyTotal?: Maybe<Scalars['Int']['output']>;
  qtyUsed: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ProductVariantInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  qtyRemaining?: InputMaybe<Scalars['Int']['input']>;
  qtyTotal?: InputMaybe<Scalars['Int']['input']>;
  qtyUsed?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum ProductpublicDisplayEnumType {
  Both = 'both',
  Registration = 'registration',
  Shop = 'shop'
}

export enum ProductqtyLimitScopeEnumType {
  Item = 'item',
  Option = 'option',
  Unlimited = 'unlimited'
}

export type Program = {
  __typename?: 'Program';
  accentColor: Scalars['String']['output'];
  activeFeatures: CampaignFeatures;
  amountRaised: Scalars['String']['output'];
  campaignDonateButtonLabel: Scalars['String']['output'];
  campaignHeaderBackgroundImage?: Maybe<Scalars['String']['output']>;
  campaignHeadline?: Maybe<Scalars['String']['output']>;
  campaignJoinButtonLabel: Scalars['String']['output'];
  campaignLogo?: Maybe<Scalars['String']['output']>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  collectDonorAddress: CampaigncollectDonorAddressEnumType;
  collectDonorPhone: CampaigncollectDonorPhoneEnumType;
  contactEmail: Scalars['String']['output'];
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  donationCount: Scalars['Int']['output'];
  donations?: Maybe<Array<Maybe<Donation>>>;
  fundraiserCount: Scalars['Int']['output'];
  heroShowDonate: Scalars['Boolean']['output'];
  heroShowJoin: Scalars['Boolean']['output'];
  heroShowRaised: Scalars['Boolean']['output'];
  heroStyle: HeroStyleEnum;
  id: Scalars['ID']['output'];
  myPermissions?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  ownerOrganization: Organization;
  ownerOrganizationId: Scalars['String']['output'];
  pages?: Maybe<Array<Maybe<CampaignPage>>>;
  participantCount: Scalars['Int']['output'];
  primaryColor: Scalars['String']['output'];
  reportTemplates?: Maybe<Array<Maybe<ReportTemplate>>>;
  slug?: Maybe<Scalars['String']['output']>;
  supportedFeatures: CampaignFeatures;
  supportedWidgetTypes: CampaignWidgetTypes;
  totalFlatAmount: Scalars['String']['output'];
  totalMatchAmount: Scalars['String']['output'];
  totalOfflineFlatAmount: Scalars['String']['output'];
  totalRegistrationAmount: Scalars['String']['output'];
};


export type ProgramCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type ProgramDonationCountArgs = {
  programLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  programLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type ProgramPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type ProgramReportTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type ProgramInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  campaignDonateButtonLabel?: InputMaybe<Scalars['String']['input']>;
  campaignHeaderBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  campaignHeadline?: InputMaybe<Scalars['String']['input']>;
  campaignJoinButtonLabel?: InputMaybe<Scalars['String']['input']>;
  campaignLogo?: InputMaybe<Scalars['String']['input']>;
  collectDonorAddress?: InputMaybe<CampaigncollectDonorAddressEnumType>;
  collectDonorPhone?: InputMaybe<CampaigncollectDonorPhoneEnumType>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  heroShowDonate?: InputMaybe<Scalars['Boolean']['input']>;
  heroShowJoin?: InputMaybe<Scalars['Boolean']['input']>;
  heroShowRaised?: InputMaybe<Scalars['Boolean']['input']>;
  heroStyle?: InputMaybe<HeroStyleEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerOrganizationId?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramSearchResult = SearchResult & {
  __typename?: 'ProgramSearchResult';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export type Query = {
  __typename?: 'Query';
  calculateOrderAmount: CalculateOrderAmountResult;
  coreVersion: Scalars['String']['output'];
  /** Fetch findAchievementLevels. */
  findAchievementLevels?: Maybe<Array<Maybe<AchievementLevel>>>;
  /** Fetch findAchievements. */
  findAchievements?: Maybe<Array<Maybe<Achievement>>>;
  /** Fetch findActivityMetrics. */
  findActivityMetrics?: Maybe<Array<Maybe<ActivityMetric>>>;
  /** Fetch findAddOns. */
  findAddOns?: Maybe<Array<Maybe<AddOn>>>;
  findAdminInvites: Array<Maybe<AdminInvite>>;
  /** Fetch findAuctionBidders. */
  findAuctionBidders?: Maybe<Array<Maybe<AuctionBidder>>>;
  /** Fetch findAuctionBids. */
  findAuctionBids?: Maybe<Array<Maybe<AuctionBid>>>;
  /** Fetch findAuctionCategories. */
  findAuctionCategories?: Maybe<Array<Maybe<AuctionCategory>>>;
  /** Fetch findAuctionItemImages. */
  findAuctionItemImages?: Maybe<Array<Maybe<AuctionItemImage>>>;
  /** Fetch findAuctionItems. */
  findAuctionItems?: Maybe<Array<Maybe<AuctionItem>>>;
  /** Fetch findAuctions. */
  findAuctions?: Maybe<Array<Maybe<Auction>>>;
  /** Fetch findCampaignEvents. */
  findCampaignEvents?: Maybe<Array<Maybe<CampaignEvent>>>;
  /** Fetch findCampaignMessageAudiences. */
  findCampaignMessageAudiences?: Maybe<Array<Maybe<CampaignMessageAudience>>>;
  /** Fetch findCampaignMessages. */
  findCampaignMessages?: Maybe<Array<Maybe<CampaignMessage>>>;
  /** Fetch findCampaignPages. */
  findCampaignPages?: Maybe<Array<Maybe<CampaignPage>>>;
  /** Fetch findCampaignTypes. */
  findCampaignTypes?: Maybe<Array<Maybe<CampaignType>>>;
  /** Fetch findCampaignWidgets. */
  findCampaignWidgets?: Maybe<Array<Maybe<CampaignWidget>>>;
  /** Fetch findCampaigns. */
  findCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  /** Fetch findChargeTypes. */
  findChargeTypes?: Maybe<Array<Maybe<ChargeType>>>;
  /** Fetch findContacts. */
  findContacts?: Maybe<Array<Maybe<Contact>>>;
  /** Fetch findCustomTextBlocks. */
  findCustomTextBlocks?: Maybe<Array<Maybe<CustomTextBlock>>>;
  /** Fetch findDonationMatches. */
  findDonationMatches?: Maybe<Array<Maybe<DonationMatch>>>;
  /** Fetch findDonationReplies. */
  findDonationReplies?: Maybe<Array<Maybe<DonationReply>>>;
  /** Fetch findDonationTypes. */
  findDonationTypes?: Maybe<Array<Maybe<DonationType>>>;
  /** Fetch findDonations. */
  findDonations?: Maybe<Array<Maybe<Donation>>>;
  /** Fetch findEmbedWidgets. */
  findEmbedWidgets?: Maybe<Array<Maybe<EmbedWidget>>>;
  /** Fetch findEventTableSponsors. */
  findEventTableSponsors?: Maybe<Array<Maybe<EventTableSponsor>>>;
  /** Fetch findEventTableTicketGroups. */
  findEventTableTicketGroups?: Maybe<Array<Maybe<EventTableTicketGroup>>>;
  /** Fetch findEventTables. */
  findEventTables?: Maybe<Array<Maybe<EventTable>>>;
  /** Fetch findFundraiserAchievements. */
  findFundraiserAchievements?: Maybe<Array<Maybe<FundraiserAchievement>>>;
  /** Fetch findFundraisers. */
  findFundraisers?: Maybe<Array<Maybe<Fundraiser>>>;
  /** Fetch findFundraisingUpdates. */
  findFundraisingUpdates?: Maybe<Array<Maybe<FundraisingUpdate>>>;
  /** Fetch findGivingPlans. */
  findGivingPlans?: Maybe<Array<Maybe<GivingPlan>>>;
  /** Fetch findGlobalQuestionOptions. */
  findGlobalQuestionOptions?: Maybe<Array<Maybe<GlobalQuestionOption>>>;
  /** Fetch findGlobalQuestions. */
  findGlobalQuestions?: Maybe<Array<Maybe<GlobalQuestion>>>;
  findGroupLeaderboardGroup?: Maybe<GroupLeaderboardGroup>;
  /** Fetch findIntervalReminders. */
  findIntervalReminders?: Maybe<Array<Maybe<IntervalReminder>>>;
  /** Fetch findLiveAuctionItems. */
  findLiveAuctionItems?: Maybe<Array<Maybe<LiveAuctionItem>>>;
  /** Fetch findLiveDisplays. */
  findLiveDisplays?: Maybe<Array<Maybe<LiveDisplay>>>;
  /** Fetch findMatches. */
  findMatches?: Maybe<Array<Maybe<Match>>>;
  /** Fetch findNeeds. */
  findNeeds?: Maybe<Array<Maybe<Need>>>;
  /** Fetch findOrderMiscItems. */
  findOrderMiscItems?: Maybe<Array<Maybe<OrderMiscItem>>>;
  /** Fetch findOrders. */
  findOrders?: Maybe<Array<Maybe<Order>>>;
  /** Fetch findOrganizations. */
  findOrganizations?: Maybe<Array<Maybe<Organization>>>;
  findParticipants?: Maybe<Array<Maybe<Fundraiser>>>;
  /** Fetch findProductVariants. */
  findProductVariants?: Maybe<Array<Maybe<ProductVariant>>>;
  /** Fetch findProducts. */
  findProducts?: Maybe<Array<Maybe<Product>>>;
  findPrograms?: Maybe<Array<Maybe<Program>>>;
  /** Fetch findQuestionAnswers. */
  findQuestionAnswers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  /** Fetch findQuestionOptions. */
  findQuestionOptions?: Maybe<Array<Maybe<QuestionOption>>>;
  /** Fetch findQuestionRegistrationTypes. */
  findQuestionRegistrationTypes?: Maybe<Array<Maybe<QuestionRegistrationType>>>;
  /** Fetch findQuestions. */
  findQuestions?: Maybe<Array<Maybe<Question>>>;
  /** Returns one  RaffleOrder. */
  findRaffleOrder?: Maybe<RaffleOrder>;
  /** Fetch findRaffleOrderItems. */
  findRaffleOrderItems?: Maybe<Array<Maybe<RaffleOrderItem>>>;
  /** Fetch findRaffleOrders. */
  findRaffleOrders?: Maybe<Array<Maybe<RaffleOrder>>>;
  /** Fetch findRaffleWinningDraws. */
  findRaffleWinningDraws?: Maybe<Array<Maybe<RaffleWinningDraw>>>;
  /** Fetch findRaffles. */
  findRaffles?: Maybe<Array<Maybe<Raffle>>>;
  /** Fetch findReactions. */
  findReactions?: Maybe<Array<Maybe<Reaction>>>;
  /** Fetch findRegistrationTypes. */
  findRegistrationTypes?: Maybe<Array<Maybe<RegistrationType>>>;
  /** Fetch findReportTemplates. */
  findReportTemplates?: Maybe<Array<Maybe<ReportTemplate>>>;
  /** Fetch findSoldProducts. */
  findSoldProducts?: Maybe<Array<Maybe<SoldProduct>>>;
  /** Fetch findSoldTicketBundles. */
  findSoldTicketBundles?: Maybe<Array<Maybe<SoldTicketBundle>>>;
  findSponsorInvoice: SponsorInvoiceResult;
  /** Fetch findSponsors. */
  findSponsors?: Maybe<Array<Maybe<Sponsor>>>;
  /** Fetch findTeamMessageBoardPosts. */
  findTeamMessageBoardPosts?: Maybe<Array<Maybe<TeamMessageBoardPost>>>;
  /** Fetch findTeams. */
  findTeams?: Maybe<Array<Maybe<Team>>>;
  /** Fetch findTicketGroups. */
  findTicketGroups?: Maybe<Array<Maybe<TicketGroup>>>;
  /** Fetch findTickets. */
  findTickets?: Maybe<Array<Maybe<Ticket>>>;
  findTimeZones?: Maybe<Array<TimeZone>>;
  /** Fetch findTipTapMigrations. */
  findTipTapMigrations?: Maybe<Array<Maybe<TipTapMigration>>>;
  /** Fetch findUsers. */
  findUsers?: Maybe<Array<Maybe<User>>>;
  /** Fetch findWonLiveAuctionItems. */
  findWonLiveAuctionItems?: Maybe<Array<Maybe<WonLiveAuctionItem>>>;
  /** A count of the total number of objects in this connection, ignoring pagination. */
  fundraisingUpdateCount?: Maybe<Scalars['Int']['output']>;
  gatewayService?: Maybe<GatewayServiceRoot>;
  getEmailCustomization: EmailCustomization;
  getSlug?: Maybe<Slug>;
  me?: Maybe<User>;
  messageService?: Maybe<MessageServiceRootQuery>;
  myAuctions: Array<Auction>;
  myCampaigns: Array<Campaign>;
  myOrganizations: Array<Organization>;
  myPrograms: Array<Program>;
  /** A count of the total number of objects in this connection, ignoring pagination. */
  organizationCount?: Maybe<Scalars['Int']['output']>;
  search: Array<SearchResult>;
  timeout?: Maybe<Scalars['Boolean']['output']>;
  userExists?: Maybe<Scalars['Boolean']['output']>;
  validateTicketGroupInviteCode?: Maybe<RegistrationType>;
  validationSchemas?: Maybe<Scalars['SequelizeJSON']['output']>;
};


export type QueryCalculateOrderAmountArgs = {
  order: CalculateOrderInput;
};


export type QueryFindAchievementLevelsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAchievementsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindActivityMetricsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAddOnsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAdminInvitesArgs = {
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<AdminInviteResourceTypeEnum>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAuctionBiddersArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAuctionBidsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAuctionCategoriesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAuctionItemImagesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAuctionItemsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindAuctionsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCampaignEventsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCampaignMessageAudiencesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCampaignMessagesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCampaignPagesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCampaignTypesArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCampaignWidgetsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCampaignsArgs = {
  fetchDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindChargeTypesArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindContactsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindCustomTextBlocksArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindDonationMatchesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindDonationRepliesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindDonationTypesArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindDonationsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindEmbedWidgetsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindEventTableSponsorsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindEventTableTicketGroupsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindEventTablesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindFundraiserAchievementsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindFundraisersArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindFundraisingUpdatesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindGivingPlansArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindGlobalQuestionOptionsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindGlobalQuestionsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindGroupLeaderboardGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindIntervalRemindersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindLiveAuctionItemsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindLiveDisplaysArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindMatchesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindNeedsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindOrderMiscItemsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindOrdersArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindOrganizationsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindParticipantsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindProductVariantsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindProductsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindProgramsArgs = {
  fetchDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindQuestionAnswersArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindQuestionOptionsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindQuestionRegistrationTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindQuestionsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindRaffleOrderArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindRaffleOrderItemsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindRaffleOrdersArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindRaffleWinningDrawsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindRafflesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindReactionsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindRegistrationTypesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindReportTemplatesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindSoldProductsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindSoldTicketBundlesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindSponsorInvoiceArgs = {
  token: Scalars['String']['input'];
};


export type QueryFindSponsorsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindTeamMessageBoardPostsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindTeamsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindTicketGroupsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindTicketsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindTipTapMigrationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindUsersArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFindWonLiveAuctionItemsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryFundraisingUpdateCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryGetEmailCustomizationArgs = {
  campaignId: Scalars['String']['input'];
  messageType: CustomizableMessageTypeEnum;
};


export type QueryGetSlugArgs = {
  key: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<SlugScopeEnum>;
};


export type QueryMyAuctionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryMyCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryMyOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryMyProgramsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryOrganizationCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QuerySearchArgs = {
  asUser?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  types?: InputMaybe<Array<InputMaybe<SearchResultTypeEnum>>>;
};


export type QueryTimeoutArgs = {
  duration: Scalars['Int']['input'];
};


export type QueryUserExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateTicketGroupInviteCodeArgs = {
  campaignId: Scalars['String']['input'];
  inviteCode: Scalars['String']['input'];
};


export type QueryValidationSchemasArgs = {
  type: ModelValidationSchema;
};

export type Question = {
  __typename?: 'Question';
  QuestionRegistrationType?: Maybe<QuestionRegistrationType>;
  answerCount: Scalars['Int']['output'];
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  assigningRegistrationTypes?: Maybe<Array<Maybe<RegistrationType>>>;
  audienceType: QuestionaudienceTypeEnumType;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  config: Scalars['SequelizeJSON']['output'];
  createdAt: Scalars['Date']['output'];
  formattedParts: Array<Scalars['String']['output']>;
  globalQuestion?: Maybe<GlobalQuestion>;
  globalQuestionId?: Maybe<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<QuestionOption>>>;
  sort: Scalars['Int']['output'];
  tags: Scalars['SequelizeJSON']['output'];
  type: QuestiontypeEnumType;
  updatedAt: Scalars['Date']['output'];
};


export type QuestionAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QuestionAssigningRegistrationTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QuestionOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  addOnId?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  donation?: Maybe<Donation>;
  donationId?: Maybe<Scalars['String']['output']>;
  formattedAnswer?: Maybe<Scalars['SequelizeJSON']['output']>;
  id: Scalars['String']['output'];
  participant?: Maybe<Fundraiser>;
  participantId?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Question>;
  questionId: Scalars['String']['output'];
  questionOption?: Maybe<QuestionOption>;
  questionOptionId?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionAnswerInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  addOnId?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  questionOptionId?: InputMaybe<Scalars['String']['input']>;
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type QuestionInput = {
  QuestionRegistrationType?: InputMaybe<QuestionRegistrationTypeInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  answers?: InputMaybe<Array<InputMaybe<QuestionAnswerInput>>>;
  assigningRegistrationTypes?: InputMaybe<Array<InputMaybe<RegistrationTypeInput>>>;
  audienceType?: InputMaybe<QuestionaudienceTypeEnumType>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  globalQuestionId?: InputMaybe<Scalars['String']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<QuestionOptionInput>>>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  type?: InputMaybe<QuestiontypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type QuestionOption = {
  __typename?: 'QuestionOption';
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  createdAt: Scalars['Date']['output'];
  globalQuestionOption?: Maybe<GlobalQuestionOption>;
  globalQuestionOptionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  question?: Maybe<Question>;
  questionId: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type QuestionOptionAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type QuestionOptionInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  answers?: InputMaybe<Array<InputMaybe<QuestionAnswerInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  globalQuestionOptionId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type QuestionRegistrationType = {
  __typename?: 'QuestionRegistrationType';
  createdAt: Scalars['Date']['output'];
  questionId: Scalars['String']['output'];
  registrationTypeId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type QuestionRegistrationTypeInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum QuestionaudienceTypeEnumType {
  Donation = 'donation',
  Participant = 'participant',
  Sponsor = 'sponsor'
}

export enum QuestiontypeEnumType {
  Address = 'address',
  Choice = 'choice',
  Currency = 'currency',
  Date = 'date',
  Number = 'number',
  Phone = 'phone',
  TextMultipleLine = 'text_multiple_line',
  TextSingleLine = 'text_single_line',
  WaiverSimple = 'waiver_simple',
  YesNo = 'yes_no'
}

export type Raffle = {
  __typename?: 'Raffle';
  amount: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['SequelizeJSON']['output']>;
  entryPackages: Scalars['SequelizeJSON']['output'];
  id: Scalars['String']['output'];
  isFeatured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  qtyRemaining?: Maybe<Scalars['Int']['output']>;
  qtyTotal?: Maybe<Scalars['Int']['output']>;
  qtyUsed: Scalars['Int']['output'];
  raffleOrderItems?: Maybe<Array<Maybe<RaffleOrderItem>>>;
  status: RafflestatusEnumType;
  type: RaffletypeEnumType;
  updatedAt: Scalars['Date']['output'];
  winningOrderItems: Array<RaffleOrderItem>;
};


export type RaffleRaffleOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type RaffleInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  entryPackages?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  qtyRemaining?: InputMaybe<Scalars['Int']['input']>;
  qtyTotal?: InputMaybe<Scalars['Int']['input']>;
  qtyUsed?: InputMaybe<Scalars['Int']['input']>;
  raffleOrderItems?: InputMaybe<Array<InputMaybe<RaffleOrderItemInput>>>;
  status?: InputMaybe<RafflestatusEnumType>;
  type?: InputMaybe<RaffletypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type RaffleOrder = {
  __typename?: 'RaffleOrder';
  activationData?: Maybe<Scalars['SequelizeJSON']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  charge: PayableCharge;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coveredFees: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  didCoverFee?: Maybe<Scalars['Boolean']['output']>;
  didCoverPlatformFee: Scalars['Boolean']['output'];
  didCoverProcessorFee: Scalars['Boolean']['output'];
  discountAmount: Scalars['String']['output'];
  discountConfig?: Maybe<Scalars['SequelizeJSON']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  items?: Maybe<Array<Maybe<RaffleOrderItem>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodExpMonth?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpYear?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpiration?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  paymentProcessorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  paymentProcessorType?: Maybe<RaffleOrderpaymentProcessorTypeEnumType>;
  paymentSourceData?: Maybe<Scalars['SequelizeJSON']['output']>;
  paymentSourceKey?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platformFee: Scalars['String']['output'];
  platformFeePercent: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  processorFeePercent: Scalars['String']['output'];
  requestMeta?: Maybe<Scalars['SequelizeJSON']['output']>;
  stateProv?: Maybe<Scalars['String']['output']>;
  status: RaffleOrderstatusEnumType;
  tip: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};


export type RaffleOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type RaffleOrderInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  activationData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coveredFees?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  didCoverFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  didCoverProcessorFee?: InputMaybe<Scalars['Boolean']['input']>;
  discountAmount?: InputMaybe<Scalars['String']['input']>;
  discountConfig?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<RaffleOrderItemInput>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodBrand?: InputMaybe<Scalars['String']['input']>;
  paymentMethodExpMonth?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpYear?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  paymentProcessorData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  paymentProcessorType?: InputMaybe<RaffleOrderpaymentProcessorTypeEnumType>;
  paymentSourceData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  paymentSourceKey?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['String']['input']>;
  platformFeePercent?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  processorFeePercent?: InputMaybe<Scalars['String']['input']>;
  requestMeta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RaffleOrderstatusEnumType>;
  tip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type RaffleOrderItem = {
  __typename?: 'RaffleOrderItem';
  amount?: Maybe<Scalars['Int']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  entries?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  raffle?: Maybe<Raffle>;
  raffleId?: Maybe<Scalars['String']['output']>;
  raffleOrder?: Maybe<RaffleOrder>;
  raffleOrderId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  winnerDrawnAt?: Maybe<Scalars['Date']['output']>;
  winningDraws?: Maybe<Array<Maybe<RaffleWinningDraw>>>;
};


export type RaffleOrderItemWinningDrawsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type RaffleOrderItemInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  entries?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  raffleId?: InputMaybe<Scalars['String']['input']>;
  raffleOrderId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  winningDraws?: InputMaybe<Array<InputMaybe<RaffleWinningDrawInput>>>;
};

export enum RaffleOrderpaymentProcessorTypeEnumType {
  Stripe = 'stripe'
}

export enum RaffleOrderstatusEnumType {
  Active = 'active',
  Pending = 'pending'
}

export type RaffleWinningDraw = {
  __typename?: 'RaffleWinningDraw';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  raffleOrderItem?: Maybe<RaffleOrderItem>;
  raffleOrderItemId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type RaffleWinningDrawInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  raffleOrderItemId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type RafflesCampaignWidget = CampaignWidget & {
  __typename?: 'RafflesCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export enum RafflestatusEnumType {
  Closed = 'closed',
  Open = 'open'
}

export enum RaffletypeEnumType {
  FiftyFifty = 'fifty_fifty',
  SingleItem = 'single_item'
}

export type Reaction = {
  __typename?: 'Reaction';
  FundraisingUpdateId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  reactionType: ReactionreactionTypeEnumType;
  requestMeta?: Maybe<Scalars['SequelizeJSON']['output']>;
  subjectId: Scalars['String']['output'];
  subjectType: ReactionsubjectTypeEnumType;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ReactionInput = {
  FundraisingUpdateId?: InputMaybe<Scalars['String']['input']>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reactionType?: InputMaybe<ReactionreactionTypeEnumType>;
  requestMeta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<ReactionsubjectTypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ReactionWithToken = {
  __typename?: 'ReactionWithToken';
  id: Scalars['String']['output'];
  reactionType: ReactionreactionTypeEnumType;
  subjectId: Scalars['String']['output'];
  subjectType: ReactionsubjectTypeEnumType;
  token?: Maybe<Scalars['String']['output']>;
};

export enum ReactionreactionTypeEnumType {
  Clap = 'clap',
  Cry = 'cry',
  Haha = 'haha',
  Like = 'like',
  Love = 'love',
  Wow = 'wow',
  Yay = 'yay'
}

export enum ReactionsubjectTypeEnumType {
  FundraisingUpdate = 'FundraisingUpdate'
}

export type RegistrationAmount = {
  __typename?: 'RegistrationAmount';
  adjustedAmount: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  discountAmount: Scalars['String']['output'];
};

export type RegistrationType = {
  __typename?: 'RegistrationType';
  QuestionRegistrationType?: Maybe<QuestionRegistrationType>;
  allQuestions: Array<Maybe<Question>>;
  amount: Scalars['String']['output'];
  assignedQuestions?: Maybe<Array<Maybe<Question>>>;
  bundleOptions?: Maybe<Array<Maybe<RegistrationType>>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  collectAddress: RegistrationTypecollectAddressEnumType;
  collectEmail: RegistrationTypecollectEmailEnumType;
  collectPhone: RegistrationTypecollectPhoneEnumType;
  commitmentAmount?: Maybe<Scalars['Int']['output']>;
  commitmentDeadline?: Maybe<Scalars['String']['output']>;
  commitmentDescription?: Maybe<Scalars['SequelizeJSON']['output']>;
  committedFundraiserCount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deductibleAmount?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['SequelizeJSON']['output']>;
  donations?: Maybe<Array<Maybe<Donation>>>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  includedTicketOption?: Maybe<RegistrationType>;
  includedTicketOptionId?: Maybe<Scalars['String']['output']>;
  includedTicketQuantity?: Maybe<Scalars['Int']['output']>;
  isAddOn: Scalars['Boolean']['output'];
  isCommitmentEnabled: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nonDeductibleAmount?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Maybe<Fundraiser>>>;
  qtyRemaining?: Maybe<Scalars['Int']['output']>;
  qtyTotal?: Maybe<Scalars['Int']['output']>;
  qtyUsed: Scalars['Int']['output'];
  questionsDisabledOnDelete: Array<Maybe<Question>>;
  sort: Scalars['Int']['output'];
  sponsorBenefits?: Maybe<Scalars['SequelizeJSON']['output']>;
  sponsorPackages?: Maybe<Array<Maybe<RegistrationType>>>;
  startDate?: Maybe<Scalars['String']['output']>;
  type: RegistrationTypetypeEnumType;
  updatedAt: Scalars['Date']['output'];
  usedCount: Scalars['Int']['output'];
};


export type RegistrationTypeAllQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type RegistrationTypeAssignedQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type RegistrationTypeBundleOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type RegistrationTypeDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type RegistrationTypeParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type RegistrationTypeSponsorPackagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type RegistrationTypeInput = {
  QuestionRegistrationType?: InputMaybe<QuestionRegistrationTypeInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  assignedQuestions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  bundleOptions?: InputMaybe<Array<InputMaybe<RegistrationTypeInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  collectAddress?: InputMaybe<RegistrationTypecollectAddressEnumType>;
  collectEmail?: InputMaybe<RegistrationTypecollectEmailEnumType>;
  collectPhone?: InputMaybe<RegistrationTypecollectPhoneEnumType>;
  commitmentAmount?: InputMaybe<Scalars['Int']['input']>;
  commitmentDeadline?: InputMaybe<Scalars['String']['input']>;
  commitmentDescription?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deductibleAmount?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  donations?: InputMaybe<Array<InputMaybe<DonationInput>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  includedTicketOptionId?: InputMaybe<Scalars['String']['input']>;
  includedTicketQuantity?: InputMaybe<Scalars['Int']['input']>;
  isAddOn?: InputMaybe<Scalars['Boolean']['input']>;
  isCommitmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonDeductibleAmount?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  qtyRemaining?: InputMaybe<Scalars['Int']['input']>;
  qtyTotal?: InputMaybe<Scalars['Int']['input']>;
  qtyUsed?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  sponsorBenefits?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  sponsorPackages?: InputMaybe<Array<InputMaybe<RegistrationTypeInput>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RegistrationTypetypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum RegistrationTypecollectAddressEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum RegistrationTypecollectEmailEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum RegistrationTypecollectPhoneEnumType {
  Off = 'off',
  Optional = 'optional',
  Required = 'required'
}

export enum RegistrationTypetypeEnumType {
  AddOn = 'add_on',
  Participant = 'participant',
  Sponsor = 'sponsor',
  TicketBundle = 'ticket_bundle'
}

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  campaignIds?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  customEndDate?: Maybe<Scalars['String']['output']>;
  customStartDate?: Maybe<Scalars['String']['output']>;
  forceIncludeQuestions: ReportTemplateforceIncludeQuestionsEnumType;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  objectType: ReportTemplateobjectTypeEnumType;
  timePeriod: ReportTemplatetimePeriodEnumType;
  type: ReportTemplatetypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type ReportTemplateInput = {
  campaignIds?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customEndDate?: InputMaybe<Scalars['String']['input']>;
  customStartDate?: InputMaybe<Scalars['String']['input']>;
  forceIncludeQuestions?: InputMaybe<ReportTemplateforceIncludeQuestionsEnumType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<ReportTemplateobjectTypeEnumType>;
  timePeriod?: InputMaybe<ReportTemplatetimePeriodEnumType>;
  type?: InputMaybe<ReportTemplatetypeEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum ReportTemplateforceIncludeQuestionsEnumType {
  All = 'all',
  Global = 'global',
  None = 'none'
}

export enum ReportTemplateobjectTypeEnumType {
  Campaign = 'campaign',
  Organization = 'organization',
  Program = 'program'
}

export enum ReportTemplatetimePeriodEnumType {
  All = 'all',
  Custom = 'custom',
  Last3months = 'last3months',
  Last7days = 'last7days',
  Last30days = 'last30days',
  MonthToDate = 'monthToDate',
  YearToDate = 'yearToDate'
}

export enum ReportTemplatetypeEnumType {
  AddOns = 'addOns',
  AuctionItems = 'auctionItems',
  Donations = 'donations',
  EventTables = 'eventTables',
  Givingplans = 'givingplans',
  Orders = 'orders',
  Participants = 'participants',
  TeamCaptains = 'teamCaptains',
  Teams = 'teams',
  Transactions = 'transactions'
}

export type RetryChargeAuctionWinnerResult = {
  __typename?: 'RetryChargeAuctionWinnerResult';
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RetryChargeGivingPlanResult = {
  __typename?: 'RetryChargeGivingPlanResult';
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SearchResult = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export enum SearchResultParticipantTypeEnum {
  Fundraiser = 'Fundraiser',
  Ticket = 'Ticket'
}

export enum SearchResultTypeEnum {
  Bidder = 'Bidder',
  Campaign = 'Campaign',
  Donation = 'Donation',
  Fundraiser = 'Fundraiser',
  Order = 'Order',
  Participant = 'Participant',
  Program = 'Program',
  Team = 'Team'
}

export type ShopCampaignWidget = CampaignWidget & {
  __typename?: 'ShopCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type ShopOrdersTable = {
  __typename?: 'ShopOrdersTable';
  count: Scalars['Int']['output'];
  rows: Array<SoldProduct>;
};

export type Slug = {
  __typename?: 'Slug';
  key: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  scope: SlugScopeEnum;
  type: SlugTypeEnum;
};

export enum SlugScopeEnum {
  Participant = 'participant',
  Root = 'root',
  Team = 'team'
}

export enum SlugTypeEnum {
  Campaign = 'Campaign',
  Fundraiser = 'Fundraiser',
  Program = 'Program',
  Team = 'Team'
}

export type SoldProduct = {
  __typename?: 'SoldProduct';
  amount: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  noteResponse?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  product?: Maybe<Product>;
  productId: Scalars['String']['output'];
  selectedVariant?: Maybe<ProductVariant>;
  selectedVariantId?: Maybe<Scalars['String']['output']>;
  status: SoldProductstatusEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type SoldProductInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  noteResponse?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  selectedVariantId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SoldProductstatusEnumType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum SoldProductstatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled'
}

export type SoldTicketBundle = {
  __typename?: 'SoldTicketBundle';
  amount: Scalars['String']['output'];
  bundleOption?: Maybe<RegistrationType>;
  bundleOptionId: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deductibleAmount?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nonDeductibleAmount?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  ticketGroup?: Maybe<TicketGroup>;
  ticketGroupId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SoldTicketBundleInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  bundleOptionId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deductibleAmount?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nonDeductibleAmount?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  ticketGroupId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type Sponsor = {
  __typename?: 'Sponsor';
  EventTableSponsor?: Maybe<EventTableSponsor>;
  activationData?: Maybe<Scalars['SequelizeJSON']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  charge: PayableCharge;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coveredFees: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  didCoverFee?: Maybe<Scalars['Boolean']['output']>;
  didCoverPlatformFee: Scalars['Boolean']['output'];
  didCoverProcessorFee: Scalars['Boolean']['output'];
  displayId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  isPackageCustomized: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  packageCustomizationNote?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['Date']['output']>;
  paymentInfo?: Maybe<Scalars['String']['output']>;
  paymentMethodBrand?: Maybe<Scalars['String']['output']>;
  paymentMethodExpMonth?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpYear?: Maybe<Scalars['Int']['output']>;
  paymentMethodExpiration?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  paymentType: SponsorpaymentTypeEnumType;
  paymentTypeLabel?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platformFee: Scalars['String']['output'];
  platformFeePercent: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  processorFeePercent: Scalars['String']['output'];
  registrationType?: Maybe<RegistrationType>;
  registrationTypeId: Scalars['String']['output'];
  sponsorBuyer?: Maybe<User>;
  sponsorBuyerId?: Maybe<Scalars['String']['output']>;
  stateProv?: Maybe<Scalars['String']['output']>;
  tableReservations?: Maybe<Array<Maybe<EventTable>>>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  ticketGroup?: Maybe<TicketGroup>;
  ticketGroupId?: Maybe<Scalars['String']['output']>;
  ticketOption?: Maybe<RegistrationType>;
  ticketOptionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type SponsorAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type SponsorTableReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type SponsorAmount = {
  __typename?: 'SponsorAmount';
  coveredFeeAmount: Scalars['String']['output'];
  sponsorAmount: Scalars['String']['output'];
  totalAmount: Scalars['String']['output'];
};

export type SponsorInput = {
  EventTableSponsor?: InputMaybe<EventTableSponsorInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  activationData?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<InputMaybe<QuestionAnswerInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  didCoverFee?: InputMaybe<Scalars['Boolean']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  isPackageCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packageCustomizationNote?: InputMaybe<Scalars['String']['input']>;
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
  paymentMethodBrand?: InputMaybe<Scalars['String']['input']>;
  paymentMethodExpMonth?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpYear?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodExpiration?: InputMaybe<Scalars['String']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  paymentTypeLabel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  registrationTypeId?: InputMaybe<Scalars['String']['input']>;
  sendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorBuyerId?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  tableReservations?: InputMaybe<Array<InputMaybe<EventTableInput>>>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  ticketGroupId?: InputMaybe<Scalars['String']['input']>;
  ticketOptionId?: InputMaybe<Scalars['String']['input']>;
  ticketQtyTotal?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SponsorInvoiceResult = {
  __typename?: 'SponsorInvoiceResult';
  error?: Maybe<Scalars['String']['output']>;
  sponsor?: Maybe<Sponsor>;
};

export type SponsorPackagesCampaignWidget = CampaignWidget & {
  __typename?: 'SponsorPackagesCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export enum SponsorpaymentTypeEnumType {
  Card = 'card',
  CashCheck = 'cash_check',
  Invoice = 'invoice'
}

export type SponsorsCampaignWidget = CampaignWidget & {
  __typename?: 'SponsorsCampaignWidget';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  campaignPage?: Maybe<CampaignPage>;
  campaignPageId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  scope: CampaignWidgetscopeEnumType;
  title?: Maybe<Scalars['String']['output']>;
  type: CampaignWidgettypeEnumType;
  updatedAt: Scalars['Date']['output'];
};

export type Team = {
  __typename?: 'Team';
  aggregatedPerformanceResult: Scalars['String']['output'];
  amITeamCaptain: Scalars['Boolean']['output'];
  amountRaised: Scalars['String']['output'];
  avatarImage?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  dailyStats: Array<Maybe<TeamDailyStats>>;
  displayId?: Maybe<Scalars['String']['output']>;
  donationCount: Scalars['Int']['output'];
  donations?: Maybe<Array<Maybe<Donation>>>;
  headerImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  members?: Maybe<Array<Maybe<Fundraiser>>>;
  messageBoardPosts?: Maybe<Array<Maybe<TeamMessageBoardPost>>>;
  metricLabelPluralWhenUnlocked?: Maybe<Scalars['String']['output']>;
  metricLabelWhenUnlocked?: Maybe<Scalars['String']['output']>;
  /** Required monetary goal for the Team (in whole dollars). Defaults to 1000 */
  monetaryGoal: Scalars['Int']['output'];
  myPermissions?: Maybe<Array<Scalars['String']['output']>>;
  myPreviousTeamForInvite?: Maybe<Team>;
  name: Scalars['String']['output'];
  performanceEstimate?: Maybe<Scalars['Int']['output']>;
  performanceSettings?: Maybe<PerformanceSettings>;
  /** Array of four values */
  pledgePresets?: Maybe<Scalars['SequelizeJSON']['output']>;
  previousTeam?: Maybe<Team>;
  previousTeamId?: Maybe<Scalars['String']['output']>;
  recentActivity: Array<TeamActivity>;
  searchFundraisers?: Maybe<Array<Maybe<FundraiserSearchResult>>>;
  searchText?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<FundraisingStats>;
  /** Stored in AST */
  story: Scalars['SequelizeJSON']['output'];
  storyTitle?: Maybe<Scalars['String']['output']>;
  subsequentTeams?: Maybe<Array<Maybe<Team>>>;
  teamCaptains?: Maybe<Array<Maybe<Fundraiser>>>;
  totalFlatAmount: Scalars['String']['output'];
  totalMatchAmount: Scalars['String']['output'];
  totalOfflineFlatAmount: Scalars['String']['output'];
  totalRegistrationAmount: Scalars['String']['output'];
  totalSponsorAmount: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  updates: Array<Maybe<FundraisingUpdate>>;
  updatesCount: Scalars['Int']['output'];
};


export type TeamDailyStatsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type TeamDonationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type TeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type TeamMessageBoardPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type TeamRecentActivityArgs = {
  limit: Scalars['Int']['input'];
};


export type TeamSearchFundraisersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamSubsequentTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type TeamTeamCaptainsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type TeamUpdatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type TeamUpdatesCountArgs = {
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type TeamActivity = DonationCreatedActivity | FundraisingUpdateActivity | PerformanceUpdateActivity | TeamJoinActivity;

export enum TeamCaptainNudgeAudienceEnum {
  All = 'all',
  NotRejoined = 'not_rejoined'
}

export type TeamDailyStats = {
  __typename?: 'TeamDailyStats';
  amountRaised: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  donationCount: Scalars['Int']['output'];
  participantAmount: Scalars['Float']['output'];
  participantCount: Scalars['Int']['output'];
  performanceResult: Scalars['Float']['output'];
};

export type TeamInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  avatarImage?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  displayId?: InputMaybe<Scalars['String']['input']>;
  donations?: InputMaybe<Array<InputMaybe<DonationInput>>>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  messageBoardPosts?: InputMaybe<Array<InputMaybe<TeamMessageBoardPostInput>>>;
  metricLabelPluralWhenUnlocked?: InputMaybe<Scalars['String']['input']>;
  metricLabelWhenUnlocked?: InputMaybe<Scalars['String']['input']>;
  /** Required monetary goal for the Team (in whole dollars). Defaults to 1000 */
  monetaryGoal?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  performanceEstimate?: InputMaybe<Scalars['Int']['input']>;
  /** Array of four values */
  pledgePresets?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  previousTeamId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Stored in AST */
  story?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  storyTitle?: InputMaybe<Scalars['String']['input']>;
  subsequentTeams?: InputMaybe<Array<InputMaybe<TeamInput>>>;
  teamCaptains?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TeamJoinActivity = ItemActivity & {
  __typename?: 'TeamJoinActivity';
  fundraiser: Fundraiser;
  timestamp: Scalars['Date']['output'];
};

export type TeamMessageBoardPost = {
  __typename?: 'TeamMessageBoardPost';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPinned: Scalars['Boolean']['output'];
  message: Scalars['SequelizeJSON']['output'];
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type TeamMessageBoardPostInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TeamSearchResult = SearchResult & {
  __typename?: 'TeamSearchResult';
  avatarImage?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  searchText: Scalars['String']['output'];
  type: SearchResultTypeEnum;
};

export type Ticket = {
  __typename?: 'Ticket';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  deductibleAmount?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isForBuyer: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  nonDeductibleAmount?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  originalAmount: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<RegistrationType>;
  registrationTypeId: Scalars['String']['output'];
  searchText?: Maybe<Scalars['String']['output']>;
  stateProv?: Maybe<Scalars['String']['output']>;
  status: TicketstatusEnumType;
  updatedAt: Scalars['Date']['output'];
};


export type TicketAnswersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type TicketGroup = {
  __typename?: 'TicketGroup';
  EventTableTicketGroup?: Maybe<EventTableTicketGroup>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  inviteCode: Scalars['String']['output'];
  resolvedName?: Maybe<Scalars['String']['output']>;
  soldTicketBundle?: Maybe<SoldTicketBundle>;
  sponsor?: Maybe<Sponsor>;
  tableReservations?: Maybe<Array<Maybe<EventTable>>>;
  ticketOption?: Maybe<RegistrationType>;
  ticketOptionId: Scalars['String']['output'];
  ticketQtyRemaining?: Maybe<Scalars['Int']['output']>;
  ticketQtyTotal?: Maybe<Scalars['Int']['output']>;
  ticketQtyUsed: Scalars['Int']['output'];
  tickets?: Maybe<Array<Maybe<Fundraiser>>>;
  updatedAt: Scalars['Date']['output'];
};


export type TicketGroupTableReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  throughWhere?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type TicketGroupTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type TicketGroupGuest = {
  __typename?: 'TicketGroupGuest';
  orderId?: Maybe<Scalars['String']['output']>;
  resolvedEmail?: Maybe<Scalars['String']['output']>;
  resolvedName?: Maybe<Scalars['String']['output']>;
  ticketGroup?: Maybe<TicketGroup>;
};

export type TicketGroupInput = {
  EventTableTicketGroup?: InputMaybe<EventTableTicketGroupInput>;
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  soldTicketBundle?: InputMaybe<SoldTicketBundleInput>;
  sponsor?: InputMaybe<SponsorInput>;
  tableReservations?: InputMaybe<Array<InputMaybe<EventTableInput>>>;
  ticketOptionId?: InputMaybe<Scalars['String']['input']>;
  ticketQtyRemaining?: InputMaybe<Scalars['Int']['input']>;
  ticketQtyTotal?: InputMaybe<Scalars['Int']['input']>;
  ticketQtyUsed?: InputMaybe<Scalars['Int']['input']>;
  tickets?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export enum TicketstatusEnumType {
  Active = 'active',
  Cancelled = 'cancelled',
  CheckedIn = 'checked_in',
  Pending = 'pending'
}

export type TimeZone = {
  __typename?: 'TimeZone';
  baseOffset: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TipTapMigration = {
  __typename?: 'TipTapMigration';
  convertedAst?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  field: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  originalAst?: Maybe<Scalars['SequelizeJSON']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type TipTapMigrationInput = {
  convertedAst?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  originalAst?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  donation?: Maybe<Donation>;
  gross: Scalars['String']['output'];
  id: Scalars['String']['output'];
  net: Scalars['String']['output'];
  order?: Maybe<Order>;
  paidAt?: Maybe<Scalars['Date']['output']>;
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  type: TransactionTypeEnum;
};

export enum TransactionTypeEnum {
  Donation = 'donation',
  Order = 'order',
  Pledge = 'pledge',
  Registration = 'registration'
}

export type UpdateAdminInviteInput = {
  id: Scalars['String']['input'];
  roleCode: Scalars['String']['input'];
};

export type UpdateGivingPlanInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<GivingPlanfrequencyEnumType>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nextChargeDate?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateProv?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UpdateGivingPlanStatusEnum>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export enum UpdateGivingPlanStatusEnum {
  Cancelled = 'cancelled'
}

export type UpdateOrderDonationInput = {
  amount: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  donation?: InputMaybe<UpdateOrderDonationInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  miscItems?: InputMaybe<Array<InputMaybe<UpdateOrderMiscItemInput>>>;
  needs?: InputMaybe<Array<InputMaybe<UpdateOrderNeedInput>>>;
  products?: InputMaybe<Array<InputMaybe<UpdateOrderProductInput>>>;
  raffle?: InputMaybe<Array<InputMaybe<UpdateOrderRaffleItemInput>>>;
  wonLiveAuctionItems?: InputMaybe<Array<InputMaybe<UpdateOrderWonLiveAuctionItemInput>>>;
};

export type UpdateOrderMiscItemInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderNeedInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  needId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderProductInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  noteResponse?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  selectedVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderRaffleItemInput = {
  entries?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  raffleId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderWonLiveAuctionItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  liveAuctionItemId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantPaymentInput = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isCoveringFees?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantPaymentResult = PayableResult & {
  __typename?: 'UpdateParticipantPaymentResult';
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePaymentMethodResult = {
  __typename?: 'UpdatePaymentMethodResult';
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  processorData?: Maybe<Scalars['SequelizeJSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  apiKey?: Maybe<Scalars['String']['output']>;
  avatarImage?: Maybe<Scalars['String']['output']>;
  clientStore?: Maybe<Scalars['SequelizeJSON']['output']>;
  createdAt: Scalars['Date']['output'];
  createdCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fundraisers?: Maybe<Array<Maybe<Fundraiser>>>;
  id: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};


export type UserCreatedCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type UserFundraisersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type UserInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  avatarImage?: InputMaybe<Scalars['String']['input']>;
  clientStore?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdCampaigns?: InputMaybe<Array<InputMaybe<CampaignInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fundraisers?: InputMaybe<Array<InputMaybe<FundraiserInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['Date']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  permissions: Array<Maybe<Scalars['String']['output']>>;
  roles: Array<Maybe<Scalars['String']['output']>>;
  user: User;
};

export enum ValidateAdminInviteResponseEnum {
  Granted = 'granted',
  Invalid = 'invalid',
  NeedsUser = 'needsUser'
}

export type WonLiveAuctionItem = {
  __typename?: 'WonLiveAuctionItem';
  amount?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  fundraiser?: Maybe<Fundraiser>;
  fundraiserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  liveAuctionItem?: Maybe<LiveAuctionItem>;
  liveAuctionItemId: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type WonLiveAuctionItemInput = {
  /** Used when mutating relations in update mutations. */
  _Op?: InputMaybe<OpsEnum>;
  amount?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  fundraiserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  liveAuctionItemId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type AddNeedCommitmentsResult = {
  __typename?: 'addNeedCommitmentsResult';
  failed: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
};

export enum AudienceTypeEnum {
  Donation = 'donation',
  Participant = 'participant',
  Sponsor = 'sponsor'
}

export enum FundraiserCommitmentStatusEnum {
  Cancelled = 'cancelled',
  ChargeFailed = 'charge_failed',
  Fulfilled = 'fulfilled',
  NotAccepted = 'not_accepted',
  Overdue = 'overdue',
  Unfulfilled = 'unfulfilled',
  Waived = 'waived'
}

export enum FundraiserCommitmentStatusInputEnum {
  Unfulfilled = 'unfulfilled',
  Waived = 'waived'
}

export type UpdateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, avatarImage?: string | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: boolean | null };

export type GetSoldProductForEditModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSoldProductForEditModalQuery = { __typename?: 'Query', findSoldProducts?: Array<{ __typename?: 'SoldProduct', id: string, status: SoldProductstatusEnumType, amount: string, noteResponse?: string | null, selectedVariantId?: string | null, product?: { __typename?: 'Product', id: string, name: string, description?: any | null, noteLabel?: string | null, isNoteRequired: boolean, variants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, qtyTotal?: number | null, qtyRemaining?: number | null, isEnabled: boolean } | null> | null } | null } | null> | null };

export type UpdateSoldProductMutationVariables = Exact<{
  data: SoldProductInput;
}>;


export type UpdateSoldProductMutation = { __typename?: 'Mutation', updateSoldProduct?: { __typename?: 'SoldProduct', id: string, status: SoldProductstatusEnumType, selectedVariantId?: string | null, noteResponse?: string | null } | null };

export type GetSoldProductBuyerDetailsForEditModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSoldProductBuyerDetailsForEditModalQuery = { __typename?: 'Query', findSoldProducts?: Array<{ __typename?: 'SoldProduct', id: string, order?: { __typename?: 'Order', id: string, firstName: string, lastName: string, email?: string | null, address1?: string | null, address2?: string | null, city?: string | null, stateProv?: string | null, postalCode?: string | null, country?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, collectShopPhone: CampaigncollectShopPhoneEnumType, collectShopAddress: CampaigncollectShopAddressEnumType } | null } | null> | null };

export type UpdateSoldProductOrderBuyerFieldsMutationVariables = Exact<{
  data: UpdateOrderInput;
}>;


export type UpdateSoldProductOrderBuyerFieldsMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', id: string, firstName: string, lastName: string, email?: string | null, address1?: string | null, address2?: string | null, city?: string | null, stateProv?: string | null, postalCode?: string | null, country?: string | null } };

export type GetSoldProductOrderForSnapshotItemListingQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
}>;


export type GetSoldProductOrderForSnapshotItemListingQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, orders?: Array<{ __typename?: 'Order', id: string, status: OrderstatusEnumType, products?: Array<{ __typename?: 'SoldProduct', id: string, amount: string, status: SoldProductstatusEnumType, product?: { __typename?: 'Product', id: string, name: string } | null, selectedVariant?: { __typename?: 'ProductVariant', id: string, name: string } | null } | null> | null } | null> | null } | null> | null };

export type UpdateSoldProductStatusMutationVariables = Exact<{
  data: SoldProductInput;
}>;


export type UpdateSoldProductStatusMutation = { __typename?: 'Mutation', updateSoldProduct?: { __typename?: 'SoldProduct', id: string, status: SoldProductstatusEnumType } | null };

export type GetMinAllowedBidQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMinAllowedBidQuery = { __typename?: 'Query', findAuctionItems?: Array<{ __typename?: 'AuctionItem', id: string, highBid: string, bidIncrement: string, auction?: { __typename?: 'Auction', id: string, myBidder?: { __typename?: 'AuctionBidder', id: string } | null } | null } | null> | null };

export type UpdateMaxBidMutationVariables = Exact<{
  itemId: Scalars['String']['input'];
  amount: Scalars['String']['input'];
}>;


export type UpdateMaxBidMutation = { __typename?: 'Mutation', updateAuctionItemMaxBid?: boolean | null };

export type GetParticipantSnapshotAddCardQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
}>;


export type GetParticipantSnapshotAddCardQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, participants?: Array<{ __typename?: 'Fundraiser', id: string, resolvedName?: string | null, resolvedEmail?: string | null, phone?: string | null, isCoveringFees: boolean, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null } | null> | null } | null> | null };

export type UpdateParticipantPaymentMutationVariables = Exact<{
  participant: UpdateParticipantPaymentInput;
  confirmationTokenId: Scalars['String']['input'];
}>;


export type UpdateParticipantPaymentMutation = { __typename?: 'Mutation', updateParticipantPayment: { __typename?: 'UpdateParticipantPaymentResult', success: boolean, processorData?: any | null, error?: any | null } };

export type GetParticipantsForPartialOrderModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetParticipantsForPartialOrderModalQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, participants?: Array<{ __typename?: 'Fundraiser', id: string, eventNumber?: number | null, resolvedName?: string | null } | null> | null } | null> | null };

export type QuestionAdminFieldsFragment = { __typename?: 'Question', id: string, answerCount: number, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, label: string, sort: number, type: QuestiontypeEnumType, audienceType: QuestionaudienceTypeEnumType, globalQuestionId?: string | null, assigningRegistrationTypes?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string, sort: number } | null> | null };

export type GetRegTypesForQuestionModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRegTypesForQuestionModalQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, registrationTypes?: Array<{ __typename?: 'RegistrationType', id: string, name: string } | null> | null } | null> | null };

export type GetCampaignQuestionsQueryVariables = Exact<{
  where: Scalars['SequelizeJSON']['input'];
}>;


export type GetCampaignQuestionsQuery = { __typename?: 'Query', findQuestions?: Array<{ __typename?: 'Question', id: string, answerCount: number, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, label: string, sort: number, type: QuestiontypeEnumType, audienceType: QuestionaudienceTypeEnumType, globalQuestionId?: string | null, assigningRegistrationTypes?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string, sort: number } | null> | null } | null> | null };

export type GetGlobalQuestionsForCampaignAdminModalQueryVariables = Exact<{
  where: Scalars['SequelizeJSON']['input'];
}>;


export type GetGlobalQuestionsForCampaignAdminModalQuery = { __typename?: 'Query', findGlobalQuestions?: Array<{ __typename?: 'GlobalQuestion', id: string, type: GlobalQuestiontypeEnumType, label: string, isEnabled: boolean, isRequired: boolean, assignableAudiences: any } | null> | null };

export type CreateQuestionMutationVariables = Exact<{
  data: QuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion?: { __typename?: 'Question', id: string, answerCount: number, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, label: string, sort: number, type: QuestiontypeEnumType, audienceType: QuestionaudienceTypeEnumType, globalQuestionId?: string | null, assigningRegistrationTypes?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string, sort: number } | null> | null } | null };

export type UpdateQuestionMutationVariables = Exact<{
  data: QuestionInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion?: { __typename?: 'Question', id: string, answerCount: number, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, label: string, sort: number, type: QuestiontypeEnumType, audienceType: QuestionaudienceTypeEnumType, globalQuestionId?: string | null, assigningRegistrationTypes?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string, sort: number } | null> | null } | null };

export type DeleteQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion?: number | null };

export type UpdateQuestionOrderMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateQuestionOrderMutation = { __typename?: 'Mutation', updateQuestionOrder: boolean };

export type AssignGlobalQuestionsMutationVariables = Exact<{
  campaignId: Scalars['String']['input'];
  globalQuestionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  audienceType: AudienceTypeEnum;
}>;


export type AssignGlobalQuestionsMutation = { __typename?: 'Mutation', assignGlobalQuestions?: boolean | null };

export type GetCampaignColorsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignColorsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, accentColor: string, primaryColor: string } | null> | null };

export type GetImageGalleryWidgetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetImageGalleryWidgetQuery = { __typename?: 'Query', findCampaignWidgets?: Array<{ __typename?: 'AuctionPreviewCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ChildCampaignListingCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'CommunityActivityCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'CustomBlockCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'DonationsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'EventDetailsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'GroupLeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ImageGalleryCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ImpactStoriesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'LeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'LogoGridCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'RafflesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ShopCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'SponsorPackagesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'SponsorsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | null> | null };

export type GetCampaignSponsorOptionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignSponsorOptionsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, accentColor: string, primaryColor: string, registrationTypes?: Array<{ __typename?: 'RegistrationType', id: string, name: string, amount: string } | null> | null } | null> | null };

export type GetSponsorsWidgetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSponsorsWidgetQuery = { __typename?: 'Query', findCampaignWidgets?: Array<{ __typename?: 'AuctionPreviewCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ChildCampaignListingCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'CommunityActivityCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'CustomBlockCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'DonationsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'EventDetailsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'GroupLeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ImageGalleryCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ImpactStoriesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'LeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'LogoGridCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'RafflesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'ShopCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'SponsorPackagesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | { __typename?: 'SponsorsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null } | null> | null };

export type GetWidgetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWidgetQuery = { __typename?: 'Query', findCampaignWidgets?: Array<{ __typename?: 'AuctionPreviewCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'ChildCampaignListingCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'CommunityActivityCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'CustomBlockCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'DonationsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'EventDetailsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'GroupLeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'ImageGalleryCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'ImpactStoriesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'LeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'LogoGridCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'RafflesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'ShopCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'SponsorPackagesCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | { __typename?: 'SponsorsCampaignWidget', id: string, type: CampaignWidgettypeEnumType, title?: string | null, config?: any | null, campaignPageId?: string | null } | null> | null };

export type GetParticipantsForPartialOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetParticipantsForPartialOrderQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, eventNumberMode: CampaigneventNumberModeEnumType, participants?: Array<{ __typename?: 'Fundraiser', id: string, eventNumber?: number | null, resolvedName?: string | null } | null> | null } | null> | null };

export type AddLiveAuctionWinnerMutationVariables = Exact<{
  amount: Scalars['Float']['input'];
  liveAuctionItemId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
}>;


export type AddLiveAuctionWinnerMutation = { __typename?: 'Mutation', addLiveAuctionWinner: { __typename?: 'Order', id: string, wonLiveAuctionItems?: Array<{ __typename?: 'WonLiveAuctionItem', liveAuctionItemId: string, amount?: string | null } | null> | null } };

export type CreateNewLiveAuctionItemMutationVariables = Exact<{
  data: LiveAuctionItemInput;
}>;


export type CreateNewLiveAuctionItemMutation = { __typename?: 'Mutation', createLiveAuctionItem?: { __typename?: 'LiveAuctionItem', id: string, name: string } | null };

export type UpdateLiveAuctionItemMutationVariables = Exact<{
  data: LiveAuctionItemInput;
}>;


export type UpdateLiveAuctionItemMutation = { __typename?: 'Mutation', updateLiveAuctionItem?: { __typename?: 'LiveAuctionItem', id: string, name: string } | null };

export type DeleteLiveAuctionItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteLiveAuctionItemMutation = { __typename?: 'Mutation', deleteLiveAuctionItem?: number | null };

export type ToggleProductIsEnabledMutationVariables = Exact<{
  data: ProductInput;
}>;


export type ToggleProductIsEnabledMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'Product', id: string, isEnabled: boolean } | null };

export type GetCampaignForNewShopQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetCampaignForNewShopQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, supportedFeatures: { __typename?: 'CampaignFeatures', tickets: boolean } } | null> | null };

export type CampaignAdmin_ProductFormFragmentFragment = { __typename?: 'Product', id: string, amount: string, description?: any | null, image?: string | null, isEnabled: boolean, isNoteRequired: boolean, isFeatured: boolean, name: string, noteLabel?: string | null, publicDisplay: ProductpublicDisplayEnumType, qtyLimitScope: ProductqtyLimitScopeEnumType, qtyTotal?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, isEnabled: boolean, name: string, qtyTotal?: number | null, sort: number } | null> | null };

export type CreateProductMutationVariables = Exact<{
  data: ProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'Product', id: string, amount: string, description?: any | null, image?: string | null, isEnabled: boolean, isNoteRequired: boolean, isFeatured: boolean, name: string, noteLabel?: string | null, publicDisplay: ProductpublicDisplayEnumType, qtyLimitScope: ProductqtyLimitScopeEnumType, qtyTotal?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, isEnabled: boolean, name: string, qtyTotal?: number | null, sort: number } | null> | null } | null };

export type GetProductFormEntitiesQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetProductFormEntitiesQuery = { __typename?: 'Query', findProducts?: Array<{ __typename?: 'Product', id: string, amount: string, description?: any | null, image?: string | null, isEnabled: boolean, isNoteRequired: boolean, isFeatured: boolean, name: string, noteLabel?: string | null, publicDisplay: ProductpublicDisplayEnumType, qtyLimitScope: ProductqtyLimitScopeEnumType, qtyTotal?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, isEnabled: boolean, name: string, qtyTotal?: number | null, sort: number } | null> | null } | null> | null };

export type UpdateProductMutationVariables = Exact<{
  data?: InputMaybe<ProductInput>;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'Product', id: string, amount: string, description?: any | null, image?: string | null, isEnabled: boolean, isNoteRequired: boolean, isFeatured: boolean, name: string, noteLabel?: string | null, publicDisplay: ProductpublicDisplayEnumType, qtyLimitScope: ProductqtyLimitScopeEnumType, qtyTotal?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, isEnabled: boolean, name: string, qtyTotal?: number | null, sort: number } | null> | null } | null };

export type GetProductSummaryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProductSummaryQuery = { __typename?: 'Query', findProducts?: Array<{ __typename?: 'Product', id: string, name: string, image?: string | null, qtyUsed: number, qtyTotal?: number | null, totalSalesAmount: string, amount: string, variants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, qtyUsed: number, qtyTotal?: number | null, qtyRemaining?: number | null, isEnabled: boolean } | null> | null } | null> | null };

export type GetCampaignProductsForAdminListingQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetCampaignProductsForAdminListingQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, products?: Array<{ __typename?: 'Product', id: string, sort: number, name: string, image?: string | null, isEnabled: boolean, qtyUsed: number, qtyTotal?: number | null, qtyRemaining?: number | null, totalSalesAmount: string, variants?: Array<{ __typename?: 'ProductVariant', id: string, qtyUsed: number, qtyTotal?: number | null, qtyRemaining?: number | null } | null> | null } | null> | null } | null> | null };

export type ReorderProductsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ReorderProductsMutation = { __typename?: 'Mutation', updateProductOrder: boolean };

export type GetProductNameForDeleteModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProductNameForDeleteModalQuery = { __typename?: 'Query', findProducts?: Array<{ __typename?: 'Product', id: string, name: string } | null> | null };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: number | null };

export type GetSoldProductOverviewQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSoldProductOverviewQuery = { __typename?: 'Query', findSoldProducts?: Array<{ __typename?: 'SoldProduct', id: string, status: SoldProductstatusEnumType, amount: string, order?: { __typename?: 'Order', status: OrderstatusEnumType, fullName?: string | null, email?: string | null, phone?: string | null, address1?: string | null, address2?: string | null, city?: string | null, stateProv?: string | null, postalCode?: string | null, country?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, collectShopPhone: CampaigncollectShopPhoneEnumType, collectShopAddress: CampaigncollectShopAddressEnumType } | null } | null> | null };

export type GetCampaignForSponsorPackageEditModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignForSponsorPackageEditModalQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, supportedFeatures: { __typename?: 'CampaignFeatures', event: boolean }, registrationTypes?: Array<{ __typename?: 'RegistrationType', id: string, name: string } | null> | null } | null> | null };

export type GetCampaignOrgInfoForTicketBundleModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignOrgInfoForTicketBundleModalQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, ownerOrganization?: { __typename?: 'Organization', id: string, isForProfit: boolean } | null } | null> | null };

export type GetCampaignOrgInfoForTicketModalQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignOrgInfoForTicketModalQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, timezone: string, supportedFeatures: { __typename?: 'CampaignFeatures', join: boolean, event: boolean, activityTracking: boolean }, ownerOrganization?: { __typename?: 'Organization', id: string, isForProfit: boolean } | null } | null> | null };

export type MarkCampaignAsCompletedOrActiveMutationVariables = Exact<{
  data: CampaignInput;
}>;


export type MarkCampaignAsCompletedOrActiveMutation = { __typename?: 'Mutation', updateCampaign?: { __typename?: 'Campaign', id: string, isCompleted: boolean } | null };

export type RemoveCampaignFromProgramMutationVariables = Exact<{
  data: CampaignInput;
}>;


export type RemoveCampaignFromProgramMutation = { __typename?: 'Mutation', updateCampaign?: { __typename?: 'Campaign', id: string, parentId?: string | null } | null };

export type SoftDeleteCampaignFromProgramPageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SoftDeleteCampaignFromProgramPageMutation = { __typename?: 'Mutation', deleteCampaign?: number | null };

export type UndeleteCampaignMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UndeleteCampaignMutation = { __typename?: 'Mutation', undeleteCampaign: number };

export type RemoveParticipantPaymentMutationVariables = Exact<{
  participantId: Scalars['String']['input'];
}>;


export type RemoveParticipantPaymentMutation = { __typename?: 'Mutation', removeParticipantPayment?: boolean | null };

export type Participant_Commitment_FragmentFragment = { __typename?: 'Fundraiser', id: string, commitmentNote?: any | null, commitmentStatus?: FundraiserCommitmentStatusEnum | null, commitmentDonation?: { __typename?: 'Donation', id: string, chargeAmount?: string | null, chargeDate?: any | null, chargeStatus?: ChargeStatus | null, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null } | null };

export type Participant_Order_FragmentFragment = { __typename?: 'Fundraiser', id: string, order?: { __typename?: 'Order', id: string, email?: string | null, fullName?: string | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null, products?: Array<{ __typename?: 'SoldProduct', id: string, amount: string, campaignId: string, status: SoldProductstatusEnumType, selectedVariantId?: string | null, selectedVariant?: { __typename?: 'ProductVariant', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null> | null, raffleOrder?: { __typename?: 'RaffleOrder', id: string, items?: Array<{ __typename?: 'RaffleOrderItem', id: string, entries?: number | null, amount?: number | null, raffle?: { __typename?: 'Raffle', id: string, name: string } | null } | null> | null } | null } | null };

export type Participant_Registration_FragmentFragment = { __typename?: 'Fundraiser', id: string, registrationType?: { __typename?: 'RegistrationType', id: string, commitmentDeadline?: string | null, name: string, allQuestions: Array<{ __typename?: 'Question', id: string, label: string, helpText?: string | null, isEnabled: boolean, isRequired: boolean, type: QuestiontypeEnumType, sort: number, config: any, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string, sort: number } | null> | null } | null> } | null, eventTable?: { __typename?: 'EventTable', id: string, name?: string | null, tableNumber: number } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, resolvedName?: string | null, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string, order?: { __typename?: 'Order', id: string } | null } | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type GetParticipantDataQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
}>;


export type GetParticipantDataQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, fundraiserDefaultHeaderAvatarImage?: string | null, eventNumberMode: CampaigneventNumberModeEnumType, ownerOrganization?: { __typename?: 'Organization', paymentProcessorConfig?: any | null } | null, supportedFeatures: { __typename?: 'CampaignFeatures', join: boolean, tickets: boolean }, participants?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, ticketId?: string | null, isForBuyer: boolean, resolvedName?: string | null, resolvedEmail?: string | null, ticketStatus: FundraiserticketStatusEnumType, orderId?: string | null, eventNumber?: number | null, email?: string | null, phone?: string | null, isCoveringFees: boolean, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null, amountRaised: string, avatarImage?: string | null, commitmentAmount?: number | null, commitmentAmountRemaining?: string | null, commitmentNote?: any | null, commitmentStatus?: FundraiserCommitmentStatusEnum | null, answers?: Array<{ __typename?: 'QuestionAnswer', id: string, formattedAnswer?: any | null, questionId: string } | null> | null, registrationType?: { __typename?: 'RegistrationType', id: string, commitmentDeadline?: string | null, name: string, allQuestions: Array<{ __typename?: 'Question', id: string, label: string, helpText?: string | null, isEnabled: boolean, isRequired: boolean, type: QuestiontypeEnumType, sort: number, config: any, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string, sort: number } | null> | null } | null> } | null, eventTable?: { __typename?: 'EventTable', id: string, name?: string | null, tableNumber: number } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, resolvedName?: string | null, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string, order?: { __typename?: 'Order', id: string } | null } | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, commitmentDonation?: { __typename?: 'Donation', id: string, chargeAmount?: string | null, chargeDate?: any | null, chargeStatus?: ChargeStatus | null, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null } | null, order?: { __typename?: 'Order', id: string, email?: string | null, fullName?: string | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null, products?: Array<{ __typename?: 'SoldProduct', id: string, amount: string, campaignId: string, status: SoldProductstatusEnumType, selectedVariantId?: string | null, selectedVariant?: { __typename?: 'ProductVariant', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null> | null, raffleOrder?: { __typename?: 'RaffleOrder', id: string, items?: Array<{ __typename?: 'RaffleOrderItem', id: string, entries?: number | null, amount?: number | null, raffle?: { __typename?: 'Raffle', id: string, name: string } | null } | null> | null } | null } | null } | null> | null } | null> | null };

export type UpdateCommitmentMutationVariables = Exact<{
  fundraiserId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
}>;


export type UpdateCommitmentMutation = { __typename?: 'Mutation', updateCommitmentAmount?: boolean | null };

export type UpdateCheckInParticipantMutationVariables = Exact<{
  data: FundraiserInput;
}>;


export type UpdateCheckInParticipantMutation = { __typename?: 'Mutation', updateParticipant?: { __typename?: 'Fundraiser', id: string, ticketStatus: FundraiserticketStatusEnumType, commitmentStatus?: FundraiserCommitmentStatusEnum | null, eventNumber?: number | null } | null };

export type UpdateNeedMutationVariables = Exact<{
  data: NeedInput;
}>;


export type UpdateNeedMutation = { __typename?: 'Mutation', updateNeed?: { __typename?: 'Need', id: string, amount: string, name: string, totalCommitmentAmount: string, qtyUsed: number } | null };

export type DeleteNeedMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteNeedMutation = { __typename?: 'Mutation', deleteNeed?: number | null };

export type AddNeedCommitmentsMutationVariables = Exact<{
  needId: Scalars['String']['input'];
  participantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddNeedCommitmentsMutation = { __typename?: 'Mutation', addNeedCommitments: { __typename?: 'addNeedCommitmentsResult', processed: number, failed: number } };

export type GetNeedDataQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  needId: Scalars['String']['input'];
  order: Scalars['String']['input'];
}>;


export type GetNeedDataQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, eventNumberMode: CampaigneventNumberModeEnumType, needs?: Array<{ __typename?: 'Need', id: string, name: string, amount: string } | null> | null, participants?: Array<{ __typename?: 'Fundraiser', id: string, resolvedName?: string | null, resolvedEmail?: string | null, eventNumber?: number | null, paymentMethodType?: string | null } | null> | null } | null> | null };

export type CreateManyEventTablesMutationVariables = Exact<{
  campaignId: Scalars['String']['input'];
  totalSeats: Scalars['Int']['input'];
  numberOfTables: Scalars['Int']['input'];
}>;


export type CreateManyEventTablesMutation = { __typename?: 'Mutation', createManyEventTables: Array<{ __typename?: 'EventTable', id: string, tableNumber: number }> };

export type CreateSingleEventTableMutationVariables = Exact<{
  data: EventTableInput;
}>;


export type CreateSingleEventTableMutation = { __typename?: 'Mutation', createEventTable?: { __typename?: 'EventTable', id: string, name?: string | null, tableNumber: number } | null };

export type GetTicketTypesForSeatingAssignmentFilterQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTicketTypesForSeatingAssignmentFilterQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, registrationTypes?: Array<{ __typename?: 'RegistrationType', id: string, name: string } | null> | null } | null> | null };

export type UpdateEventTableSettingsMutationVariables = Exact<{
  data: EventTableInput;
}>;


export type UpdateEventTableSettingsMutation = { __typename?: 'Mutation', updateEventTable?: { __typename?: 'EventTable', id: string, name?: string | null, totalSeats: number } | null };

export type DeleteEventTableMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteEventTableMutation = { __typename?: 'Mutation', deleteEventTable?: number | null };

export type SeatGuestsMutationVariables = Exact<{
  ticketGroupId: Scalars['ID']['input'];
  eventTableId: Scalars['ID']['input'];
}>;


export type SeatGuestsMutation = { __typename?: 'Mutation', seatGuests?: { __typename?: 'EventTableTicketGroup', ticketGroupId: string, eventTableId: string, seatsReserved: number } | null };

export type SeatParticipantMutationVariables = Exact<{
  data: FundraiserInput;
}>;


export type SeatParticipantMutation = { __typename?: 'Mutation', updateFundraiser?: { __typename?: 'Fundraiser', id: string, eventTableId?: string | null } | null };

export type GetSeatingDataQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetSeatingDataQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, eventSeating?: Array<{ __typename?: 'EventAttendeeSeating', isSeated: boolean, eventTable?: { __typename?: 'EventTable', id: string } | null, attendee?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null, resolvedEmail?: string | null, orderId?: string | null, registrationType?: { __typename?: 'RegistrationType', id: string, name: string } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string, name: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string, order?: { __typename?: 'Order', id: string, firstName: string, lastName: string } | null } | null } | null } | { __typename?: 'TicketGroupGuest', resolvedName?: string | null, resolvedEmail?: string | null, orderId?: string | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, ticketOption?: { __typename?: 'RegistrationType', id: string, name: string } | null } | null } | null } | null> | null, eventTables?: Array<{ __typename?: 'EventTable', id: string, name?: string | null, tableNumber: number, totalSeats: number, seatsUsed: number } | null> | null } | null> | null };

export type UnseatGuestsMutationVariables = Exact<{
  ticketGroupId: Scalars['ID']['input'];
  eventTableId: Scalars['ID']['input'];
}>;


export type UnseatGuestsMutation = { __typename?: 'Mutation', unseatGuests?: { __typename?: 'EventTableTicketGroup', ticketGroupId: string, eventTableId: string, seatsReserved: number } | null };

export type GetOrderSummaryOptionsQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetOrderSummaryOptionsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, canParticipantCoverPlatformFee: boolean, canParticipantCoverProcessorFee: boolean, discountCodeCount: number, ownerOrganization?: { __typename?: 'Organization', id: string, name: string } | null } | null> | null };

export type CampaignCheckout_RaffleFragmentFragment = { __typename?: 'Raffle', id: string, description?: any | null, entryPackages: any, qtyTotal?: number | null, qtyUsed: number, qtyRemaining?: number | null, name: string, type: RaffletypeEnumType };

export type GetTeamNameQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTeamNameQuery = { __typename?: 'Query', findTeams?: Array<{ __typename?: 'Team', id: string, name: string } | null> | null };

export type GetCampaignFundraisingTypeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignFundraisingTypeQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', fundraisingType: CampaignfundraisingTypeEnumType } | null> | null };

export type GetEventDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEventDetailsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, activeFeatures: { __typename?: 'CampaignFeatures', event: boolean }, event?: { __typename?: 'CampaignEvent', id: string, startDate: string, endDate: string, time?: string | null, address1?: string | null, address2?: string | null, city?: string | null, stateProv?: string | null, country?: string | null, postalCode?: string | null } | null } | null> | null };

export type GetShopWidgetDetailsQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
  isExisting: Scalars['Boolean']['input'];
}>;


export type GetShopWidgetDetailsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, activeFeatures: { __typename?: 'CampaignFeatures', shop: boolean }, products?: Array<{ __typename?: 'Product', id: string, name: string, description?: any | null, amount: string, image?: string | null, qtyRemaining?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, qtyRemaining?: number | null } | null> | null } | null> | null, widgets?: Array<{ __typename?: 'AuctionPreviewCampaignWidget', id: string, title?: string | null } | { __typename?: 'ChildCampaignListingCampaignWidget', id: string, title?: string | null } | { __typename?: 'CommunityActivityCampaignWidget', id: string, title?: string | null } | { __typename?: 'CustomBlockCampaignWidget', id: string, title?: string | null } | { __typename?: 'DonationsCampaignWidget', id: string, title?: string | null } | { __typename?: 'EventDetailsCampaignWidget', id: string, title?: string | null } | { __typename?: 'GroupLeaderboardCampaignWidget', id: string, title?: string | null } | { __typename?: 'ImageGalleryCampaignWidget', id: string, title?: string | null } | { __typename?: 'ImpactStoriesCampaignWidget', id: string, title?: string | null } | { __typename?: 'LeaderboardCampaignWidget', id: string, title?: string | null } | { __typename?: 'LogoGridCampaignWidget', id: string, title?: string | null } | { __typename?: 'RafflesCampaignWidget', id: string, title?: string | null } | { __typename?: 'ShopCampaignWidget', id: string, title?: string | null } | { __typename?: 'SponsorPackagesCampaignWidget', id: string, title?: string | null } | { __typename?: 'SponsorsCampaignWidget', id: string, title?: string | null } | null> | null } | null> | null };

export type AuctionItemFieldsFragment = { __typename?: 'AuctionItem', id: string, name: string, sort: number, status?: AuctionItemStatusEnum | null, endDate: any, startDate: any, campaignId: string, categoryId?: string | null, numBids: number, highBid: string, startingBid: string, estimatedValue?: number | null, images?: Array<{ __typename?: 'AuctionItemImage', id: string, image: string } | null> | null, myBid?: { __typename?: 'MyAuctionItemBid', bid: string, type: AuctionBidtypeEnumType, isWinning: boolean } | null };

export type GetResultsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  query: Scalars['String']['input'];
}>;


export type GetResultsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, fundraiserDefaultHeaderAvatarImage?: string | null, teamDefaultHeaderAvatarImage?: string | null, searchTeams?: Array<{ __typename?: 'TeamSearchResult', id: string, avatarImage?: string | null, name: string } | null> | null, searchFundraisers?: Array<{ __typename?: 'FundraiserSearchResult', id: string, resolvedName: string, avatarImage?: string | null, teamName?: string | null } | null> | null } | null> | null };

export type FundraisingUpdateFieldsFragment = { __typename?: 'FundraisingUpdate', id: string, createdAt: any, type?: FundraisingUpdatetypeEnumType | null, isFeatured?: boolean | null, performanceUnits?: string | null, message?: any | null, likeCounter: number, loveCounter: number, clapCounter: number, cryCounter: number, yayCounter: number, hahaCounter: number, wowCounter: number, myReaction?: ReactionreactionTypeEnumType | null, embeddedMedia?: any | null, stravaActivity?: any | null };

export type FundraisingUpdateCampaignFieldsFragment = { __typename?: 'Campaign', id: string, fundraiserDefaultHeaderAvatarImage?: string | null };

export type FundraisingUpdateFundraiserFieldsFragment = { __typename?: 'Fundraiser', id: string, resolvedName?: string | null, avatarImage?: string | null, performanceSettings?: { __typename?: 'PerformanceSettings', id?: string | null, metricLabel?: string | null, metricLabelPlural?: string | null } | null, stats?: { __typename?: 'FundraisingStats', id?: string | null, pledgeValue?: string | null } | null };

export type CampaignFundraisingUpdateSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CampaignFundraisingUpdateSettingsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, widgets?: Array<{ __typename?: 'AuctionPreviewCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ChildCampaignListingCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'CommunityActivityCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'CustomBlockCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'DonationsCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'EventDetailsCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'GroupLeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ImageGalleryCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ImpactStoriesCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'LeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'LogoGridCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'RafflesCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ShopCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'SponsorPackagesCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'SponsorsCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | null> | null } | null> | null };

export type UpdateCampaignWidgetsMutationVariables = Exact<{
  data: CampaignWidgetInput;
}>;


export type UpdateCampaignWidgetsMutation = { __typename?: 'Mutation', createCampaignWidget?: { __typename?: 'AuctionPreviewCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ChildCampaignListingCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'CommunityActivityCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'CustomBlockCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'DonationsCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'EventDetailsCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'GroupLeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ImageGalleryCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ImpactStoriesCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'LeaderboardCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'LogoGridCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'RafflesCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'ShopCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'SponsorPackagesCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | { __typename?: 'SponsorsCampaignWidget', id: string, type: CampaignWidgettypeEnumType } | null };

export type UpdateFundraisingUpdateMutationVariables = Exact<{
  data: FundraisingUpdateInput;
}>;


export type UpdateFundraisingUpdateMutation = { __typename?: 'Mutation', updateFundraisingUpdate?: { __typename?: 'FundraisingUpdate', id: string, isFeatured?: boolean | null } | null };

export type CreateOrUpdateReactionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reaction?: InputMaybe<ReactionreactionTypeEnumType>;
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrUpdateReactionMutation = { __typename?: 'Mutation', setReaction?: { __typename?: 'ReactionWithToken', token?: string | null } | null };

export type FundraisingUpdateReactionsFragment = { __typename?: 'FundraisingUpdate', myReaction?: ReactionreactionTypeEnumType | null, likeCounter: number, loveCounter: number, clapCounter: number, cryCounter: number, yayCounter: number, hahaCounter: number, wowCounter: number };

export type DeleteProgramMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProgramMutation = { __typename?: 'Mutation', deleteProgram: number };

export type UndeleteProgramMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UndeleteProgramMutation = { __typename?: 'Mutation', undeleteProgram: number };

export type ValidateCampaignDiscountCodeMutationVariables = Exact<{
  campaignId: Scalars['String']['input'];
  discountCode: Scalars['String']['input'];
}>;


export type ValidateCampaignDiscountCodeMutation = { __typename?: 'Mutation', validateDiscountCode: boolean };

export type CustomQuestion_EditFragmentFragment = { __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null };

export type GlobalQuestion_EditFragmentFragment = { __typename?: 'GlobalQuestion', id: string, label: string, config: any, helpText?: string | null, isRequired: boolean };

export type GetCampaignTicketPurchaseLayoutQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignTicketPurchaseLayoutQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, name: string, accentColor: string, campaignLogo?: string | null, primaryColor: string, canParticipantCoverPlatformFee: boolean, canParticipantCoverProcessorFee: boolean, ownerOrganization?: { __typename?: 'Organization', id: string, logo?: string | null, name: string, paymentProcessorConfig?: any | null, metaPixelId?: string | null } | null } | null> | null };

export type GetCampaignSponsorPurchaseLayoutQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignSponsorPurchaseLayoutQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, accentColor: string, primaryColor: string, campaignLogo?: string | null, canSponsorCoverPlatformFee: boolean, canSponsorCoverProcessorFee: boolean, ownerOrganization?: { __typename?: 'Organization', id: string, logo?: string | null, metaPixelId?: string | null, name: string, paymentProcessorConfig?: any | null } | null } | null> | null };

export type GlobalQuestionAdminFieldsFragment = { __typename?: 'GlobalQuestion', id: string, type: GlobalQuestiontypeEnumType, label: string, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, assignableAudiences: any, shouldAddToNewCampaigns: boolean, options?: Array<{ __typename?: 'GlobalQuestionOption', id: string, label: string, sort: number } | null> | null };

export type GetGlobalQuestionsQueryVariables = Exact<{
  where: Scalars['SequelizeJSON']['input'];
}>;


export type GetGlobalQuestionsQuery = { __typename?: 'Query', findGlobalQuestions?: Array<{ __typename?: 'GlobalQuestion', id: string, type: GlobalQuestiontypeEnumType, label: string, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, assignableAudiences: any, shouldAddToNewCampaigns: boolean, options?: Array<{ __typename?: 'GlobalQuestionOption', id: string, label: string, sort: number } | null> | null } | null> | null };

export type CreateGlobalQuestionMutationVariables = Exact<{
  data: GlobalQuestionInput;
}>;


export type CreateGlobalQuestionMutation = { __typename?: 'Mutation', createGlobalQuestion?: { __typename?: 'GlobalQuestion', id: string, type: GlobalQuestiontypeEnumType, label: string, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, assignableAudiences: any, shouldAddToNewCampaigns: boolean, options?: Array<{ __typename?: 'GlobalQuestionOption', id: string, label: string, sort: number } | null> | null } | null };

export type UpdateGlobalQuestionMutationVariables = Exact<{
  data: GlobalQuestionInput;
}>;


export type UpdateGlobalQuestionMutation = { __typename?: 'Mutation', updateGlobalQuestion?: { __typename?: 'GlobalQuestion', id: string, type: GlobalQuestiontypeEnumType, label: string, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, assignableAudiences: any, shouldAddToNewCampaigns: boolean, options?: Array<{ __typename?: 'GlobalQuestionOption', id: string, label: string, sort: number } | null> | null } | null };

export type DeleteGlobalQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteGlobalQuestionMutation = { __typename?: 'Mutation', deleteGlobalQuestion?: number | null };

export type CalculateRaffleOrderMutationVariables = Exact<{
  raffleOrder: CalculateRaffleOrderInput;
}>;


export type CalculateRaffleOrderMutation = { __typename?: 'Mutation', calculateRaffleOrderAmount: { __typename?: 'CalculateRaffleOrderResult', coveredFeeAmount: string, raffleAmount: string, totalAmount: string, items: Array<{ __typename?: 'CalculateRaffleOrderItem', amount: string, entries: number, name: string }> } };

export type CreateRaffleOrderMutationVariables = Exact<{
  data: CreateRaffleOrderInput;
}>;


export type CreateRaffleOrderMutation = { __typename?: 'Mutation', createRaffleOrder: { __typename?: 'CreateRaffleOrderResult', error?: any | null, processorData?: any | null, raffleOrderId?: string | null, success: boolean } };

export type GetRaffleCheckoutEntitiesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRaffleCheckoutEntitiesQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, accentColor: string, campaignLogo?: string | null, canRaffleCoverPlatformFee: boolean, canRaffleCoverProcessorFee: boolean, collectRaffleAddress: CampaigncollectRaffleAddressEnumType, collectRafflePhone: CampaigncollectRafflePhoneEnumType, name: string, primaryColor: string, slug?: string | null, type: CampaigntypeEnumType, activeFeatures: { __typename?: 'CampaignFeatures', raffle: boolean }, ownerOrganization?: { __typename?: 'Organization', id: string, logo?: string | null, metaPixelId?: string | null, name: string, paymentProcessorConfig?: any | null } | null, raffles?: Array<{ __typename?: 'Raffle', id: string, description?: any | null, entryPackages: any, qtyTotal?: number | null, qtyUsed: number, qtyRemaining?: number | null, name: string, type: RaffletypeEnumType } | null> | null } | null> | null };

export type ValidateTicketGroupInviteCodeQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  inviteCode: Scalars['String']['input'];
}>;


export type ValidateTicketGroupInviteCodeQuery = { __typename?: 'Query', validateTicketGroupInviteCode?: { __typename?: 'RegistrationType', id: string, amount: string, description?: any | null, name: string, qtyUsed: number, qtyTotal?: number | null, sort: number, isCommitmentEnabled: boolean, commitmentAmount?: number | null, commitmentDeadline?: string | null } | null };

export type SlugRouteQueryVariables = Exact<{
  key: Scalars['String']['input'];
  scope?: InputMaybe<SlugScopeEnum>;
  parentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SlugRouteQuery = { __typename?: 'Query', getSlug?: { __typename?: 'Slug', key: string, type: SlugTypeEnum, objectId: string } | null };

export type Cart_LayoutCampaignFragmentFragment = { __typename?: 'Campaign', id: string, name: string, campaignLogo?: string | null, primaryColor: string, accentColor: string, myPermissions?: Array<string> | null, isPerformanceEnabled: boolean, performanceStartDate?: string | null, performanceEndDate?: string | null, event?: { __typename?: 'CampaignEvent', startDate: string, endDate: string } | null, ownerOrganization?: { __typename?: 'Organization', id: string, logo?: string | null, name: string, paymentProcessorConfig?: any | null, myPermissions?: Array<string> | null, metaPixelId?: string | null } | null };

export type Cart_DonationFragmentFragment = { __typename?: 'Campaign', id: string, donationPresets: any };

export type Cart_AuctionItemListFragmentFragment = { __typename?: 'Campaign', id: string, activeFeatures: { __typename?: 'CampaignFeatures', liveAuction: boolean }, liveAuctionItems?: Array<{ __typename?: 'LiveAuctionItem', id: string, name: string, wonLiveAuctionItems?: Array<{ __typename?: 'WonLiveAuctionItem', id: string } | null> | null } | null> | null };

export type Cart_NeedListFragmentFragment = { __typename?: 'Campaign', id: string, activeFeatures: { __typename?: 'CampaignFeatures', fundANeed: boolean }, cartNeedOptions?: Array<{ __typename?: 'Need', id: string, name: string, amount: string } | null> | null };

export type Cart_OrderSummaryFragmentFragment = { __typename?: 'Campaign', id: string, canParticipantCoverPlatformFee: boolean, canParticipantCoverProcessorFee: boolean };

export type IsFundraiserAlreadyQueryVariables = Exact<{
  where: Scalars['SequelizeJSON']['input'];
}>;


export type IsFundraiserAlreadyQuery = { __typename?: 'Query', findFundraisers?: Array<{ __typename?: 'Fundraiser', id: string } | null> | null };

export type Cart_ProductListFragmentFragment = { __typename?: 'Campaign', id: string, activeFeatures: { __typename?: 'CampaignFeatures', shop: boolean }, cartProducts?: Array<{ __typename?: 'Product', id: string, sort: number, name: string, description?: any | null, amount: string, image?: string | null, isEnabled: boolean, isNoteRequired: boolean, noteLabel?: string | null, isFeatured: boolean, qtyLimitScope: ProductqtyLimitScopeEnumType, qtyRemaining?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, qtyTotal?: number | null, qtyRemaining?: number | null } | null> | null } | null> | null };

export type Cart_RaffleListFragmentFragment = { __typename?: 'Campaign', id: string, activeFeatures: { __typename?: 'CampaignFeatures', raffle: boolean }, cartRaffles?: Array<{ __typename?: 'Raffle', id: string, name: string, type: RaffletypeEnumType, status: RafflestatusEnumType, description?: any | null, entryPackages: any, qtyTotal?: number | null, qtyUsed: number, qtyRemaining?: number | null, isFeatured: boolean } | null> | null };

export type Cart_TicketBundleOptionsListFragmentFragment = { __typename?: 'Campaign', id: string, cartTicketBundleOptions?: Array<{ __typename?: 'RegistrationType', id: string, name: string, amount: string, description?: any | null, qtyRemaining?: number | null, isEnabled: boolean, startDate?: string | null, endDate?: string | null, includedTicketQuantity?: number | null, includedTicketOption?: { __typename?: 'RegistrationType', id: string, collectAddress: RegistrationTypecollectAddressEnumType, collectEmail: RegistrationTypecollectEmailEnumType, collectPhone: RegistrationTypecollectPhoneEnumType, name: string, qtyRemaining?: number | null, allQuestions: Array<{ __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> } | null } | null> | null };

export type Cart_TicketOptionListFragmentFragment = { __typename?: 'Campaign', id: string, discountCodeCount: number, registrationDescription?: any | null, supportedFeatures: { __typename?: 'CampaignFeatures', tickets: boolean }, bundles?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, sponsorPackagesWithIncludedTickets?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, cartTicketOptions?: Array<{ __typename?: 'RegistrationType', id: string, isEnabled: boolean, startDate?: string | null, endDate?: string | null, amount: string, collectAddress: RegistrationTypecollectAddressEnumType, collectEmail: RegistrationTypecollectEmailEnumType, collectPhone: RegistrationTypecollectPhoneEnumType, description?: any | null, name: string, qtyRemaining?: number | null, allQuestions: Array<{ __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> } | null> | null };

export type CalculateOrderQueryVariables = Exact<{
  order: CalculateOrderInput;
}>;


export type CalculateOrderQuery = { __typename?: 'Query', calculateOrderAmount: { __typename?: 'CalculateOrderAmountResult', amount: string, discount: string, discountedSubtotal: string, fees: string, subtotal: string, tickets?: Array<{ __typename?: 'CalculateOrderAmountTicket', name: string, amount: string, originalAmount: string, discountText?: string | null, registrationTypeId: string } | null> | null, ticketBundles?: Array<{ __typename?: 'CalculateOrderAmountTicketBundle', name: string, amount: string, originalAmount: string, discountText?: string | null, bundleOptionId: string } | null> | null } };

export type GetCampaignTimezoneForCartQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetCampaignTimezoneForCartQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, timezone: string } | null> | null };

export type GetCartEntitiesQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  currentDate: Scalars['String']['input'];
}>;


export type GetCartEntitiesQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, name: string, campaignLogo?: string | null, primaryColor: string, accentColor: string, myPermissions?: Array<string> | null, isPerformanceEnabled: boolean, performanceStartDate?: string | null, performanceEndDate?: string | null, canParticipantCoverPlatformFee: boolean, canParticipantCoverProcessorFee: boolean, discountCodeCount: number, registrationDescription?: any | null, donationPresets: any, event?: { __typename?: 'CampaignEvent', startDate: string, endDate: string } | null, ownerOrganization?: { __typename?: 'Organization', id: string, logo?: string | null, name: string, paymentProcessorConfig?: any | null, myPermissions?: Array<string> | null, metaPixelId?: string | null } | null, activeFeatures: { __typename?: 'CampaignFeatures', shop: boolean, raffle: boolean, liveAuction: boolean, fundANeed: boolean }, cartProducts?: Array<{ __typename?: 'Product', id: string, sort: number, name: string, description?: any | null, amount: string, image?: string | null, isEnabled: boolean, isNoteRequired: boolean, noteLabel?: string | null, isFeatured: boolean, qtyLimitScope: ProductqtyLimitScopeEnumType, qtyRemaining?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, qtyTotal?: number | null, qtyRemaining?: number | null } | null> | null } | null> | null, supportedFeatures: { __typename?: 'CampaignFeatures', tickets: boolean }, bundles?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, sponsorPackagesWithIncludedTickets?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, cartTicketOptions?: Array<{ __typename?: 'RegistrationType', id: string, isEnabled: boolean, startDate?: string | null, endDate?: string | null, amount: string, collectAddress: RegistrationTypecollectAddressEnumType, collectEmail: RegistrationTypecollectEmailEnumType, collectPhone: RegistrationTypecollectPhoneEnumType, description?: any | null, name: string, qtyRemaining?: number | null, allQuestions: Array<{ __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> } | null> | null, cartTicketBundleOptions?: Array<{ __typename?: 'RegistrationType', id: string, name: string, amount: string, description?: any | null, qtyRemaining?: number | null, isEnabled: boolean, startDate?: string | null, endDate?: string | null, includedTicketQuantity?: number | null, includedTicketOption?: { __typename?: 'RegistrationType', id: string, collectAddress: RegistrationTypecollectAddressEnumType, collectEmail: RegistrationTypecollectEmailEnumType, collectPhone: RegistrationTypecollectPhoneEnumType, name: string, qtyRemaining?: number | null, allQuestions: Array<{ __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> } | null } | null> | null, cartRaffles?: Array<{ __typename?: 'Raffle', id: string, name: string, type: RaffletypeEnumType, status: RafflestatusEnumType, description?: any | null, entryPackages: any, qtyTotal?: number | null, qtyUsed: number, qtyRemaining?: number | null, isFeatured: boolean } | null> | null, liveAuctionItems?: Array<{ __typename?: 'LiveAuctionItem', id: string, name: string, wonLiveAuctionItems?: Array<{ __typename?: 'WonLiveAuctionItem', id: string } | null> | null } | null> | null, cartNeedOptions?: Array<{ __typename?: 'Need', id: string, name: string, amount: string } | null> | null } | null> | null };

export type Cart_PartialOrderFragmentFragment = { __typename?: 'Order', id: string, orderData: { __typename?: 'OrderData', id: string, amount: string, currency?: string | null, coverFee?: boolean | null, discountCode?: string | null, donation?: { __typename?: 'OrderDonationData', id: string, amount: string } | null, products?: Array<{ __typename?: 'OrderProductData', id: string, productId: string, selectedVariantId?: string | null, noteResponse?: string | null }> | null, raffle?: Array<{ __typename?: 'OrderRaffleItemData', id: string, entries: number, amount: string, raffleId: string }> | null, wonLiveAuctionItems?: Array<{ __typename?: 'OrderWonLiveAuctionItemData', id: string, amount: number, liveAuctionItemId: string }> | null, needs?: Array<{ __typename?: 'OrderNeedData', id: string, amount: string, needId: string }> | null, miscItems?: Array<{ __typename?: 'OrderMiscItemData', id: string, name: string, amount: string }> | null } };

export type GetPartialOrderBuyerQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  participantWhere: Scalars['SequelizeJSON']['input'];
}>;


export type GetPartialOrderBuyerQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, participants?: Array<{ __typename?: 'Fundraiser', id: string, eventNumber?: number | null, firstName?: string | null, lastName?: string | null, resolvedEmail?: string | null, isCoveringFees: boolean, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null, paymentMethodType?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, eventOrder?: { __typename?: 'Order', id: string, orderData: { __typename?: 'OrderData', id: string, amount: string, currency?: string | null, coverFee?: boolean | null, discountCode?: string | null, donation?: { __typename?: 'OrderDonationData', id: string, amount: string } | null, products?: Array<{ __typename?: 'OrderProductData', id: string, productId: string, selectedVariantId?: string | null, noteResponse?: string | null }> | null, raffle?: Array<{ __typename?: 'OrderRaffleItemData', id: string, entries: number, amount: string, raffleId: string }> | null, wonLiveAuctionItems?: Array<{ __typename?: 'OrderWonLiveAuctionItemData', id: string, amount: number, liveAuctionItemId: string }> | null, needs?: Array<{ __typename?: 'OrderNeedData', id: string, amount: string, needId: string }> | null, miscItems?: Array<{ __typename?: 'OrderMiscItemData', id: string, name: string, amount: string }> | null } } | null } | null> | null } | null> | null };

export type CreateOrderMutationVariables = Exact<{
  order: CreateOrderInput;
  givingVoucher?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'OrderResult', error?: any | null, orderId?: string | null, processorData?: any | null, success: boolean } };

export type CompleteOrderMutationVariables = Exact<{
  order: CompleteOrderInput;
}>;


export type CompleteOrderMutation = { __typename?: 'Mutation', completeOrder: { __typename?: 'OrderResult', error?: any | null, orderId?: string | null, success: boolean, processorData?: any | null } };

export type UpdateOrderMutationVariables = Exact<{
  order: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', id: string, orderData: { __typename?: 'OrderData', id: string, amount: string, currency?: string | null, coverFee?: boolean | null, discountCode?: string | null, donation?: { __typename?: 'OrderDonationData', id: string, amount: string } | null, products?: Array<{ __typename?: 'OrderProductData', id: string, productId: string, selectedVariantId?: string | null, noteResponse?: string | null }> | null, raffle?: Array<{ __typename?: 'OrderRaffleItemData', id: string, entries: number, amount: string, raffleId: string }> | null, wonLiveAuctionItems?: Array<{ __typename?: 'OrderWonLiveAuctionItemData', id: string, amount: number, liveAuctionItemId: string }> | null, needs?: Array<{ __typename?: 'OrderNeedData', id: string, amount: string, needId: string }> | null, miscItems?: Array<{ __typename?: 'OrderMiscItemData', id: string, name: string, amount: string }> | null } } };

export type RegisterUnclaimedParticipantMutationVariables = Exact<{
  order: CreateOrderInput;
}>;


export type RegisterUnclaimedParticipantMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'OrderResult', success: boolean, orderId?: string | null, processorData?: any | null, error?: any | null } };

export type CreateCampaignMessageMutationVariables = Exact<{
  data: CampaignMessageInput;
}>;


export type CreateCampaignMessageMutation = { __typename?: 'Mutation', createCampaignMessage?: { __typename?: 'CampaignMessage', id: string, body: any, bodyColor: string, buttonColor: string, headerImage?: string | null, previewText?: string | null, scheduledAt?: any | null, status?: CampaignMessagestatusEnumType | null, subject: string, textColor: string, audiences?: Array<{ __typename?: 'CampaignMessageAudience', id: string, audience: CampaignMessageAudienceaudienceEnumType, questionId?: string | null, questionAnswerValue?: any | null, registrationTypeId?: string | null } | null> | null } | null };

export type DeleteCampaignMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCampaignMessageMutation = { __typename?: 'Mutation', deleteCampaignMessage?: number | null };

export type CampaignMessage_DetailsFragmentFragment = { __typename?: 'CampaignMessage', id: string, body: any, bodyColor: string, buttonColor: string, headerImage?: string | null, previewText?: string | null, scheduledAt?: any | null, status?: CampaignMessagestatusEnumType | null, subject: string, textColor: string, audiences?: Array<{ __typename?: 'CampaignMessageAudience', id: string, audience: CampaignMessageAudienceaudienceEnumType, questionId?: string | null, questionAnswerValue?: any | null, registrationTypeId?: string | null } | null> | null };

export type FetchCampaignMessageByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchCampaignMessageByIdQuery = { __typename?: 'Query', findCampaignMessages?: Array<{ __typename?: 'CampaignMessage', id: string, body: any, bodyColor: string, buttonColor: string, headerImage?: string | null, previewText?: string | null, scheduledAt?: any | null, status?: CampaignMessagestatusEnumType | null, subject: string, textColor: string, audiences?: Array<{ __typename?: 'CampaignMessageAudience', id: string, audience: CampaignMessageAudienceaudienceEnumType, questionId?: string | null, questionAnswerValue?: any | null, registrationTypeId?: string | null } | null> | null } | null> | null };

export type GetCampaignMessageContextQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignMessageContextQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, accentColor: string, primaryColor: string, timezone: string, isSponsorshipEnabled: boolean, activeFeatures: { __typename?: 'CampaignFeatures', activityTracking: boolean, auction: boolean, teams: boolean }, participantQuestions?: Array<{ __typename?: 'Question', id: string, type: QuestiontypeEnumType, label: string, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> | null, previousCampaign?: { __typename?: 'Campaign', id: string, supportedFeatures: { __typename?: 'CampaignFeatures', event: boolean, join: boolean }, activeFeatures: { __typename?: 'CampaignFeatures', teams: boolean } } | null, registrationTypes?: Array<{ __typename?: 'RegistrationType', id: string, name: string } | null> | null, supportedFeatures: { __typename?: 'CampaignFeatures', event: boolean, join: boolean } } | null> | null };

export type GetMessagePreviewQueryVariables = Exact<{
  data: Scalars['JSONObject']['input'];
}>;


export type GetMessagePreviewQuery = { __typename?: 'Query', messageService?: { __typename?: 'MessageServiceRootQuery', messagePreview?: { __typename?: 'MessagePreview', html?: string | null, subject?: string | null, text?: string | null } | null } | null };

export type SendCampaignMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SendCampaignMessageMutation = { __typename?: 'Mutation', sendCampaignMessage: { __typename?: 'CampaignMessage', id: string, body: any, bodyColor: string, buttonColor: string, headerImage?: string | null, previewText?: string | null, scheduledAt?: any | null, status?: CampaignMessagestatusEnumType | null, subject: string, textColor: string, audiences?: Array<{ __typename?: 'CampaignMessageAudience', id: string, audience: CampaignMessageAudienceaudienceEnumType, questionId?: string | null, questionAnswerValue?: any | null, registrationTypeId?: string | null } | null> | null } };

export type SendCampaignMessageTestMutationVariables = Exact<{
  email: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  message: CampaignMessageTestInput;
}>;


export type SendCampaignMessageTestMutation = { __typename?: 'Mutation', sendCampaignMessageTest: boolean };

export type UpdateCampaignMessageMutationVariables = Exact<{
  data: CampaignMessageInput;
}>;


export type UpdateCampaignMessageMutation = { __typename?: 'Mutation', updateCampaignMessage?: { __typename?: 'CampaignMessage', id: string, body: any, bodyColor: string, buttonColor: string, headerImage?: string | null, previewText?: string | null, scheduledAt?: any | null, status?: CampaignMessagestatusEnumType | null, subject: string, textColor: string, audiences?: Array<{ __typename?: 'CampaignMessageAudience', id: string, audience: CampaignMessageAudienceaudienceEnumType, questionId?: string | null, questionAnswerValue?: any | null, registrationTypeId?: string | null } | null> | null } | null };

export type Order_Donation_FieldsFragment = { __typename?: 'Donation', id: string, campaignId: string, teamId?: string | null, fundraiserId?: string | null, donationTypeCode: string, status: DonationstatusEnumType, amount: string, fundraiser?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, need?: { __typename?: 'Need', id: string, name: string } | null };

export type Order_Donations_FragmentFragment = { __typename?: 'Order', id: string, donation?: { __typename?: 'Donation', id: string, campaignId: string, teamId?: string | null, fundraiserId?: string | null, donationTypeCode: string, status: DonationstatusEnumType, amount: string, fundraiser?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, need?: { __typename?: 'Need', id: string, name: string } | null } | null, needDonations?: Array<{ __typename?: 'Donation', id: string, campaignId: string, teamId?: string | null, fundraiserId?: string | null, donationTypeCode: string, status: DonationstatusEnumType, amount: string, fundraiser?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, need?: { __typename?: 'Need', id: string, name: string } | null } | null> | null };

export type Order_LiveAuctionItems_FragmentFragment = { __typename?: 'Order', id: string, wonLiveAuctionItems?: Array<{ __typename?: 'WonLiveAuctionItem', id: string, amount?: string | null, liveAuctionItem?: { __typename?: 'LiveAuctionItem', id: string, name: string } | null } | null> | null };

export type Order_MiscItems_FragmentFragment = { __typename?: 'Order', id: string, miscItems?: Array<{ __typename?: 'OrderMiscItem', id: string, name: string, amount: string } | null> | null };

export type Campaign_Order_FragmentFragment = { __typename?: 'Campaign', id: string, orders?: Array<{ __typename?: 'Order', id: string, email?: string | null, fullName?: string | null, amount: string, status: OrderstatusEnumType, createdAt: any, ticketTotalAmount: string, productTotalAmount: string, donationTotalAmount: string, raffleTotalAmount: string, liveAuctionTotalAmount: string, miscTotalAmount: string, cancelledTicketAmount: string, cancelledRaffleAmount: string, cancelledDonationAmount: string, cancelledProductAmount: string, cancelledTotalAmount: string, discountAmount: string, coveredFees: string, paidAt?: any | null, paymentType?: OrderpaymentTypeEnumType | null, paymentMethodType?: string | null, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null, paymentInfo?: string | null, openTabParticipant?: { __typename?: 'Fundraiser', id: string } | null, donation?: { __typename?: 'Donation', id: string, campaignId: string, teamId?: string | null, fundraiserId?: string | null, donationTypeCode: string, status: DonationstatusEnumType, amount: string, fundraiser?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, need?: { __typename?: 'Need', id: string, name: string } | null } | null, needDonations?: Array<{ __typename?: 'Donation', id: string, campaignId: string, teamId?: string | null, fundraiserId?: string | null, donationTypeCode: string, status: DonationstatusEnumType, amount: string, fundraiser?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, need?: { __typename?: 'Need', id: string, name: string } | null } | null> | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null, soldTicketBundles?: Array<{ __typename?: 'SoldTicketBundle', id: string, amount: string, order?: { __typename?: 'Order', fullName?: string | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, ticketQtyTotal?: number | null, ticketQtyRemaining?: number | null, inviteCode: string, ticketOption?: { __typename?: 'RegistrationType', id: string, name: string, allQuestions: Array<{ __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> } | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null } | null, bundleOption?: { __typename?: 'RegistrationType', id: string, name: string, includedTicketOption?: { __typename?: 'RegistrationType', id: string, name: string } | null } | null } | null> | null, products?: Array<{ __typename?: 'SoldProduct', id: string, amount: string, campaignId: string, status: SoldProductstatusEnumType, selectedVariantId?: string | null, selectedVariant?: { __typename?: 'ProductVariant', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null> | null, raffleOrder?: { __typename?: 'RaffleOrder', id: string, items?: Array<{ __typename?: 'RaffleOrderItem', id: string, entries?: number | null, amount?: number | null, raffle?: { __typename?: 'Raffle', id: string, name: string } | null } | null> | null } | null, wonLiveAuctionItems?: Array<{ __typename?: 'WonLiveAuctionItem', id: string, amount?: string | null, liveAuctionItem?: { __typename?: 'LiveAuctionItem', id: string, name: string } | null } | null> | null, miscItems?: Array<{ __typename?: 'OrderMiscItem', id: string, name: string, amount: string } | null> | null } | null> | null };

export type Ticket_FieldsFragment = { __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null };

export type Order_Sold_Ticket_Bundles_FragmentFragment = { __typename?: 'Order', id: string, soldTicketBundles?: Array<{ __typename?: 'SoldTicketBundle', id: string, amount: string, order?: { __typename?: 'Order', fullName?: string | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, ticketQtyTotal?: number | null, ticketQtyRemaining?: number | null, inviteCode: string, ticketOption?: { __typename?: 'RegistrationType', id: string, name: string, allQuestions: Array<{ __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> } | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null } | null, bundleOption?: { __typename?: 'RegistrationType', id: string, name: string, includedTicketOption?: { __typename?: 'RegistrationType', id: string, name: string } | null } | null } | null> | null };

export type Order_Tickets_FragmentFragment = { __typename?: 'Order', id: string, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null };

export type Order_Products_FragmentFragment = { __typename?: 'Order', id: string, products?: Array<{ __typename?: 'SoldProduct', id: string, amount: string, campaignId: string, status: SoldProductstatusEnumType, selectedVariantId?: string | null, selectedVariant?: { __typename?: 'ProductVariant', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null> | null };

export type Order_Raffles_FragmentFragment = { __typename?: 'Order', id: string, raffleOrder?: { __typename?: 'RaffleOrder', id: string, items?: Array<{ __typename?: 'RaffleOrderItem', id: string, entries?: number | null, amount?: number | null, raffle?: { __typename?: 'Raffle', id: string, name: string } | null } | null> | null } | null };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder?: number | null };

export type GetOrderForSnapshotQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
}>;


export type GetOrderForSnapshotQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, name: string, timezone: string, supportedFeatures: { __typename?: 'CampaignFeatures', event: boolean, join: boolean }, orders?: Array<{ __typename?: 'Order', id: string, email?: string | null, fullName?: string | null, amount: string, status: OrderstatusEnumType, createdAt: any, ticketTotalAmount: string, productTotalAmount: string, donationTotalAmount: string, raffleTotalAmount: string, liveAuctionTotalAmount: string, miscTotalAmount: string, cancelledTicketAmount: string, cancelledRaffleAmount: string, cancelledDonationAmount: string, cancelledProductAmount: string, cancelledTotalAmount: string, discountAmount: string, coveredFees: string, paidAt?: any | null, paymentType?: OrderpaymentTypeEnumType | null, paymentMethodType?: string | null, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null, paymentInfo?: string | null, openTabParticipant?: { __typename?: 'Fundraiser', id: string } | null, donation?: { __typename?: 'Donation', id: string, campaignId: string, teamId?: string | null, fundraiserId?: string | null, donationTypeCode: string, status: DonationstatusEnumType, amount: string, fundraiser?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, need?: { __typename?: 'Need', id: string, name: string } | null } | null, needDonations?: Array<{ __typename?: 'Donation', id: string, campaignId: string, teamId?: string | null, fundraiserId?: string | null, donationTypeCode: string, status: DonationstatusEnumType, amount: string, fundraiser?: { __typename?: 'Fundraiser', id: string, resolvedName?: string | null } | null, team?: { __typename?: 'Team', id: string, name: string } | null, need?: { __typename?: 'Need', id: string, name: string } | null } | null> | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null, soldTicketBundles?: Array<{ __typename?: 'SoldTicketBundle', id: string, amount: string, order?: { __typename?: 'Order', fullName?: string | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, ticketQtyTotal?: number | null, ticketQtyRemaining?: number | null, inviteCode: string, ticketOption?: { __typename?: 'RegistrationType', id: string, name: string, allQuestions: Array<{ __typename?: 'Question', id: string, config: any, helpText?: string | null, isRequired: boolean, label: string, type: QuestiontypeEnumType, options?: Array<{ __typename?: 'QuestionOption', id: string, label: string } | null> | null } | null> } | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string, type: FundraisertypeEnumType, email?: string | null, ticketId?: string | null, ticketGroupId?: string | null, ticketStatus: FundraiserticketStatusEnumType, resolvedName?: string | null, amount: string, totalPledgeValue: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null } | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string } | null } | null } | null> | null } | null, bundleOption?: { __typename?: 'RegistrationType', id: string, name: string, includedTicketOption?: { __typename?: 'RegistrationType', id: string, name: string } | null } | null } | null> | null, products?: Array<{ __typename?: 'SoldProduct', id: string, amount: string, campaignId: string, status: SoldProductstatusEnumType, selectedVariantId?: string | null, selectedVariant?: { __typename?: 'ProductVariant', id: string, name: string } | null, product?: { __typename?: 'Product', id: string, name: string } | null } | null> | null, raffleOrder?: { __typename?: 'RaffleOrder', id: string, items?: Array<{ __typename?: 'RaffleOrderItem', id: string, entries?: number | null, amount?: number | null, raffle?: { __typename?: 'Raffle', id: string, name: string } | null } | null> | null } | null, wonLiveAuctionItems?: Array<{ __typename?: 'WonLiveAuctionItem', id: string, amount?: string | null, liveAuctionItem?: { __typename?: 'LiveAuctionItem', id: string, name: string } | null } | null> | null, miscItems?: Array<{ __typename?: 'OrderMiscItem', id: string, name: string, amount: string } | null> | null } | null> | null } | null> | null };

export type CalculateSponsorAmountMutationVariables = Exact<{
  campaignId: Scalars['String']['input'];
  registrationTypeId: Scalars['String']['input'];
  coverFee: Scalars['Boolean']['input'];
}>;


export type CalculateSponsorAmountMutation = { __typename?: 'Mutation', calculateSponsorAmount: { __typename?: 'SponsorAmount', sponsorAmount: string, coveredFeeAmount: string, totalAmount: string } };

export type ChargeInvoiceSponsorMutationVariables = Exact<{
  sponsorId: Scalars['String']['input'];
  confirmationTokenId: Scalars['String']['input'];
  coverFee: Scalars['Boolean']['input'];
  sendReceipt: Scalars['Boolean']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChargeInvoiceSponsorMutation = { __typename?: 'Mutation', chargeSponsor: { __typename?: 'ChargeSponsorResult', success: boolean, processorData?: any | null, error?: any | null } };

export type FindSponsorInvoiceQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type FindSponsorInvoiceQuery = { __typename?: 'Query', findSponsorInvoice: { __typename?: 'SponsorInvoiceResult', error?: string | null, sponsor?: { __typename?: 'Sponsor', id: string, email: string, firstName: string, lastName: string, phone?: string | null, amount: string, coveredFees: string, registrationType?: { __typename?: 'RegistrationType', id: string, name: string, description?: any | null, sponsorBenefits?: any | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, primaryColor: string, accentColor: string, campaignLogo?: string | null, contactEmail: string, contactPhone?: string | null, canSponsorCoverPlatformFee: boolean, canSponsorCoverProcessorFee: boolean, ownerOrganization?: { __typename?: 'Organization', id: string, name: string, logo?: string | null, paymentProcessorConfig?: any | null } | null } | null } | null } };

export type GetCampaignTimezoneForCheckoutQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetCampaignTimezoneForCheckoutQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, timezone: string } | null> | null };

export type GetCampaignTicketsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  currentDate: Scalars['String']['input'];
}>;


export type GetCampaignTicketsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, name: string, registrationDescription?: any | null, supportedFeatures: { __typename?: 'CampaignFeatures', join: boolean, event: boolean }, activeFeatures: { __typename?: 'CampaignFeatures', shop: boolean, raffle: boolean, sponsorship: boolean }, event?: { __typename?: 'CampaignEvent', id: string, startDate: string, endDate: string } | null, tickets?: Array<{ __typename?: 'RegistrationType', id: string, amount: string, description?: any | null, name: string, qtyUsed: number, qtyTotal?: number | null, sort: number, startDate?: string | null, endDate?: string | null, isCommitmentEnabled: boolean, commitmentAmount?: number | null, commitmentDeadline?: string | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name: string, amount: string, image?: string | null, qtyRemaining?: number | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, qtyRemaining?: number | null } | null> | null } | null> | null, bundles?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, sponsorPackagesWithIncludedTickets?: Array<{ __typename?: 'RegistrationType', id: string } | null> | null, raffles?: Array<{ __typename?: 'Raffle', id: string, description?: any | null, entryPackages: any, qtyTotal?: number | null, qtyUsed: number, qtyRemaining?: number | null, name: string, type: RaffletypeEnumType } | null> | null } | null> | null };

export type GetCampaignTypeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCampaignTypeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string } | null, findCampaigns?: Array<{ __typename?: 'Campaign', id: string, supportedFeatures: { __typename?: 'CampaignFeatures', join: boolean, event: boolean } } | null> | null };

export type GetLatestCampaignsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLatestCampaignsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, name: string, isPerformanceEnabled: boolean, performanceMode?: CampaignperformanceModeEnumType | null, intervalStartDate?: string | null, intervalEndDate?: string | null, type: CampaigntypeEnumType, amountRaised: string, totalOfflineFlatAmount: string, totalMatchAmount: string, supportedFeatures: { __typename?: 'CampaignFeatures', event: boolean }, event?: { __typename?: 'CampaignEvent', startDate: string, endDate: string } | null, ownerOrganization?: { __typename?: 'Organization', id: string, name: string } | null } | null> | null };

export type GetRegisteredParticipantsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRegisteredParticipantsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, eventNumberMode: CampaigneventNumberModeEnumType, ownerOrganization?: { __typename?: 'Organization', paymentProcessorConfig?: any | null } | null, participants?: Array<{ __typename?: 'Fundraiser', id: string, ticketId?: string | null, ticketStatus: FundraiserticketStatusEnumType, avatarImage?: string | null, resolvedName?: string | null, resolvedEmail?: string | null, paymentMethodType?: string | null, eventNumber?: number | null, ticketGroup?: { __typename?: 'TicketGroup', id: string, sponsor?: { __typename?: 'Sponsor', id: string, name: string } | null, soldTicketBundle?: { __typename?: 'SoldTicketBundle', id: string, order?: { __typename?: 'Order', id: string, firstName: string, lastName: string } | null } | null } | null, eventOrder?: { __typename?: 'Order', id: string, status: OrderstatusEnumType, amount: string } | null } | null> | null } | null> | null };

export type GetNeedsQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetNeedsQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, needs?: Array<{ __typename?: 'Need', id: string, amount: string, name: string, totalCommitmentAmount: string, qtyUsed: number } | null> | null } | null> | null };

export type CreateNeedMutationVariables = Exact<{
  data: NeedInput;
}>;


export type CreateNeedMutation = { __typename?: 'Mutation', createNeed?: { __typename?: 'Need', id: string } | null };

export type GetCampaignMessageQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  messageWhere: Scalars['SequelizeJSON']['input'];
}>;


export type GetCampaignMessageQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, supportedFeatures: { __typename?: 'CampaignFeatures', event: boolean }, messages?: Array<{ __typename?: 'CampaignMessage', id: string, subject: string, body: any, headerImage?: string | null, buttonColor: string, textColor: string, bodyColor: string, ccSender: boolean, messageServiceId?: string | null, updatedAt: any, deliveryInfo?: { __typename?: 'MessageDeliveryInfo', openRate?: number | null } | null, audiences?: Array<{ __typename?: 'CampaignMessageAudience', id: string, audience: CampaignMessageAudienceaudienceEnumType, question?: { __typename?: 'Question', label: string } | null, registrationType?: { __typename?: 'RegistrationType', id: string, name: string } | null } | null> | null, createdBy?: { __typename?: 'User', fullName?: string | null } | null } | null> | null } | null> | null };

export type GetCampaignShopStatsForAdminQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;


export type GetCampaignShopStatsForAdminQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, totalShopAmount: string, soldProductsCount: number, products?: Array<{ __typename?: 'Product', id: string } | null> | null, supportedFeatures: { __typename?: 'CampaignFeatures', tickets: boolean } } | null> | null };

export type GetSoldProductDetailsForSnapshotQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
  soldProductId: Scalars['String']['input'];
}>;


export type GetSoldProductDetailsForSnapshotQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, soldProducts?: Array<{ __typename?: 'SoldProduct', id: string, order?: { __typename?: 'Order', id: string, status: OrderstatusEnumType, paidAt?: any | null, paymentType?: OrderpaymentTypeEnumType | null, paymentInfo?: string | null, paymentMethodBrand?: string | null, paymentMethodLast4?: string | null, donation?: { __typename?: 'Donation', id: string } | null, raffleOrder?: { __typename?: 'RaffleOrder', id: string } | null, tickets?: Array<{ __typename?: 'Fundraiser', id: string } | null> | null, soldTicketBundles?: Array<{ __typename?: 'SoldTicketBundle', id: string } | null> | null, miscItems?: Array<{ __typename?: 'OrderMiscItem', id: string } | null> | null } | null } | null> | null } | null> | null };

export type SponsorPackageFieldsFragment = { __typename?: 'RegistrationType', id: string, sort: number, type: RegistrationTypetypeEnumType, name: string, description?: any | null, amount: string, qtyUsed: number, qtyTotal?: number | null, qtyRemaining?: number | null, isEnabled: boolean, sponsorBenefits?: any | null, includedTicketQuantity?: number | null, includedTicketOptionId?: string | null, includedTicketOption?: { __typename?: 'RegistrationType', id: string, qtyRemaining?: number | null } | null };

export type GetSponsorPackagesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSponsorPackagesQuery = { __typename?: 'Query', findCampaigns?: Array<{ __typename?: 'Campaign', id: string, sponsorCount: number, totalSponsorAmount: string, registrationTypes?: Array<{ __typename?: 'RegistrationType', id: string, sort: number, type: RegistrationTypetypeEnumType, name: string, description?: any | null, amount: string, qtyUsed: number, qtyTotal?: number | null, qtyRemaining?: number | null, isEnabled: boolean, sponsorBenefits?: any | null, includedTicketQuantity?: number | null, includedTicketOptionId?: string | null, includedTicketOption?: { __typename?: 'RegistrationType', id: string, qtyRemaining?: number | null } | null } | null> | null } | null> | null };

export type CreatePackageMutationVariables = Exact<{
  data: RegistrationTypeInput;
}>;


export type CreatePackageMutation = { __typename?: 'Mutation', createRegistrationType?: { __typename?: 'RegistrationType', id: string, sort: number, type: RegistrationTypetypeEnumType, name: string, description?: any | null, amount: string, qtyUsed: number, qtyTotal?: number | null, qtyRemaining?: number | null, isEnabled: boolean, sponsorBenefits?: any | null, includedTicketQuantity?: number | null, includedTicketOptionId?: string | null, includedTicketOption?: { __typename?: 'RegistrationType', id: string, qtyRemaining?: number | null } | null } | null };

export type UpdatePackageMutationVariables = Exact<{
  data: RegistrationTypeInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updateRegistrationType: { __typename?: 'RegistrationType', id: string, sort: number, type: RegistrationTypetypeEnumType, name: string, description?: any | null, amount: string, qtyUsed: number, qtyTotal?: number | null, qtyRemaining?: number | null, isEnabled: boolean, sponsorBenefits?: any | null, includedTicketQuantity?: number | null, includedTicketOptionId?: string | null, includedTicketOption?: { __typename?: 'RegistrationType', id: string, qtyRemaining?: number | null } | null } };

export type DeletePackageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePackageMutation = { __typename?: 'Mutation', deleteRegistrationType?: number | null };

export type GetGlobalQuestionsForPreviewQueryVariables = Exact<{
  where: Scalars['SequelizeJSON']['input'];
}>;


export type GetGlobalQuestionsForPreviewQuery = { __typename?: 'Query', findGlobalQuestions?: Array<{ __typename?: 'GlobalQuestion', id: string, type: GlobalQuestiontypeEnumType, label: string, config: any, helpText?: string | null, isEnabled: boolean, isRequired: boolean, assignableAudiences: any, shouldAddToNewCampaigns: boolean, options?: Array<{ __typename?: 'GlobalQuestionOption', id: string, label: string, sort: number } | null> | null } | null> | null };

export type FindSponsorInvoiceSuccessQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type FindSponsorInvoiceSuccessQuery = { __typename?: 'Query', findSponsorInvoice: { __typename?: 'SponsorInvoiceResult', sponsor?: { __typename?: 'Sponsor', id: string, campaign?: { __typename?: 'Campaign', id: string, name: string, slug?: string | null, campaignLogo?: string | null, ownerOrganization?: { __typename?: 'Organization', id: string, name: string, logo?: string | null } | null } | null } | null } };

export const QuestionAdminFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerCount"}},{"kind":"Field","name":{"kind":"Name","value":"assigningRegistrationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"audienceType"}},{"kind":"Field","name":{"kind":"Name","value":"globalQuestionId"}}]}}]} as unknown as DocumentNode<QuestionAdminFieldsFragment, unknown>;
export const CampaignAdmin_ProductFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignAdmin_ProductFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noteLabel"}},{"kind":"Field","name":{"kind":"Name","value":"publicDisplay"}},{"kind":"Field","name":{"kind":"Name","value":"qtyLimitScope"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}}]}}]} as unknown as DocumentNode<CampaignAdmin_ProductFormFragmentFragment, unknown>;
export const Participant_Commitment_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Participant_Commitment_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentDonation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}},{"kind":"Field","name":{"kind":"Name","value":"chargeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commitmentNote"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentStatus"}}]}}]} as unknown as DocumentNode<Participant_Commitment_FragmentFragment, unknown>;
export const Ticket_FieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ticket_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPledgeValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Ticket_FieldsFragment, unknown>;
export const Order_Tickets_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Tickets_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ticket_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPledgeValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Order_Tickets_FragmentFragment, unknown>;
export const Order_Products_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Products_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Order_Products_FragmentFragment, unknown>;
export const Order_Raffles_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Raffles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"raffleOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Order_Raffles_FragmentFragment, unknown>;
export const Participant_Order_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Participant_Order_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Tickets_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Products_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Raffles_Fragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ticket_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPledgeValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Tickets_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Products_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Raffles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"raffleOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Participant_Order_FragmentFragment, unknown>;
export const Participant_Registration_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Participant_Registration_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Participant_Registration_FragmentFragment, unknown>;
export const CampaignCheckout_RaffleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignCheckout_RaffleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Raffle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entryPackages"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<CampaignCheckout_RaffleFragmentFragment, unknown>;
export const AuctionItemFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuctionItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuctionItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numBids"}},{"kind":"Field","name":{"kind":"Name","value":"highBid"}},{"kind":"Field","name":{"kind":"Name","value":"startingBid"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedValue"}},{"kind":"Field","name":{"kind":"Name","value":"myBid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isWinning"}}]}}]}}]} as unknown as DocumentNode<AuctionItemFieldsFragment, unknown>;
export const FundraisingUpdateFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FundraisingUpdateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FundraisingUpdate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"performanceUnits"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"likeCounter"}},{"kind":"Field","name":{"kind":"Name","value":"loveCounter"}},{"kind":"Field","name":{"kind":"Name","value":"clapCounter"}},{"kind":"Field","name":{"kind":"Name","value":"cryCounter"}},{"kind":"Field","name":{"kind":"Name","value":"yayCounter"}},{"kind":"Field","name":{"kind":"Name","value":"hahaCounter"}},{"kind":"Field","name":{"kind":"Name","value":"wowCounter"}},{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"embeddedMedia"}},{"kind":"Field","name":{"kind":"Name","value":"stravaActivity"}}]}}]} as unknown as DocumentNode<FundraisingUpdateFieldsFragment, unknown>;
export const FundraisingUpdateCampaignFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FundraisingUpdateCampaignFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiserDefaultHeaderAvatarImage"}}]}}]} as unknown as DocumentNode<FundraisingUpdateCampaignFieldsFragment, unknown>;
export const FundraisingUpdateFundraiserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FundraisingUpdateFundraiserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"performanceSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metricLabel"}},{"kind":"Field","name":{"kind":"Name","value":"metricLabelPlural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pledgeValue"}}]}}]}}]} as unknown as DocumentNode<FundraisingUpdateFundraiserFieldsFragment, unknown>;
export const FundraisingUpdateReactionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FundraisingUpdateReactions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FundraisingUpdate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myReaction"}},{"kind":"Field","name":{"kind":"Name","value":"likeCounter"}},{"kind":"Field","name":{"kind":"Name","value":"loveCounter"}},{"kind":"Field","name":{"kind":"Name","value":"clapCounter"}},{"kind":"Field","name":{"kind":"Name","value":"cryCounter"}},{"kind":"Field","name":{"kind":"Name","value":"yayCounter"}},{"kind":"Field","name":{"kind":"Name","value":"hahaCounter"}},{"kind":"Field","name":{"kind":"Name","value":"wowCounter"}}]}}]} as unknown as DocumentNode<FundraisingUpdateReactionsFragment, unknown>;
export const GlobalQuestion_EditFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalQuestion_EditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}}]}}]} as unknown as DocumentNode<GlobalQuestion_EditFragmentFragment, unknown>;
export const GlobalQuestionAdminFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalQuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"assignableAudiences"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAddToNewCampaigns"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]} as unknown as DocumentNode<GlobalQuestionAdminFieldsFragment, unknown>;
export const Cart_LayoutCampaignFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_LayoutCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"campaignLogo"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"myPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"isPerformanceEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"performanceStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}},{"kind":"Field","name":{"kind":"Name","value":"myPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"metaPixelId"}}]}}]}}]} as unknown as DocumentNode<Cart_LayoutCampaignFragmentFragment, unknown>;
export const Cart_DonationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_DonationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"donationPresets"}}]}}]} as unknown as DocumentNode<Cart_DonationFragmentFragment, unknown>;
export const Cart_AuctionItemListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_AuctionItemListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveAuction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Cart_AuctionItemListFragmentFragment, unknown>;
export const Cart_NeedListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_NeedListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundANeed"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartNeedOptions"},"name":{"kind":"Name","value":"needs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"reverse:amount","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<Cart_NeedListFragmentFragment, unknown>;
export const Cart_OrderSummaryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_OrderSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverPlatformFee"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverProcessorFee"}}]}}]} as unknown as DocumentNode<Cart_OrderSummaryFragmentFragment, unknown>;
export const Cart_ProductListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_ProductListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartProducts"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"noteLabel"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"qtyLimitScope"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]}}]} as unknown as DocumentNode<Cart_ProductListFragmentFragment, unknown>;
export const Cart_RaffleListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_RaffleListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raffle"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartRaffles"},"name":{"kind":"Name","value":"raffles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entryPackages"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}}]}}]}}]} as unknown as DocumentNode<Cart_RaffleListFragmentFragment, unknown>;
export const CustomQuestion_EditFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomQuestion_EditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<CustomQuestion_EditFragmentFragment, unknown>;
export const Cart_TicketBundleOptionsListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_TicketBundleOptionsListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"cartTicketBundleOptions"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"ticket_bundle","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomQuestion_EditFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectAddress"}},{"kind":"Field","name":{"kind":"Name","value":"collectEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectPhone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomQuestion_EditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<Cart_TicketBundleOptionsListFragmentFragment, unknown>;
export const Cart_TicketOptionListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_TicketOptionListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountCodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickets"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundles"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"ticket_bundle","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sponsorPackagesWithIncludedTickets"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"sponsor","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"includedTicketQuantity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartTicketOptions"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"participant","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomQuestion_EditFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"collectAddress"}},{"kind":"Field","name":{"kind":"Name","value":"collectEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectPhone"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomQuestion_EditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<Cart_TicketOptionListFragmentFragment, unknown>;
export const Cart_PartialOrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_PartialOrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"coverFee"}},{"kind":"Field","name":{"kind":"Name","value":"discountCode"}},{"kind":"Field","name":{"kind":"Name","value":"donation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"noteResponse"}}]}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffleId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"needs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"needId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"miscItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<Cart_PartialOrderFragmentFragment, unknown>;
export const CampaignMessage_DetailsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"questionAnswerValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonColor"}},{"kind":"Field","name":{"kind":"Name","value":"headerImage"}},{"kind":"Field","name":{"kind":"Name","value":"previewText"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}}]}}]} as unknown as DocumentNode<CampaignMessage_DetailsFragmentFragment, unknown>;
export const Order_Donation_FieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Donation_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Donation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiserId"}},{"kind":"Field","name":{"kind":"Name","value":"donationTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"need"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Order_Donation_FieldsFragment, unknown>;
export const Order_Donations_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Donations_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"donation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donation_Fields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"needDonations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donation_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Donation_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Donation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiserId"}},{"kind":"Field","name":{"kind":"Name","value":"donationTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"need"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Order_Donations_FragmentFragment, unknown>;
export const Order_Sold_Ticket_Bundles_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Sold_Ticket_Bundles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketQtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ticketQtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"inviteCode"}},{"kind":"Field","name":{"kind":"Name","value":"ticketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bundleOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ticket_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPledgeValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Order_Sold_Ticket_Bundles_FragmentFragment, unknown>;
export const Order_LiveAuctionItems_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_LiveAuctionItems_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Order_LiveAuctionItems_FragmentFragment, unknown>;
export const Order_MiscItems_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_MiscItems_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"miscItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<Order_MiscItems_FragmentFragment, unknown>;
export const Campaign_Order_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Campaign_Order_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticketTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"productTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"donationTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"raffleTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"miscTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledTicketAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledRaffleAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledDonationAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledProductAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"coveredFees"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"openTabParticipant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donations_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Tickets_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Sold_Ticket_Bundles_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Products_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Raffles_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_LiveAuctionItems_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_MiscItems_Fragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Donation_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Donation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiserId"}},{"kind":"Field","name":{"kind":"Name","value":"donationTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"need"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ticket_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPledgeValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Donations_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"donation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donation_Fields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"needDonations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donation_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Tickets_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Sold_Ticket_Bundles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketQtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ticketQtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"inviteCode"}},{"kind":"Field","name":{"kind":"Name","value":"ticketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bundleOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Products_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Raffles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"raffleOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_LiveAuctionItems_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_MiscItems_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"miscItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<Campaign_Order_FragmentFragment, unknown>;
export const SponsorPackageFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SponsorPackageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorBenefits"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOptionId"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]} as unknown as DocumentNode<SponsorPackageFieldsFragment, unknown>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"User"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}}]}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GetSoldProductForEditModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSoldProductForEditModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSoldProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"noteResponse"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"noteLabel"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSoldProductForEditModalQuery, GetSoldProductForEditModalQueryVariables>;
export const UpdateSoldProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSoldProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SoldProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSoldProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SoldProduct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"noteResponse"}}]}}]}}]} as unknown as DocumentNode<UpdateSoldProductMutation, UpdateSoldProductMutationVariables>;
export const GetSoldProductBuyerDetailsForEditModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSoldProductBuyerDetailsForEditModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSoldProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateProv"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectShopPhone"}},{"kind":"Field","name":{"kind":"Name","value":"collectShopAddress"}}]}}]}}]}}]} as unknown as DocumentNode<GetSoldProductBuyerDetailsForEditModalQuery, GetSoldProductBuyerDetailsForEditModalQueryVariables>;
export const UpdateSoldProductOrderBuyerFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSoldProductOrderBuyerFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateProv"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<UpdateSoldProductOrderBuyerFieldsMutation, UpdateSoldProductOrderBuyerFieldsMutationVariables>;
export const GetSoldProductOrderForSnapshotItemListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSoldProductOrderForSnapshotItemListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSoldProductOrderForSnapshotItemListingQuery, GetSoldProductOrderForSnapshotItemListingQueryVariables>;
export const UpdateSoldProductStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSoldProductStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SoldProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSoldProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SoldProduct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateSoldProductStatusMutation, UpdateSoldProductStatusMutationVariables>;
export const GetMinAllowedBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMinAllowedBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAuctionItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"highBid"}},{"kind":"Field","name":{"kind":"Name","value":"bidIncrement"}},{"kind":"Field","name":{"kind":"Name","value":"auction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"myBidder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMinAllowedBidQuery, GetMinAllowedBidQueryVariables>;
export const UpdateMaxBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMaxBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAuctionItemMaxBid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}]}]}}]} as unknown as DocumentNode<UpdateMaxBidMutation, UpdateMaxBidMutationVariables>;
export const GetParticipantSnapshotAddCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParticipantSnapshotAddCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isCoveringFees"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}}]}}]}}]}}]} as unknown as DocumentNode<GetParticipantSnapshotAddCardQuery, GetParticipantSnapshotAddCardQueryVariables>;
export const UpdateParticipantPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateParticipantPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateParticipantPaymentInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"confirmationTokenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParticipantPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant"}}},{"kind":"Argument","name":{"kind":"Name","value":"confirmationTokenId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"confirmationTokenId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"processorData"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<UpdateParticipantPaymentMutation, UpdateParticipantPaymentMutationVariables>;
export const GetParticipantsForPartialOrderModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParticipantsForPartialOrderModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticketStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"StringValue","value":"cancelled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumber"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}}]}}]}}]}}]} as unknown as DocumentNode<GetParticipantsForPartialOrderModalQuery, GetParticipantsForPartialOrderModalQueryVariables>;
export const GetRegTypesForQuestionModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRegTypesForQuestionModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"participant","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetRegTypesForQuestionModalQuery, GetRegTypesForQuestionModalQueryVariables>;
export const GetCampaignQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SequelizeJSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionAdminFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerCount"}},{"kind":"Field","name":{"kind":"Name","value":"assigningRegistrationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"audienceType"}},{"kind":"Field","name":{"kind":"Name","value":"globalQuestionId"}}]}}]} as unknown as DocumentNode<GetCampaignQuestionsQuery, GetCampaignQuestionsQueryVariables>;
export const GetGlobalQuestionsForCampaignAdminModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGlobalQuestionsForCampaignAdminModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SequelizeJSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findGlobalQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"assignableAudiences"}}]}}]}}]} as unknown as DocumentNode<GetGlobalQuestionsForCampaignAdminModalQuery, GetGlobalQuestionsForCampaignAdminModalQueryVariables>;
export const CreateQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionAdminFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerCount"}},{"kind":"Field","name":{"kind":"Name","value":"assigningRegistrationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"audienceType"}},{"kind":"Field","name":{"kind":"Name","value":"globalQuestionId"}}]}}]} as unknown as DocumentNode<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const UpdateQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionAdminFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerCount"}},{"kind":"Field","name":{"kind":"Name","value":"assigningRegistrationTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"audienceType"}},{"kind":"Field","name":{"kind":"Name","value":"globalQuestionId"}}]}}]} as unknown as DocumentNode<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const DeleteQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const UpdateQuestionOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateQuestionOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuestionOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}]}}]} as unknown as DocumentNode<UpdateQuestionOrderMutation, UpdateQuestionOrderMutationVariables>;
export const AssignGlobalQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignGlobalQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalQuestionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audienceType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"audienceTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignGlobalQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalQuestionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalQuestionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"audienceType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audienceType"}}}]}]}}]} as unknown as DocumentNode<AssignGlobalQuestionsMutation, AssignGlobalQuestionsMutationVariables>;
export const GetCampaignColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignColors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}}]}}]}}]} as unknown as DocumentNode<GetCampaignColorsQuery, GetCampaignColorsQueryVariables>;
export const GetImageGalleryWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImageGalleryWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaignWidgets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"config"}}]}}]}}]} as unknown as DocumentNode<GetImageGalleryWidgetQuery, GetImageGalleryWidgetQueryVariables>;
export const GetCampaignSponsorOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignSponsorOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"reverse:amount","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"sponsor","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignSponsorOptionsQuery, GetCampaignSponsorOptionsQueryVariables>;
export const GetSponsorsWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSponsorsWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaignWidgets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"config"}}]}}]}}]} as unknown as DocumentNode<GetSponsorsWidgetQuery, GetSponsorsWidgetQueryVariables>;
export const GetWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaignWidgets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"campaignPageId"}}]}}]}}]} as unknown as DocumentNode<GetWidgetQuery, GetWidgetQueryVariables>;
export const GetParticipantsForPartialOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParticipantsForPartialOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumberMode"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticketStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"StringValue","value":"cancelled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumber"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}}]}}]}}]}}]} as unknown as DocumentNode<GetParticipantsForPartialOrderQuery, GetParticipantsForPartialOrderQueryVariables>;
export const AddLiveAuctionWinnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddLiveAuctionWinner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liveAuctionItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addLiveAuctionWinner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"liveAuctionItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liveAuctionItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItemId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<AddLiveAuctionWinnerMutation, AddLiveAuctionWinnerMutationVariables>;
export const CreateNewLiveAuctionItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewLiveAuctionItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveAuctionItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLiveAuctionItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"LiveAuctionItem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateNewLiveAuctionItemMutation, CreateNewLiveAuctionItemMutationVariables>;
export const UpdateLiveAuctionItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLiveAuctionItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveAuctionItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLiveAuctionItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"LiveAuctionItem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateLiveAuctionItemMutation, UpdateLiveAuctionItemMutationVariables>;
export const DeleteLiveAuctionItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLiveAuctionItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLiveAuctionItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteLiveAuctionItemMutation, DeleteLiveAuctionItemMutationVariables>;
export const ToggleProductIsEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleProductIsEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]} as unknown as DocumentNode<ToggleProductIsEnabledMutation, ToggleProductIsEnabledMutationVariables>;
export const GetCampaignForNewShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignForNewShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickets"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignForNewShopQuery, GetCampaignForNewShopQueryVariables>;
export const CreateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignAdmin_ProductFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignAdmin_ProductFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noteLabel"}},{"kind":"Field","name":{"kind":"Name","value":"publicDisplay"}},{"kind":"Field","name":{"kind":"Name","value":"qtyLimitScope"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}}]}}]} as unknown as DocumentNode<CreateProductMutation, CreateProductMutationVariables>;
export const GetProductFormEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductFormEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignAdmin_ProductFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignAdmin_ProductFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noteLabel"}},{"kind":"Field","name":{"kind":"Name","value":"publicDisplay"}},{"kind":"Field","name":{"kind":"Name","value":"qtyLimitScope"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}}]}}]} as unknown as DocumentNode<GetProductFormEntitiesQuery, GetProductFormEntitiesQueryVariables>;
export const UpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignAdmin_ProductFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignAdmin_ProductFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noteLabel"}},{"kind":"Field","name":{"kind":"Name","value":"publicDisplay"}},{"kind":"Field","name":{"kind":"Name","value":"qtyLimitScope"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}}]}}]} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;
export const GetProductSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"totalSalesAmount"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<GetProductSummaryQuery, GetProductSummaryQueryVariables>;
export const GetCampaignProductsForAdminListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignProductsForAdminListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"totalSalesAmount"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignProductsForAdminListingQuery, GetCampaignProductsForAdminListingQueryVariables>;
export const ReorderProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}]}}]} as unknown as DocumentNode<ReorderProductsMutation, ReorderProductsMutationVariables>;
export const GetProductNameForDeleteModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductNameForDeleteModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetProductNameForDeleteModalQuery, GetProductNameForDeleteModalQueryVariables>;
export const DeleteProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteProductMutation, DeleteProductMutationVariables>;
export const GetSoldProductOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSoldProductOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSoldProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateProv"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectShopPhone"}},{"kind":"Field","name":{"kind":"Name","value":"collectShopAddress"}}]}}]}}]}}]} as unknown as DocumentNode<GetSoldProductOverviewQuery, GetSoldProductOverviewQueryVariables>;
export const GetCampaignForSponsorPackageEditModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignForSponsorPackageEditModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"participant","block":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCommitmentEnabled"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignForSponsorPackageEditModalQuery, GetCampaignForSponsorPackageEditModalQueryVariables>;
export const GetCampaignOrgInfoForTicketBundleModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignOrgInfoForTicketBundleModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isForProfit"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignOrgInfoForTicketBundleModalQuery, GetCampaignOrgInfoForTicketBundleModalQueryVariables>;
export const GetCampaignOrgInfoForTicketModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignOrgInfoForTicketModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"join"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"activityTracking"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isForProfit"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignOrgInfoForTicketModalQuery, GetCampaignOrgInfoForTicketModalQueryVariables>;
export const MarkCampaignAsCompletedOrActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkCampaignAsCompletedOrActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Campaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}}]}}]} as unknown as DocumentNode<MarkCampaignAsCompletedOrActiveMutation, MarkCampaignAsCompletedOrActiveMutationVariables>;
export const RemoveCampaignFromProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCampaignFromProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Campaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]}}]} as unknown as DocumentNode<RemoveCampaignFromProgramMutation, RemoveCampaignFromProgramMutationVariables>;
export const SoftDeleteCampaignFromProgramPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SoftDeleteCampaignFromProgramPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<SoftDeleteCampaignFromProgramPageMutation, SoftDeleteCampaignFromProgramPageMutationVariables>;
export const UndeleteCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UndeleteCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"undeleteCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UndeleteCampaignMutation, UndeleteCampaignMutationVariables>;
export const RemoveParticipantPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeParticipantPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeParticipantPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}]}]}}]} as unknown as DocumentNode<RemoveParticipantPaymentMutation, RemoveParticipantPaymentMutationVariables>;
export const GetParticipantDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParticipantData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiserDefaultHeaderAvatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumberMode"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"join"}},{"kind":"Field","name":{"kind":"Name","value":"tickets"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"isForBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isCoveringFees"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}},{"kind":"Field","name":{"kind":"Name","value":"amountRaised"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentAmountRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Participant_Registration_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Participant_Commitment_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Participant_Order_Fragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ticket_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPledgeValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Tickets_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Products_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Raffles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"raffleOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Participant_Registration_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Participant_Commitment_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentDonation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}},{"kind":"Field","name":{"kind":"Name","value":"chargeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commitmentNote"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentStatus"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Participant_Order_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Tickets_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Products_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Raffles_Fragment"}}]}}]}}]} as unknown as DocumentNode<GetParticipantDataQuery, GetParticipantDataQueryVariables>;
export const UpdateCommitmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCommitment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fundraiserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCommitmentAmount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fundraiserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fundraiserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}]}]}}]} as unknown as DocumentNode<UpdateCommitmentMutation, UpdateCommitmentMutationVariables>;
export const UpdateCheckInParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCheckInParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FundraiserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParticipant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Fundraiser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumber"}}]}}]}}]} as unknown as DocumentNode<UpdateCheckInParticipantMutation, UpdateCheckInParticipantMutationVariables>;
export const UpdateNeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NeedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Need"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalCommitmentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}}]}}]}}]} as unknown as DocumentNode<UpdateNeedMutation, UpdateNeedMutationVariables>;
export const DeleteNeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteNeedMutation, DeleteNeedMutationVariables>;
export const AddNeedCommitmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddNeedCommitments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"needId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addNeedCommitments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"needId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"needId"}}},{"kind":"Argument","name":{"kind":"Name","value":"participantIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"failed"}}]}}]}}]} as unknown as DocumentNode<AddNeedCommitmentsMutation, AddNeedCommitmentsMutationVariables>;
export const GetNeedDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNeedData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"needId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumberMode"}},{"kind":"Field","name":{"kind":"Name","value":"needs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"needId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}}]}}]}}]}}]} as unknown as DocumentNode<GetNeedDataQuery, GetNeedDataQueryVariables>;
export const CreateManyEventTablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateManyEventTables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"totalSeats"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfTables"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyEventTables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"totalSeats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"totalSeats"}}},{"kind":"Argument","name":{"kind":"Name","value":"numberOfTables"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfTables"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableNumber"}}]}}]}}]} as unknown as DocumentNode<CreateManyEventTablesMutation, CreateManyEventTablesMutationVariables>;
export const CreateSingleEventTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSingleEventTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventTableInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEventTable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"EventTable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableNumber"}}]}}]}}]} as unknown as DocumentNode<CreateSingleEventTableMutation, CreateSingleEventTableMutationVariables>;
export const GetTicketTypesForSeatingAssignmentFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTicketTypesForSeatingAssignmentFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"participant","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTicketTypesForSeatingAssignmentFilterQuery, GetTicketTypesForSeatingAssignmentFilterQueryVariables>;
export const UpdateEventTableSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventTableSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventTableInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventTable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"EventTable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}}]}}]}}]} as unknown as DocumentNode<UpdateEventTableSettingsMutation, UpdateEventTableSettingsMutationVariables>;
export const DeleteEventTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEventTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEventTable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteEventTableMutation, DeleteEventTableMutationVariables>;
export const SeatGuestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SeatGuests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seatGuests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ticketGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"numSeats"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"eventTableId"}},{"kind":"Field","name":{"kind":"Name","value":"seatsReserved"}}]}}]}}]} as unknown as DocumentNode<SeatGuestsMutation, SeatGuestsMutationVariables>;
export const SeatParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SeatParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FundraiserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFundraiser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Fundraiser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventTableId"}}]}}]}}]} as unknown as DocumentNode<SeatParticipantMutation, SeatParticipantMutationVariables>;
export const GetSeatingDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeatingData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventSeating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSeated"}},{"kind":"Field","name":{"kind":"Name","value":"eventTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TicketGroupGuest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventTables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"tableNumber","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableNumber"}},{"kind":"Field","name":{"kind":"Name","value":"totalSeats"}},{"kind":"Field","name":{"kind":"Name","value":"seatsUsed"}}]}}]}}]}}]} as unknown as DocumentNode<GetSeatingDataQuery, GetSeatingDataQueryVariables>;
export const UnseatGuestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnseatGuests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventTableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unseatGuests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ticketGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventTableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventTableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"numSeats"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"eventTableId"}},{"kind":"Field","name":{"kind":"Name","value":"seatsReserved"}}]}}]}}]} as unknown as DocumentNode<UnseatGuestsMutation, UnseatGuestsMutationVariables>;
export const GetOrderSummaryOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderSummaryOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverPlatformFee"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverProcessorFee"}},{"kind":"Field","name":{"kind":"Name","value":"discountCodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderSummaryOptionsQuery, GetOrderSummaryOptionsQueryVariables>;
export const GetTeamNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTeamNameQuery, GetTeamNameQueryVariables>;
export const GetCampaignFundraisingTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignFundraisingType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundraisingType"}}]}}]}}]} as unknown as DocumentNode<GetCampaignFundraisingTypeQuery, GetCampaignFundraisingTypeQueryVariables>;
export const GetEventDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateProv"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]}}]} as unknown as DocumentNode<GetEventDetailsQuery, GetEventDetailsQueryVariables>;
export const GetShopWidgetDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShopWidgetDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isExisting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isExisting"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetShopWidgetDetailsQuery, GetShopWidgetDetailsQueryVariables>;
export const GetResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiserDefaultHeaderAvatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"teamDefaultHeaderAvatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"searchTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"7"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"searchFundraisers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"7"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}}]}}]}}]}}]} as unknown as DocumentNode<GetResultsQuery, GetResultsQueryVariables>;
export const CampaignFundraisingUpdateSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CampaignFundraisingUpdateSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignFundraisingUpdateSettingsQuery, CampaignFundraisingUpdateSettingsQueryVariables>;
export const UpdateCampaignWidgetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCampaignWidgets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignWidgetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaignWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CampaignWidget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<UpdateCampaignWidgetsMutation, UpdateCampaignWidgetsMutationVariables>;
export const UpdateFundraisingUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFundraisingUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FundraisingUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFundraisingUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"FundraisingUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}}]}}]}}]} as unknown as DocumentNode<UpdateFundraisingUpdateMutation, UpdateFundraisingUpdateMutationVariables>;
export const CreateOrUpdateReactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrUpdateReaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reaction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReactionreactionTypeEnumType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setReaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subjectType"},"value":{"kind":"EnumValue","value":"FundraisingUpdate"}},{"kind":"Argument","name":{"kind":"Name","value":"subjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"reactionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reaction"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<CreateOrUpdateReactionMutation, CreateOrUpdateReactionMutationVariables>;
export const DeleteProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteProgramMutation, DeleteProgramMutationVariables>;
export const UndeleteProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UndeleteProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"undeleteProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<UndeleteProgramMutation, UndeleteProgramMutationVariables>;
export const ValidateCampaignDiscountCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateCampaignDiscountCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discountCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateDiscountCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"discountCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discountCode"}}}]}]}}]} as unknown as DocumentNode<ValidateCampaignDiscountCodeMutation, ValidateCampaignDiscountCodeMutationVariables>;
export const GetCampaignTicketPurchaseLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignTicketPurchaseLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"campaignLogo"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}},{"kind":"Field","name":{"kind":"Name","value":"metaPixelId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverPlatformFee"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverProcessorFee"}}]}}]}}]} as unknown as DocumentNode<GetCampaignTicketPurchaseLayoutQuery, GetCampaignTicketPurchaseLayoutQueryVariables>;
export const GetCampaignSponsorPurchaseLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignSponsorPurchaseLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"campaignLogo"}},{"kind":"Field","name":{"kind":"Name","value":"canSponsorCoverPlatformFee"}},{"kind":"Field","name":{"kind":"Name","value":"canSponsorCoverProcessorFee"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"metaPixelId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignSponsorPurchaseLayoutQuery, GetCampaignSponsorPurchaseLayoutQueryVariables>;
export const GetGlobalQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGlobalQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SequelizeJSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findGlobalQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"reverse:createdAt","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalQuestionAdminFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalQuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"assignableAudiences"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAddToNewCampaigns"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]} as unknown as DocumentNode<GetGlobalQuestionsQuery, GetGlobalQuestionsQueryVariables>;
export const CreateGlobalQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGlobalQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGlobalQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GlobalQuestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalQuestionAdminFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalQuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"assignableAudiences"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAddToNewCampaigns"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]} as unknown as DocumentNode<CreateGlobalQuestionMutation, CreateGlobalQuestionMutationVariables>;
export const UpdateGlobalQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGlobalQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGlobalQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GlobalQuestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalQuestionAdminFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalQuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"assignableAudiences"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAddToNewCampaigns"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]} as unknown as DocumentNode<UpdateGlobalQuestionMutation, UpdateGlobalQuestionMutationVariables>;
export const DeleteGlobalQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteGlobalQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteGlobalQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteGlobalQuestionMutation, DeleteGlobalQuestionMutationVariables>;
export const CalculateRaffleOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CalculateRaffleOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"raffleOrder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculateRaffleOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateRaffleOrderAmount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raffleOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raffleOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coveredFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"raffleAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]} as unknown as DocumentNode<CalculateRaffleOrderMutation, CalculateRaffleOrderMutationVariables>;
export const CreateRaffleOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRaffleOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRaffleOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRaffleOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raffleOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"processorData"}},{"kind":"Field","name":{"kind":"Name","value":"raffleOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateRaffleOrderMutation, CreateRaffleOrderMutationVariables>;
export const GetRaffleCheckoutEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRaffleCheckoutEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raffle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignLogo"}},{"kind":"Field","name":{"kind":"Name","value":"canRaffleCoverPlatformFee"}},{"kind":"Field","name":{"kind":"Name","value":"canRaffleCoverProcessorFee"}},{"kind":"Field","name":{"kind":"Name","value":"collectRaffleAddress"}},{"kind":"Field","name":{"kind":"Name","value":"collectRafflePhone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"metaPixelId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"raffles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"open","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignCheckout_RaffleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignCheckout_RaffleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Raffle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entryPackages"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GetRaffleCheckoutEntitiesQuery, GetRaffleCheckoutEntitiesQueryVariables>;
export const ValidateTicketGroupInviteCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateTicketGroupInviteCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateTicketGroupInviteCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inviteCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"isCommitmentEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentDeadline"}}]}}]}}]} as unknown as DocumentNode<ValidateTicketGroupInviteCodeQuery, ValidateTicketGroupInviteCodeQueryVariables>;
export const SlugRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SlugRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SlugScopeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"scope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scope"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}}]}}]}}]} as unknown as DocumentNode<SlugRouteQuery, SlugRouteQueryVariables>;
export const IsFundraiserAlreadyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IsFundraiserAlready"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SequelizeJSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFundraisers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IsFundraiserAlreadyQuery, IsFundraiserAlreadyQueryVariables>;
export const CalculateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalculateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateOrderAmount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"discountedSubtotal"}},{"kind":"Field","name":{"kind":"Name","value":"fees"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"originalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountText"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"originalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountText"}},{"kind":"Field","name":{"kind":"Name","value":"bundleOptionId"}}]}}]}}]}}]} as unknown as DocumentNode<CalculateOrderQuery, CalculateOrderQueryVariables>;
export const GetCampaignTimezoneForCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignTimezoneForCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<GetCampaignTimezoneForCartQuery, GetCampaignTimezoneForCartQueryVariables>;
export const GetCartEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCartEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_LayoutCampaignFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_OrderSummaryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_ProductListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_TicketOptionListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_TicketBundleOptionsListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_RaffleListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_AuctionItemListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_NeedListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_DonationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomQuestion_EditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_LayoutCampaignFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"campaignLogo"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"myPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"isPerformanceEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"performanceStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}},{"kind":"Field","name":{"kind":"Name","value":"myPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"metaPixelId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_OrderSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverPlatformFee"}},{"kind":"Field","name":{"kind":"Name","value":"canParticipantCoverProcessorFee"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_ProductListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartProducts"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isNoteRequired"}},{"kind":"Field","name":{"kind":"Name","value":"noteLabel"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"qtyLimitScope"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_TicketOptionListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discountCodeCount"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickets"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundles"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"ticket_bundle","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sponsorPackagesWithIncludedTickets"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"sponsor","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"includedTicketQuantity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartTicketOptions"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"participant","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomQuestion_EditFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"collectAddress"}},{"kind":"Field","name":{"kind":"Name","value":"collectEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectPhone"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_TicketBundleOptionsListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"cartTicketBundleOptions"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"ticket_bundle","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomQuestion_EditFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectAddress"}},{"kind":"Field","name":{"kind":"Name","value":"collectEmail"}},{"kind":"Field","name":{"kind":"Name","value":"collectPhone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_RaffleListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raffle"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartRaffles"},"name":{"kind":"Name","value":"raffles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entryPackages"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_AuctionItemListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveAuction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_NeedListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fundANeed"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartNeedOptions"},"name":{"kind":"Name","value":"needs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"reverse:amount","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_DonationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"donationPresets"}}]}}]} as unknown as DocumentNode<GetCartEntitiesQuery, GetCartEntitiesQueryVariables>;
export const GetPartialOrderBuyerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPartialOrderBuyer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SequelizeJSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCoveringFees"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"eventOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_PartialOrderFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_PartialOrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"coverFee"}},{"kind":"Field","name":{"kind":"Name","value":"discountCode"}},{"kind":"Field","name":{"kind":"Name","value":"donation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"noteResponse"}}]}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffleId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"needs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"needId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"miscItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<GetPartialOrderBuyerQuery, GetPartialOrderBuyerQueryVariables>;
export const CreateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"givingVoucher"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"givingVoucher"},"value":{"kind":"Variable","name":{"kind":"Name","value":"givingVoucher"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"processorData"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const CompleteOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"processorData"}}]}}]}}]} as unknown as DocumentNode<CompleteOrderMutation, CompleteOrderMutationVariables>;
export const UpdateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cart_PartialOrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cart_PartialOrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"coverFee"}},{"kind":"Field","name":{"kind":"Name","value":"discountCode"}},{"kind":"Field","name":{"kind":"Name","value":"donation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"noteResponse"}}]}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffleId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"needs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"needId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"miscItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const RegisterUnclaimedParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterUnclaimedParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"processorData"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<RegisterUnclaimedParticipantMutation, RegisterUnclaimedParticipantMutationVariables>;
export const CreateCampaignMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCampaignMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaignMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CampaignMessage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"questionAnswerValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonColor"}},{"kind":"Field","name":{"kind":"Name","value":"headerImage"}},{"kind":"Field","name":{"kind":"Name","value":"previewText"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}}]}}]} as unknown as DocumentNode<CreateCampaignMessageMutation, CreateCampaignMessageMutationVariables>;
export const DeleteCampaignMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCampaignMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCampaignMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteCampaignMessageMutation, DeleteCampaignMessageMutationVariables>;
export const FetchCampaignMessageByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCampaignMessageById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaignMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"questionAnswerValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonColor"}},{"kind":"Field","name":{"kind":"Name","value":"headerImage"}},{"kind":"Field","name":{"kind":"Name","value":"previewText"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}}]}}]} as unknown as DocumentNode<FetchCampaignMessageByIdQuery, FetchCampaignMessageByIdQueryVariables>;
export const GetCampaignMessageContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignMessageContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"isSponsorshipEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityTracking"}},{"kind":"Field","name":{"kind":"Name","value":"auction"}},{"kind":"Field","name":{"kind":"Name","value":"teams"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participantQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"choice","block":false},{"kind":"StringValue","value":"yes_no","block":false},{"kind":"StringValue","value":"waiver_simple","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousCampaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"join"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"participant","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"join"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignMessageContextQuery, GetCampaignMessageContextQueryVariables>;
export const GetMessagePreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMessagePreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messagePreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"campaignMessage","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"StringValue","value":"en","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<GetMessagePreviewQuery, GetMessagePreviewQueryVariables>;
export const SendCampaignMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendCampaignMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendCampaignMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"questionAnswerValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonColor"}},{"kind":"Field","name":{"kind":"Name","value":"headerImage"}},{"kind":"Field","name":{"kind":"Name","value":"previewText"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}}]}}]} as unknown as DocumentNode<SendCampaignMessageMutation, SendCampaignMessageMutationVariables>;
export const SendCampaignMessageTestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendCampaignMessageTest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessageTestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendCampaignMessageTest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<SendCampaignMessageTestMutation, SendCampaignMessageTestMutationVariables>;
export const UpdateCampaignMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCampaignMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaignMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CampaignMessage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignMessage_DetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"questionAnswerValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonColor"}},{"kind":"Field","name":{"kind":"Name","value":"headerImage"}},{"kind":"Field","name":{"kind":"Name","value":"previewText"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}}]}}]} as unknown as DocumentNode<UpdateCampaignMessageMutation, UpdateCampaignMessageMutationVariables>;
export const DeleteOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const GetOrderForSnapshotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderForSnapshot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"join"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Campaign_Order_Fragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Donation_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Donation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiserId"}},{"kind":"Field","name":{"kind":"Name","value":"donationTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"fundraiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"need"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Donations_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"donation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donation_Fields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"needDonations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donation_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ticket_Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fundraiser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPledgeValue"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Tickets_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Sold_Ticket_Bundles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketQtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ticketQtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"inviteCode"}},{"kind":"Field","name":{"kind":"Name","value":"ticketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ticket_Fields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bundleOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Products_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"selectedVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_Raffles_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"raffleOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"raffle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_LiveAuctionItems_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wonLiveAuctionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Order_MiscItems_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"miscItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Campaign_Order_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Campaign"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticketTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"productTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"donationTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"raffleTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"liveAuctionTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"miscTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledTicketAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledRaffleAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledDonationAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledProductAmount"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledTotalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"coveredFees"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"openTabParticipant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Donations_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Tickets_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Sold_Ticket_Bundles_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Products_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_Raffles_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_LiveAuctionItems_Fragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Order_MiscItems_Fragment"}}]}}]}}]} as unknown as DocumentNode<GetOrderForSnapshotQuery, GetOrderForSnapshotQueryVariables>;
export const CalculateSponsorAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"calculateSponsorAmount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverFee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateSponsorAmount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"campaignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"registrationTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverFee"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsorAmount"}},{"kind":"Field","name":{"kind":"Name","value":"coveredFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]} as unknown as DocumentNode<CalculateSponsorAmountMutation, CalculateSponsorAmountMutationVariables>;
export const ChargeInvoiceSponsorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"chargeInvoiceSponsor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sponsorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"confirmationTokenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverFee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendReceipt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeSponsor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sponsorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sponsorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"confirmationTokenId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"confirmationTokenId"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverFee"}}},{"kind":"Argument","name":{"kind":"Name","value":"sendReceipt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendReceipt"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"processorData"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ChargeInvoiceSponsorMutation, ChargeInvoiceSponsorMutationVariables>;
export const FindSponsorInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findSponsorInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSponsorInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"coveredFees"}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorBenefits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"accentColor"}},{"kind":"Field","name":{"kind":"Name","value":"campaignLogo"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"canSponsorCoverPlatformFee"}},{"kind":"Field","name":{"kind":"Name","value":"canSponsorCoverProcessorFee"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindSponsorInvoiceQuery, FindSponsorInvoiceQueryVariables>;
export const GetCampaignTimezoneForCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignTimezoneForCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<GetCampaignTimezoneForCheckoutQuery, GetCampaignTimezoneForCheckoutQueryVariables>;
export const GetCampaignTicketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignTickets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"join"}},{"kind":"Field","name":{"kind":"Name","value":"event"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"}},{"kind":"Field","name":{"kind":"Name","value":"raffle"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tickets"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"participant","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isCommitmentEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"commitmentDeadline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"publicDisplay"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"StringValue","value":"shop","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bundles"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"ticket_bundle","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"NullValue"}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sponsorPackagesWithIncludedTickets"},"name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"sponsor","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"includedTicketQuantity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"raffles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"open","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignCheckout_RaffleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignCheckout_RaffleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Raffle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entryPackages"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GetCampaignTicketsQuery, GetCampaignTicketsQueryVariables>;
export const GetCampaignTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"join"}},{"kind":"Field","name":{"kind":"Name","value":"event"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignTypeQuery, GetCampaignTypeQueryVariables>;
export const GetLatestCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestCampaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"reverse:createdAt","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPerformanceEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"performanceMode"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"intervalEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountRaised"}},{"kind":"Field","name":{"kind":"Name","value":"totalOfflineFlatAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalMatchAmount"}}]}}]}}]} as unknown as DocumentNode<GetLatestCampaignsQuery, GetLatestCampaignsQueryVariables>;
export const GetRegisteredParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRegisteredParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventNumberMode"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentProcessorConfig"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ne"},"value":{"kind":"StringValue","value":"cancelled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketStatus"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedName"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"ticketGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventNumber"}},{"kind":"Field","name":{"kind":"Name","value":"eventOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRegisteredParticipantsQuery, GetRegisteredParticipantsQueryVariables>;
export const GetNeedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNeeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"needs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"createdAt","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalCommitmentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}}]}}]}}]}}]} as unknown as DocumentNode<GetNeedsQuery, GetNeedsQueryVariables>;
export const CreateNeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NeedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNeed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Need"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateNeedMutation, CreateNeedMutationVariables>;
export const GetCampaignMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SequelizeJSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"headerImage"}},{"kind":"Field","name":{"kind":"Name","value":"buttonColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"ccSender"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"audiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"messageServiceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignMessageQuery, GetCampaignMessageQueryVariables>;
export const GetCampaignShopStatsForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignShopStatsForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalShopAmount"}},{"kind":"Field","name":{"kind":"Name","value":"soldProductsCount"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickets"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignShopStatsForAdminQuery, GetCampaignShopStatsForAdminQueryVariables>;
export const GetSoldProductDetailsForSnapshotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSoldProductDetailsForSnapshot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"soldProductId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"soldProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"soldProductId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodBrand"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodLast4"}},{"kind":"Field","name":{"kind":"Name","value":"donation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"raffleOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"soldTicketBundles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"miscItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSoldProductDetailsForSnapshotQuery, GetSoldProductDetailsForSnapshotQueryVariables>;
export const GetSponsorPackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSponsorPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalSponsorAmount"}},{"kind":"Field","name":{"kind":"Name","value":"registrationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"reverse:amount","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"sponsor","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SponsorPackageFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SponsorPackageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorBenefits"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOptionId"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]} as unknown as DocumentNode<GetSponsorPackagesQuery, GetSponsorPackagesQueryVariables>;
export const CreatePackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRegistrationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"RegistrationType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SponsorPackageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SponsorPackageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorBenefits"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOptionId"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]} as unknown as DocumentNode<CreatePackageMutation, CreatePackageMutationVariables>;
export const UpdatePackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRegistrationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"RegistrationType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SponsorPackageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SponsorPackageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"qtyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"qtyTotal"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorBenefits"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOptionId"}},{"kind":"Field","name":{"kind":"Name","value":"includedTicketOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qtyRemaining"}}]}}]}}]} as unknown as DocumentNode<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const DeletePackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRegistrationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeletePackageMutation, DeletePackageMutationVariables>;
export const GetGlobalQuestionsForPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGlobalQuestionsForPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SequelizeJSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findGlobalQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GlobalQuestionAdminFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GlobalQuestionAdminFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"assignableAudiences"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAddToNewCampaigns"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"sort","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEnabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}}]} as unknown as DocumentNode<GetGlobalQuestionsForPreviewQuery, GetGlobalQuestionsForPreviewQueryVariables>;
export const FindSponsorInvoiceSuccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findSponsorInvoiceSuccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findSponsorInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"campaignLogo"}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindSponsorInvoiceSuccessQuery, FindSponsorInvoiceSuccessQueryVariables>;